// import { firebase } from 'firebase/compat/app'
// import '@firebase/database'
// import '@firebase/storage'
// import 'firebase/auth'
// import 'firebase/functions'

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import "firebase/compat/database";
import "firebase/compat/storage";
import 'firebase/compat/functions'
// AIzaSyDh03vvNLOXv2KLrqyqNoYXFN8Ia8V5ZOI
import { getFunctions } from "firebase/functions";

import { formatInTimeZone, format } from 'date-fns-tz'
import moment from 'moment'
import router from '../router'
var numeral = require("numeral");

export default {
  pushError({ commit }, payload) {
    commit('setError', { message: payload })
  },

  clearError({ commit }) {
    commit('clearError')
  },
  loadUserProfiles({ commit }) {
    const userprofiles = []
    firebase.database().ref('users').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          userprofiles.push({
            bio: obj[key].bio,
            userkey: key,
            alerts: obj[key].alerts,
            email: obj[key].email,
            level: obj[key].level,
            status: obj[key].status,
            username: obj[key].username,
            group: obj[key].group,
            institution: obj[key].institution
          })
        }
        commit('setLoadedUserProfiles', userprofiles)
      })
      .catch(
        (error) => {
          console.log(error)
        }
      )
  },
  autoSignIn({ commit }, payload) {
    let key = payload.uid
    // firebase.database().ref('users').child(key)
    /*
    firebase.database().ref('/users/' + key).once('value').then(function (snapshot) {
      console.log('snap is ', snapshot.val())
    })
    */
    let userprofile = ''
    firebase.database().ref('users').child(key).once('value')
      .then(
        data => {
          const obj = data.val()
          const newUser = {
            id: payload.uid,
            email: obj.email,
            group: obj.group,
            bio: obj.bio,
            level: obj.level,
            status: obj.status,
            institution: obj.institution
          }
          userprofile = newUser
          commit('setUser', newUser)
        }
      ).then(() => {
        console.log('#######  WE HAVE OUR USER', userprofile)
        this.$router.push("/")
      })
      .catch(
        error => {
          commit('setError', error)
          console.log(error)
        }
      )
  },
  signUserUp({ commit }, payload) {
    // commit('clearError')
    commit('setLoading', true)
    firebase
      .auth()
      .createUserWithEmailAndPassword(payload.email, payload.password)
      .then((user) => {
        const idkey = firebase.auth().currentUser.uid
        const myuser = {
          email: payload.email,
          phonenumber: payload.phonenumber,
          group: 'UNSET',
          alerts: false,
          level: 0,
          status: 'NONE',
          bio: 'nothing',
          institution: '',
        }
        firebase
          .database()
          .ref('/users/' + idkey)
          .update(myuser)
          .then((data) => {
            commit('setUser', myuser)
            const actionrecord = {
              user: firebase.auth().currentUser.uid,
              actions: 'create user',
              description: 'new user signup',
              timestamp: Date.now(),
              meta: 'user registered',
            }
            const date = moment().format('YYYY-MM-DD')
            firebase.database().ref('AUDITLOG').child(date).push(actionrecord)
            router.push('/app/sessions/noaccess')
          })
          .catch((error) => {
            console.error(error)
            commit('setLoading', false)
          })
      })
      .catch((error) => {
        commit('setloginError', error.message)
        commit('setError', error)
      })
  },
  handlePwReset({ commit }, payload) {
    let actionCode = payload.actionCode
    let pw = payload.password

    // Verify the password reset code is valid.
    firebase.auth().verifyPasswordResetCode(actionCode).then((email) => {
      let accountEmail = email;

      // TODO: Show the reset screen with the user's email and ask the user for
      // the new password.
      let newPassword = pw;

      // Save the new password.
      firebase.auth().confirmPasswordReset(actionCode, newPassword).then((resp) => {
        // Password reset has been confirmed and new password updated.
        console.log("pw reset", resp)
        console.log("pw reset", actionCode, newPassword)
        let msg = "New Password is set, please sign in"
        commit('setError', msg)
        // TODO: Display a link back to the app, or sign-in the user directly
        // if the page belongs to the same domain as the app:
        // auth.signInWithEmailAndPassword(accountEmail, newPassword);

        // TODO: If a continue URL is available, display a button which on
        // click redirects the user back to the app via continueUrl with
        // additional state determined from that URL's parameters.
      }).catch((error) => {
        console.log('pw reset err ', error)
        let msg = error.toString()
        if (msg.includes("Firebase:")) {
          msg = "There is an error resetting the password, using an old link or a link which has been used before"
        }
        commit('setError', msg)
        // Error occurred during confirmation. The code might have expired or the
        // password is too weak.
      });
    }).catch((error) => {
      console.log("overall reset error ", error)
      let msg = error.toString()
      commit('setError', msg)
      // Invalid or expired action code. Ask user to try to reset the password
      // again.
    });
  },
  sendRecoveryEmail({ commit }, payload) {
    console.log('sending recovery', payload)
    var emailAddress = payload.email
    firebase.auth().sendPasswordResetEmail(emailAddress).then(function () {
      // console.log('Email was sent to the user address!!', payload.email)
      // Email sent.
      let msg = "Recovery Email has been sent"
      commit('setError', msg)

    })
      .catch(
        error => {
          console.log('err ', error)
          let msg = error.toString()
          if (msg.includes("There is no user record corresponding")) {
            msg = "There is no user record found with this email"
          }
          commit('setError', msg)
          console.log(msg)
        }
      )
  },
  updateUserProfile({ commit, getters }, payload) {
    firebase
      .database()
      .ref('users')
      .child(payload.userkey)
      .update(payload)
      .then(() => {
        // audit log
        const actionrecord = {
          user: firebase.auth().currentUser.uid,
          actions: 'update',
          description: 'updated user profile',
          timestamp: Date.now(),
          meta: '',
        }
        const date = moment().format('YYYY-MM-DD')
        firebase.database().ref('AUDITLOG').child(date).push(actionrecord)
      })
      .catch((error) => {
        console.error(error)
      })
    // Reach out to firebase and store it
  },

  removeUserProfile({ commit, state, dispatch }, payload) {
    const key = payload.userkey
    commit('setLoading', true)
    firebase
      .database()
      .ref('users')
      .child(key)
      .remove()
      .then(() => {
        const actionrecord = {
          user: firebase.auth().currentUser.uid,
          actions: 'delete',
          description: 'removed user profile',
          timestamp: Date.now(),
          meta: key,
        }
        const date = moment().format('YYYY-MM-DD')
        firebase
          .database()
          .ref('AUDITLOG')
          .child(date)
          .push(actionrecord)
          .catch((error) => {
            console.error(error)
            commit('setLoading', false)
          })
      })
      .catch((error) => {
        console.error(error)
        commit('setLoading', false)
      })
    commit('setLoading', false)
    // Reach out to firebase and store it
  },

  loadUserGroups({ commit }) {
    console.log('loading groups')
    const usergroups = []
    firebase.database().ref('GROUPS').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          usergroups.push({
            name: obj[key].name,
            groupkey: key
          })
        }
        console.log('setting groups')

        commit('setUserGroups', usergroups)
      })
      .catch(
        (error) => {
          console.log(error)
        }
      )
  },
  async loadUserInstitutions({ commit }) {
    const userinstitutions = []
    firebase.database().ref('Institutions').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          userinstitutions.push({
            name: obj[key].name,
            sitekeys: obj[key].sitekeys,
            key: key
          })
        }
        console.log('USER INSTITUTIONS', userinstitutions)
        commit('setUserInstitutions', userinstitutions)
      })
      .catch(
        (error) => {
          console.log(error)
        }
      )
  },
  updateInstitutions({ commit }, payload) {
    console.log('we updated insta ', payload)

    const insta = {
      name: payload.name,
      sitekeys: payload.sitekeys
    }
    firebase.database().ref('Institutions').child(payload.key).update(insta)
      .then(() => {
        console.log('we updated insta ', payload)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  createUserInstitutions({ commit, getters }, payload) {
    const instaData = {
      name: payload,
      sitekeys: []
    }
    let key
    firebase.database().ref('Institutions').push(instaData)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
    // Reach out to firebase and store it
  },
  loadUserProfiles({ commit }) {
    const userprofiles = []
    firebase
      .database()
      .ref('users')
      .once('value')
      .then((data) => {
        const obj = data.val()
        for (const key in obj) {
          userprofiles.push({
            userkey: key,
            alerts: obj[key].alerts | '',
            timestamp: obj[key].timestamp,
            transactions: obj[key].transactions,
            email: obj[key].email,
            phonenumber: obj[key].phonenumber,
            firstname: obj[key].firstname || '',
            lastname: obj[key].lastname || '',
            dateofbirth: obj[key].dateofbirth || '',
            //mrmr load inst jul 27
            institution: obj[key].institution || '',
            address: obj[key].address || '',
            city: obj[key].city || '',
            country: obj[key].country || '',
            level: obj[key].level || '',
            kycstatus: obj[key].kycstatus | '',
            active: obj[key].active || '',
            status: obj[key].status || '',
            username: obj[key].username,
            group: obj[key].group,
            lastlogin: obj[key].lastlogin,
          })
        }
        commit('setLoadedUserProfiles', userprofiles)
      })
      .catch((error) => {
        console.error(error)
      })
  },
  loadsystemdata({ commit }) {
    let systemdata = []
    commit('setLoading', true)

    firebase.database().ref('system').child('performance').limitToLast(24).once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          systemdata.push({
            mqtt_disco: obj[key].mqtt_disco,
            mqtt_recon: obj[key].mqtt_recon,
            msg_count_cashheld: obj[key].msg_count_cashheld,
            msg_count_cit: obj[key].msg_count_cit,
            msg_count_deposit: obj[key].msg_count_deposit,
            msg_count_manualdeposit: obj[key].msg_count_manualdeposit,
            msg_count_notein: obj[key].msg_count_notein,
            msg_count_ping: obj[key].msg_count_ping,
            msg_count_rejected: obj[key].msg_count_rejected,
            timestamp: obj[key].timestamp,
            totalmessages: obj[key].totalmessages
          })
        }
        commit('setSystemData', systemdata)
        commit('setLoading', false)
      })
      .catch(
        (error) => {
          commit('setLoading', false)
          console.log(error)
        }
      )
  },
  initrealtimeheartbeats({ commit }) {
    console.log('starting real time heartbeats ')
    firebase.database().ref('hardware').child('heartbeat').on('value', function (snapshot) {
      let heartbeatestate = snapshot.val()
      let heartbeatrecs = []
      for (let key in heartbeatestate) {
        let rec = {
          crypto_idnum: key,
          heartbeat: heartbeatestate[key].timestamp,
          version: heartbeatestate[key].version,
          servertime: heartbeatestate[key].servertime,
          desc: heartbeatestate[key].desc,
          ip: heartbeatestate[key].ip,
          isocketversion: heartbeatestate[key].isocketversion,
          notereaderversion: heartbeatestate[key].notereaderversion,
          status: heartbeatestate[key].status,
          timestamp: heartbeatestate[key].timestamp,
          timezone: heartbeatestate[key].timezone,
          type: heartbeatestate[key].type
        }
        heartbeatrecs.push(rec)
      }
      commit('setheartbeatvalues', heartbeatrecs)
    })
  },
  stoprealtimeheartbeats({ commit }) {
    firebase.database().ref('hardware').child('heartbeat').off()
  },
  async loadheartbeats({ commit, state }, payload) {
    console.log('HEARTBEATS CALLED ')
    // get a list of the sites
    // get a list of those sites with profiles
    // get their cryptoids
    commit('setLoading', true)
    let heartbeatrecs = []
    try {
      let beat = await firebase.database().ref('hardware').child('heartbeat').once('value')
      let heartbeatestate = beat.val()
      for (let key in heartbeatestate) {
        let timestamp = 'NA'
        let servertime = 'NA'

        let rec = {
          crypto_idnum: key,
          heartbeat: heartbeatestate[key].timestamp,
          version: heartbeatestate[key].version,
          timestamp: heartbeatestate[key].timestamp,
          servertime: heartbeatestate[key].servertime,
          desc: heartbeatestate[key].desc,
          ip: heartbeatestate[key].ip,
          isocketversion: heartbeatestate[key].isocketversion,
          notereaderversion: heartbeatestate[key].notereaderversion,
          status: heartbeatestate[key].status,
          timezone: heartbeatestate[key].timezone,
          type: heartbeatestate[key].type
        }
        heartbeatrecs.push(rec)
      }
    } catch {

    }
    // console.log(heartbeatrecs)
    commit('setheartbeatvalues', heartbeatrecs)
    commit('setLoading', false)
  },
  loadmonthcashin({ commit }, payload) {
    let safes = payload
    let cashindata = []
    let PromArr = []
    for (let key in safes) {
      let numberofdays = 120
      let week = []
      for (let i = 0; i < numberofdays; i++) {
        week.push(moment().subtract((i + 1), 'day').format('YYYY-MM-DD'))
      }
      // get data for this safe unit id num from firebase
      let safeidnum = safes[key].crypto_idnum
      for (let calday in week) {
        let prom = firebase.database().ref('e2c').child('EODRECS').child(week[calday]).child(safeidnum).once('value')
          .then((data) => {



            let notedata = []
            const obj = data.val()
            if (week[calday] === '2026-04-01') {
              console.log('found rec ', obj)
            }
            if (obj) {
              let twos = 0
              if (obj.twos) {
                twos = obj.twos
              }
              cashindata.push({
                unitid: safeidnum,
                day: week[calday],
                ones: obj.ones,
                twos: twos,
                fives: obj.fives,
                tens: obj.tens,
                twenties: obj.twenties,
                fifties: obj.fifties,
                hundreds: obj.hundreds,
                bills: obj.ones + twos + obj.fives + obj.tens + obj.twenties + obj.fifties + obj.hundreds,
                validated: obj.sumvalidated,
                coinpayments: obj.coinpayments,
                sumdrops: obj.sumdrops,
                sum: obj.sum
              })

            }
            else {
              // no data on date
              cashindata.push({
                unitid: safeidnum,
                day: week[calday],
                ones: 0,
                twos: 0,
                fives: 0,
                tens: 0,
                twenties: 0,
                fifties: 0,
                hundreds: 0,
                bills: 0,
                validated: 0,
                coinpayments: 0,
                sumdrops: 0,
                sum: 0
              })
            }
            return notedata
          })
          .catch((error) => {
            let nodata = []
            console.log(error)
            return nodata
          })
        // this code is actually executed before the above. I know its weird.
        PromArr.push(prom)
      }
    }
    Promise.all(PromArr).then(function (values) {
      commit('setCashinValues', cashindata)
    })
    // take in a json obj of
    //  siteid
    //    unit array
    // returns cashin of last 7 days for each unit
    //  [day]/[amount,timestamp]
  },
  async loadnotereaderevents({ commit }) {
    // today and x days back
    commit('setLoading', true)
    let rejectrecs = []
    let rejectionslist = []
    try {
      let rejecteventref = await firebase.database().ref('hardware').child('notereject').limitToLast(20).once('value')
      let rejections = rejecteventref.val()
      for (let day in rejections) {
        for (let safe in rejections[day]) {
          // each key here is a rejection entry but its not an iterable list
          let rec = {
            day: day,
            crypto_idnum: safe,
            rejcount: Object.keys(rejections[day][safe]).length
          }
          rejectrecs.push(rec)
          Object.values(rejections[day][safe]).forEach(element => {
            let event = {
              crypto_idnum: safe,
              timestamp: element.TS
            }
            rejectionslist.push(event)
          })
        }
        // {day machine count}
        // rejectrecs.push(rec)
      }
      commit('setNotereaderEventList', rejectionslist)
      commit('setNotereaderEvents', rejectrecs)
    } catch {

    }
    commit('setLoading', false)
  },
  async loadsplitdata({ commit }) {
    let splitdata
    let dataref = await firebase.database().ref('e2c').child('CITSPLIT').limitToLast(30).once('value')
    splitdata = dataref.val()
    // console.log(splitdata)
    commit('setSplitData', splitdata)
  },
  async loadAuditLog({ commit }, payload) {
    const MAX_REPORTING_DAYS = 30
    const PromArr = []
    const timespan = []
    const transactions = []
    // get an array of dates
    for (let i = 0; i < MAX_REPORTING_DAYS; i++) {
      timespan.push(moment().subtract(i, 'day').format('YYYY-MM-DD'))
    }
    for (const day of timespan) {
      const transProm = firebase
        .database()
        .ref('AUDITLOG')
        .child(day)
        .once('value')
        .then((data) => {
          const obj = data.val()
          if (obj) {
            // get user keys
            let actions = []
            if (obj) {
              actions = Object.values(obj)
            }
            actions.forEach((item) => {
              transactions.push({
                date: day,
                timestamp: item.timestamp,
                description: item.description,
                actions: item.actions,
                meta: item.meta,
                userkey: item.user,
              })
            })
          }
        })
      PromArr.push(transProm)
    }

    await Promise.all(PromArr).then((values) => {
      commit('setAuditLogByDay', transactions)
    })
    commit('setLoading', false)
  },
  async loadunits({ commit }) {


    console.log('now getting all units')

    const ssunits = []
    firebase.database().ref('UNITS').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          let credit_enabled = false
          // let creditdetails = cclients.find(item => item.safeid === obj[key].crypto_idnum)

          ssunits.push({
            crypto_idnum: obj[key].crypto_idnum,
            assigned: obj[key].assigned,
            sitekey: obj[key].sitekey,
            unitkey: key
          })
        }
        commit('setLoadedUnits', ssunits)
      })
      .catch(
        (error) => {
          console.log(error)
        }
      )
  },
  async loadsiteProfiles({ commit }) {
    // load cc units
    const cclients = []
    await firebase.database().ref('CASHCONNECT_DIRECTOR').child('CC_EnabledSites').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          cclients.push({
            idnum: obj[key].idnum,
            sitekey: obj[key].sitekey,
            ccid: obj[key].ccid,
            safeid: obj[key].safeid,
            override: obj[key].override,
            timestamp: obj[key].timestamp,
            key: key,
          })
        }
        console.log('cc sites setting ', cclients)
      })
    // commit('setLoading', true)
    firebase.database().ref('SITEPROFILES').once('value')
      .then((data) => {
        const profiles = data.val()
        commit('setLoadedProfiles', profiles)
        console.log('set profiles with ', profiles)
      })
      .catch(
        (error) => {
          console.log(error)
          // commit('setLoading', false)
        }
      )
  },
  loadSiteConfigs({ commit }) {

    const clients = []
    firebase.database().ref('CASHCONNECT_DIRECTOR').child('CC_EnabledSites').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          clients.push({
            idnum: obj[key].idnum,
            sitekey: obj[key].sitekey,
            ccid: obj[key].ccid,
            safeid: obj[key].safeid,
            override: obj[key].override,
            timestamp: obj[key].timestamp,
            key: key,
          })
        }
        console.log('cc sites setting ', clients)
        commit('setCashConnectSites', clients)
      })

    // commit('setLoading', true)
    const sites = []
    firebase.database().ref('SITES').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          let credit_enabled = false
          let details = clients.find(entry => entry.idnum === obj[key].idnum)
          if (details) {
            credit_enabled = details.credit_enabled
          }

          sites.push({
            idnum: obj[key].idnum,
            originalidnum: obj[key].idnum,
            created_date: obj[key].created_date,
            crypto_idnum: obj[key].crypto_idnum,
            nightlyrestart: obj[key].nightlyrestart,
            monthlyrate: obj[key].monthlyrate,
            billingclientkey: obj[key].billingclientkey,
            billingprofilekey: obj[key].billingprofilekey,
            sitekey: key,
            address: obj[key].address,
            group: obj[key].group,
            wifipw: obj[key].wifipw,
            wifiaccess: obj[key].wifiaccess,
            allowedusers: obj[key].allowedusers,
            changeSystemID: obj[key].changeSystemID,
            changeProvider: obj[key].changeProvider,
            changeorderprofiles: obj[key].changeorderprofiles,
            safeType: obj[key].safeType,
            noteCapacity: obj[key].noteCapacity,
            locationTags: obj[key].locationTags,
            provCredit: obj[key].provCredit,
            creditprovider: obj[key].creditprovider,
            creditproviderId: obj[key].creditproviderId,
            creditproviderLocationID: obj[key].creditproviderLocationID,
            creditproviderapikey: obj[key].creditproviderapikey,
            city: obj[key].city,
            state: obj[key].state,
            zipcode: obj[key].zipcode,
            sitecontactnumber: obj[key].sitecontactnumber,
            sitecontactname: obj[key].sitecontactname,
            installdate: obj[key].installdate,
            supportemail: obj[key].supportemail,
            supportnumber: obj[key].supportnumber,
            shipmentspermonth: obj[key].shipmentspermonth,
            time_open: obj[key].time_open,
            time_close: obj[key].time_close,
            time_eod: obj[key].time_eod,
            timezone: obj[key].timezone,
            time_deposit_summary: obj[key].time_deposit_summary,
            credit_enabled: credit_enabled??'NA'
          })
        }
        console.log('loaded sites ', sites)
        commit('setLoadedSites', sites)
        // commit('setLoading', false)
      })
      .catch(
        (error) => {
          console.log(error)
          // commit('setLoading', false)
        }
      )
  },
  // testCCwrite(payload) {
  //   let safeid = 'S&S-123456'
  //   let date = '2024-11-23'
  //   let data = 'D,2,S&S-012391BEF0DE9AE5EE,DROP,PROV,,11-23-2024 04:39:38,1,1455.00,400.00,100.00,820.00,100.00,35.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00'
  //   let rec = {
  //     data: data,
  //     date: date
  //   }
  //   firebase.database().ref('datafeeds').child('CC_V3').child('dailyrun').child('2024-11-24').child(safeid).child(date).child().update(rec)
  // },
  loadEstateSums({ commit }) {
    commit('setLoading', true)
    let sums = []
    firebase.database().ref('SUMMARY').child('SAFEANDSOUND').limitToLast(24).once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          sums.push({
            timestamp: obj[key].timestamp,
            sum: obj[key].estatesum
          })
        }
        commit('setEstatesums', sums.reverse())
        console.log('estate sums are ', sums)
        // orders are added by time, lets put the newest at the start of the array
        // commit('setsafestatus', safes)
        commit('setLoading', false)
      })
      .catch(
        (error) => {
          console.log(error)
          commit('setLoading', false)
        }
      )
  },
  loadChangeOrders({ commit }, payload) {
    console.log('checking details ')
    if (!payload.sitekey) {
      return
    }
    let sitekey = payload.sitekey
    let group = payload.group
    console.log('user details ', firebase.auth().currentUser.email, sitekey, group)
    // mrmr change order
    // group -> sitekey -> order list
    let changeOrders = []
    commit('setLoadedChangeOrders', changeOrders)
    firebase.database().ref('EXTERNALCHANGEORDERS').child('FILLED').child(group).child(sitekey).once('value')
      .then((data) => {
        // console.log('data ', data.val())
        if (data.val()) {
          changeOrders = Object.values(data.val())
        }
        console.log('orders are ', changeOrders)
        let shipstatus = 'In process'
        // mrmr tracking coin
        // look up to see if this order shipped and get its tracking number

        commit('setLoadedChangeOrders', changeOrders)
      })
    // load in db
  },
  inituserdepositlistener({ commit }, payload) {
    let safes = payload
    for (let key in safes) {
      // get data for this safe unit id num from firebase
      // let today = moment(new Date()).format('DD-MM-YYYY')
      let safeidnum = safes[key].crypto_idnum
      firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeidnum).child('userdeposits').limitToLast(1).on('child_added', function (snapshot) {
        console.log('adding real time event for ', safeidnum)
        let obj = snapshot.val()
        commit('appendUserDeposits', obj)
      })
    }
  },
  initmanualdepositlistener({ commit }, payload) {
    let safes = payload
    for (let key in safes) {
      // get data for this safe unit id num from firebase
      // let today = moment(new Date()).format('DD-MM-YYYY')
      let safeidnum = safes[key].crypto_idnum
      console.log('listening for ', safeidnum)
      firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeidnum).child('manualdeposits').limitToLast(50).on('child_added', function (snapshot) {
        let obj = snapshot.val()
        commit('appendManualDeposits', obj)
      })
    }
  },
  loadCITMessages({ commit }, payload) {
    console.log('LOADING NEW CIT MESSAGE!')
    let machineid = payload.crypto_idnum
    commit('setLoading', true)
    // e2c SAFEANDSOUND SS-SIM deposits
    let citevents = []
    firebase.database().ref('CITtesting').child('SAFEANDSOUND').child(machineid).limitToLast(200).once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          console.log('###### CIT MESSAGES ', obj)
          let notecount = 0
          let values = []
          values = obj[key].values
          if (values) {

          }
          citevents.push({
            timestamp: obj[key].TS,
            guid: obj[key].guid,
            total: obj[key].grandTotal,
            bills: notecount,
            values: values
          })
        }
        console.log('****** our cits ', citevents)
        // markhere
        commit('setCITValues', citevents)
        // orders are added by time, lets put the newest at the start of the array
        // commit('setsafestatus', safes)
        commit('setLoading', false)
      })
      .catch(
        (error) => {
          console.log(error)
          commit('setLoading', false)
        }
      )
  },
  initrealtimecit({ commit }, payload) {
    //     firebase.database().ref('e2c').child('SAFEANDSOUND').child(machineid).child('cashintransit').limitToLast(50).once('value')
    let safeidnum = payload.crypto_idnum
    console.log(safeidnum.crypto_idnum)
    firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeidnum).child('cashintransit').limitToLast(50).on('child_added', function (snapshot) {
      console.log('adding real time event for ', safeidnum)
      let obj = snapshot.val()
      let rec = {
        timestamp: obj.s,
        guid: obj.guid,
        total: obj.t,
        bills: obj.b,
        values: obj.v
      }
      console.log('real time cit ', rec)
      commit('appendCit', rec)
    })
  },
  stoprealtimecit({ commit }, payload) {
    let safeidnum = payload
    console.log('stopping real time cit on ', safeidnum)
    firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeidnum).child('cashintransit').off()
  },
  loadDepositusers({ commit }, payload) {
    const depositusers = []
    let siteid = payload
    console.log('loading dep usrs for ', payload)
    firebase.database().ref('DEPOSITUSERS').child(siteid).once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          depositusers.push({
            username: obj[key].username,
            email: obj[key].email,
            usertype: obj[key].usertype,
            accesscode: obj[key].accesscode,
            key: key
          })
        }
        console.log('setting usrs  ', payload, depositusers)

        commit('setLoadedDepositusers', depositusers)
      })
      .catch(
        (error) => {
          commit('setLoadedDepositusers', depositusers)
          console.log(error)
        }
      )
  },
  async loadnotecountmachinelearning({ commit }, payload) {
    let safeid = payload[0].crypto_idnum
    console.log('ml safeid ', payload)
    let numberofdays = 14
    let days = []
    let mlresults = []
    commit('setmlresults', mlresults)

    for (let i = 0; i < numberofdays; i++) {
      days.push(moment().subtract(i, 'days').format('YYYY-MM-DD'))
    }
    for (let day of days) {
      let mlforday = []
      console.log('ml day ', day, safeid)
      let dataref = await firebase.database().ref('e2c').child('ML_notecount').child(day).child(safeid).once('value')
      mlforday = dataref.val()
      if (mlforday) {
        Object.assign(mlforday, { date: day })
        mlresults.push(mlforday)
      }
    }
    console.log('ML results ', mlresults)
    commit('setmlresults', mlresults)
  },
  createccSite({ commit }, payload) {
    // CASHCONNECT_DIRECTOR
    console.log('creating cashconnect client ', payload)
    const sitedetails = {
      idnum: payload.idnum,
      sitekey: payload.sitekey,
      safeid: payload.safeid,
      ccid: payload.ccid,
      override: payload.override,
      timestamp: Date.now(),
    }
    let key
    firebase.database().ref('CASHCONNECT_DIRECTOR').child('CC_EnabledSites').push(sitedetails)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  updateccSite({ commit }, payload) {
    console.log('creating cashconnect client ', payload)
    const sitedetails = {
      idnum: payload.idnum,
      sitekey: payload.sitekey,
      ccid: payload.ccid,
      key: payload.key,
      safeid: payload.safeid,
      override: payload.override,
      timestamp: Date.now(),
    }
    let key
    firebase.database().ref('CASHCONNECT_DIRECTOR').child('CC_EnabledSites').child(payload.key).update(sitedetails)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  removeccSite({ commit }, payload) {
    // CASHCONNECT_DIRECTOR
    firebase.database().ref('CASHCONNECT_DIRECTOR').child('CC_EnabledSites').child(payload.key).remove()
  },
  loadccSites({ commit }, payload) {
    // CASHCONNECT_DIRECTOR
    console.log('loading cash connect clients')
    const clients = []
    firebase.database().ref('CASHCONNECT_DIRECTOR').child('CC_EnabledSites').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          clients.push({
            idnum: obj[key].idnum,
            sitekey: obj[key].sitekey,
            ccid: obj[key].ccid,
            safeid: obj[key].safeid,
            override: obj[key].override,
            timestamp: obj[key].timestamp,
            key: key,
          })
        }
        console.log('cc sites setting ', clients)
        commit('setCashConnectSites', clients)
      })
  },
  loadunitcashin({ commit }, payload) {
    let safes = payload
    // console.log('payload is ', payload)
    let cashindata = []
    let PromArr = []
    for (let key in safes) {
      let numberofdays = 7
      let week = []
      for (let i = 0; i < numberofdays; i++) {
        week.push(moment().subtract((i + 1), 'day').format('YYYY-MM-DD'))
      }
      // get data for this safe unit id num from firebase
      let safeidnum = safes[key].crypto_idnum
      for (let calday in week) {
        let prom = firebase.database().ref('e2c').child('EODRECS').child(week[calday]).child(safeidnum).once('value')
          .then((data) => {
            let notedata = []
            let twos = 0

            let obj = data.val()

            if (obj) {
              if (!obj.twos) {
                Object.assign(obj, { twos: 0 })
                console.log('object twos ', obj.twos)
              }


              if (obj.twos) {
                console.log('we have some twos')
                twos = obj.twos
              }

              cashindata.push({
                unitid: safeidnum,
                day: week[calday],
                ones: obj.ones,
                twos: twos,
                fives: obj.fives,
                tens: obj.tens,
                twenties: obj.twenties,
                fifties: obj.fifties,
                hundreds: obj.hundreds,
                bills: obj.ones + obj.twos + obj.fives + obj.tens + obj.twenties + obj.fifties + obj.hundreds,
                coinpayments: obj.coinpayments,
                validated: obj.sumvalidated,
                sumdrops: obj.sumdrops,
                sum: obj.sum
              })
            } else {
              cashindata.push({
                unitid: safeidnum,
                day: week[calday],
                ones: 0,
                twos: 0,
                fives: 0,
                tens: 0,
                twenties: 0,
                fifties: 0,
                hundreds: 0,
                bills: 0,
                coinpayments: 0,
                validated: 0,
                sumdrops: 0,
                sum: 0
              })
            }

            return notedata
          })
          .catch((error) => {
            let nodata = []
            console.log(error)
            return nodata
          })
        // this code is actually executed before the above. I know its weird.
        PromArr.push(prom)
      }
    }
    Promise.all(PromArr).then(function (values) {
      commit('setCashinValues', cashindata)
    })
    // take in a json obj of
    //  siteid
    //    unit array
    // returns cashin of last 7 days for each unit
    //  [day]/[amount,timestamp]
  },
  updateccSite({ commit }, payload) {
    console.log('creating cashconnect client ', payload)
    const sitedetails = {
      idnum: payload.idnum,
      sitekey: payload.sitekey,
      ccid: payload.ccid,
      key: payload.key,
      safeid: payload.safeid,
      override: payload.override,
      timestamp: Date.now(),
    }
    let key
    firebase.database().ref('CASHCONNECT_DIRECTOR').child('CC_EnabledSites').child(payload.key).update(sitedetails)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  removeccSite({ commit }, payload) {
    // CASHCONNECT_DIRECTOR
    firebase.database().ref('CASHCONNECT_DIRECTOR').child('CC_EnabledSites').child(payload.key).remove()
  },
  loadccSites({ commit }, payload) {
    // CASHCONNECT_DIRECTOR
    console.log('loading cash connect clients')
    const clients = []
    firebase.database().ref('CASHCONNECT_DIRECTOR').child('CC_EnabledSites').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          clients.push({
            idnum: obj[key].idnum,
            sitekey: obj[key].sitekey,
            ccid: obj[key].ccid,
            safeid: obj[key].safeid,
            override: obj[key].override,
            timestamp: obj[key].timestamp,
            key: key,
          })
        }
        console.log('cc sites setting ', clients)
        commit('setCashConnectSites', clients)
      })
  },
  loadAlerts({ commit }, payload) {
    console.log('load alerts with ', payload)
    const alerts = []
    let siteid = payload
    firebase.database().ref('ALERTS').child(siteid).once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          alerts.push({
            crypto_idnum: obj[key].crypto_idnum,
            label: obj[key].label,
            event_type: obj[key].event_type,
            method: obj[key].method,
            destination: obj[key].destination,
            key: key
          })
        }
        commit('setLoadedAlerts', alerts)
      })
      .catch(
        (error) => {
          commit('setLoadedAlerts', alerts)
          console.log(error)
        }
      )
  },
  loadunituserdeposits({ commit }, payload) {
    let safes = payload
    // get data for this safe unit id num from firebase
    // let today = moment(new Date()).format('DD-MM-YYYY')
    let safeidnum = safes.crypto_idnum
    let LIMIT = 600
    if (safeidnum === 'B1-000631') {
      LIMIT = 1200
    }
    firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeidnum).child('userdeposits').limitToLast(LIMIT).once('value')
      .then((data) => {
        const obj = data.val()
        let userdeposits = []
        for (let key in obj) {
          if (obj[key].userdepositid === '18735') {
            console.log('we loaded this way twos ', obj[key])
          }
          userdeposits.push({
            timestamp: obj[key].timestamp,
            userdepositid: obj[key].userdepositid,
            useridnum: obj[key].useridnum,
            notes: obj[key].notes
          })
        }
        // if safenum is S&S-
        // lets get a list of unique depoist ids
        // loop thru the total list of unique ids
        // include a record for each unique id
        if (safeidnum.includes('S&S-') || safeidnum.includes('SS-SIM')) {
          for (let entry of userdeposits) {
            let depositId = 0
            depositId = entry.userdepositid
            let recordswithId = userdeposits.filter(record => record.userdepositid === depositId)

            if (recordswithId.length > 1) {
              console.log('we have dup array ', recordswithId)
              // this.graphsums.pop()
              recordswithId.forEach((rec, index) => {
                console.log('index ', index, rec)
                // find position of the dup record in main array
                // splice record out
                if (index !== (recordswithId.length - 1)) {
                  // if its not the last one
                  console.log('remove this ', rec, ' at ', index)
                  userdeposits.forEach((item, index) => {
                    if (item.timestamp === rec.timestamp) {
                      console.log('remove from main array record at pos ', index)
                      userdeposits.splice(index, 1)
                    }
                  })
                }
              })
              // sort by time
              // splice out the older records
            }
          }
        }
        commit('setUserDeposits', userdeposits)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  // bag collection
  loadgrouppickups({ commit, state }, payload) {
    console.log('params pickup ', payload)
    let startdate = payload.startdate
    let enddate = payload.enddate
    let group = payload.group
    let max_days = 100
    // this is organized by sitekey, then date, then bags. its more efficient and easier to get data
    // get the list of site keys for this group
    // for each site get the bags per day
    // go max 100 days deep in that node
    let groupsites = state.loadedSites.filter(site => site.group === group)
    let groupsitekeys = groupsites.map(site => site.sitekey)
    let grouppickups = []
    commit('setLoading', true)
    commit('setGroupPickups', grouppickups)

    if (groupsitekeys.length > 0) {
      console.log('keys for this group', groupsitekeys.length)
      let PromArr = []
      // mr1
      for (let sitekey of groupsitekeys) {
        // get the last 100 days deep
        let prom = firebase.database().ref('COLLECTED').child(sitekey).limitToLast(60).once('value')
          .then((data) => {
            const obj = data.val()
            if (obj) {
              let sitedetails = state.loadedSites.find(site => site.sitekey === sitekey)
              // console.log('site details ', sitedetails.idnum)
              // console.log('obj ', obj)
              // console.log('bags ', Object.values(obj), ' dates ', Object.keys(obj))
              // loop through the obj and make records for each site, each day, and all the bags that day
              let dates = Object.keys(obj)
              let bagdata = Object.values(obj)
              for (let day of dates) {
                let bagsfordate = Object.values(obj[day])
                bagsfordate.forEach(bag => {
                  grouppickups.push({
                    sitename: sitedetails.idnum,
                    city: sitedetails.city,
                    date: day,
                    bagnumber: bag.tracking_number,
                    carrierid: bag.carrierid,
                    carriercompany: bag.carriercompany,
                    dayofweek: moment(day).format('dddd'),
                    depositamount: numeral(bag.depositamount).format('000.00')
                  })
                })
                // console.log('site ', sitedetails.idnum, ' bags on day ', day, ' ', bagsfordate)
              }
            }
          })
        PromArr.push(prom)
      }

      Promise.all(PromArr).then(function (values) {
        // do something here
        console.log(grouppickups)
        commit('setGroupPickups', grouppickups)

        commit('setLoading', false)
      })
    }
  },
  loadficit({ commit, state, dispatch }, params) {
    let safelist = []
    let startdate = moment(params.startdate, 'YYYY-MM-DD')
    let enddate = moment(params.enddate, 'YYYY-MM-DD')
    let span = enddate.diff(startdate, 'days')
    let datesarr = []
    // add the first date
    datesarr.push(params.startdate)
    // check to see if we add more and how many
    if (span > 0) {
      for (let i = 0; i < span; i++) {
        datesarr.push(moment(startdate).add((1 + i), 'day').format('YYYY-MM-DD'))
      }
    }
  },
  loadgroupcit({ commit, state }, params) {
    commit('setLoading', true)
    let grp = params.group
    let startdate = moment(params.startdate, 'YYYY-MM-DD')
    let enddate = moment(params.enddate, 'YYYY-MM-DD')
    let span = enddate.diff(startdate, 'days')
    let datesarr = []
    // add the first date
    datesarr.push(params.startdate)
    // check to see if we add more and how many
    if (span > 0) {
      for (let i = 0; i < span; i++) {
        datesarr.push(moment(startdate).add((1 + i), 'day').format('YYYY-MM-DD'))
      }
    }
    let groupunits = []
    let sitelabelrec = []
    let groupcit = []
    // reset it
    commit('setCITGroupValues', groupcit)
    // filter the loaded sites for our group
    let groupsites = state.loadedSites.filter(site => site.group === grp)
    // look up the profile for each site
    for (let index in groupsites) {
      let siteid = groupsites[index].idnum
      let capacity = groupsites[index].noteCapacity
      if (state.siteprofiles[siteid]) {
        let unitid
        // its got a weird struct in the db for speed but its unit per site even tho its an array
        if (state.siteprofiles[siteid].siteunitsprofile) {
          if (state.siteprofiles[siteid].siteunitsprofile[0].crypto_idnum) {
            unitid = state.siteprofiles[siteid].siteunitsprofile[0].crypto_idnum
            let rec = {
              siteid: siteid,
              unitid: unitid,
              capacity: capacity
            }
            sitelabelrec.push(rec)
            groupunits.push(unitid)
          }
        }
      }
    }
    // get unique units list by unit id
    // const uniqueunits = [...new Set(groupunits.map(rec => rec.unitid))]
    const uniqueunits = [...new Set(groupunits)]
    // push all the safe ids into an array
    // get each from the database
    // summarize these by note type
    // summarize these by manual drop
    // get total sum
    let PromArr = []
    let CIT_LIMIT = 200
    console.log('group unique units ', uniqueunits)
    // mrmr testing 
    for (let key in uniqueunits) {
      // get data for this safe unit id num from firebase
      // let today = moment(new Date()).format('DD-MM-YYYY')
      // firebase.database().ref('CITtesting').child('SAFEANDSOUND').child(safeid)
      let safeidnum = uniqueunits[key]
      console.log('getting cit for ', safeidnum, key, uniqueunits)
      let prom = firebase.database().ref('CITtesting').child('SAFEANDSOUND').child(safeidnum).limitToLast(CIT_LIMIT).once('value')
        .then((data) => {
          let notedata = []
          const obj = data.val()
          if (obj) {
            console.log('groupcitobj ', Object.values(obj))
            let dataset = Object.values(obj)
            // if we have something to do lets format us up a nice record so the complexity isnt in the view
            // get that site label
            let siteidnum = ''
            let capacity = ''
            for (let entry in sitelabelrec) {
              if (safeidnum === sitelabelrec[entry].unitid) {
                siteidnum = sitelabelrec[entry].siteid
                capacity = sitelabelrec[entry].capacity
              }
            }
            let usage = 0


            // loop thru data set
            dataset.forEach(entry => {
              let billcount = 0
              let total_amount = 0

              if (entry.values) {
                entry.values.forEach(item => {
                  billcount += item.count
                  total_amount += item.denom * item.count
                })
              }
              if (capacity) {
                usage = billcount / capacity
              }
              // empty ones are not meaningful
              if (entry.TS > 0) {
                groupcit.push({
                  siteid: siteidnum,
                  unitid: safeidnum,
                  capacity: capacity,
                  usage: usage,
                  day: moment(entry.TS).format('ddd YY-MM-DD HH:mm'),
                  notecount: billcount,
                  timestamp: entry.TS,
                  total: total_amount,
                  notes: entry.v
                })
              }
            })

            // console.log(' data for this group is ', graphdata)
            // groupeod.push(graphdata)
            // key is the date
            // value is an array of note in events for that specific day
          }
          return notedata
        })
        .catch((error) => {
          let nodata = []
          console.log(error)
          return nodata
        })
      // this code is actually executed before the above. I know its weird.
      PromArr.push(prom)
    }

    Promise.all(PromArr).then(function (values) {
      commit('setCITGroupValues', groupcit)
      commit('setLoading', false)
    })
  },
  createsiteProfile({ commit, getters }, payload) {
    const machineProfile = {
      sitekey: payload.sitekey,
      idnum: payload.idnum,
      group: payload.group,
      siteunitsprofile: payload.siteunitsprofile
    }
    // we want to be able to reference directly to the configuration via the machine ID in the database here
    // this allows us to NOT have to get the full list of elements even tho that list might not be that big
    // per instance.

    // we get back order of SITES/SITEIDS/specsitekey/data
    // we can just ignore the site key but if someone uses the same site id it'll have its own unique key
    // this is a good thing...
    let key
    firebase.database().ref('SITEPROFILES').child(payload.idnum).set(machineProfile)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
    // Reach out to firebase and store it
  },
  loadgroupeods({ commit, state }, params) {
    commit('setLoading', true)
    let grp = params.group
    let startdate = moment(params.startdate, 'YYYY-MM-DD')
    let enddate = moment(params.enddate, 'YYYY-MM-DD')
    let span = enddate.diff(startdate, 'days')
    let datesarr = []
    // add the first date
    datesarr.push(params.startdate)
    // check to see if we add more and how many
    if (span > 0) {
      for (let i = 0; i < span; i++) {
        datesarr.push(moment(startdate).add((1 + i), 'day').format('YYYY-MM-DD'))
      }
    }
    let groupunits = []
    let sitelabelrec = []
    let groupeod = []
    // filter the loaded sites for our group
    let groupsites = state.loadedSites.filter(site => site.group === grp)
    // look up the profile for each site
    for (let index in groupsites) {
      let siteid = groupsites[index].idnum
      if (state.siteprofiles[siteid]) {
        let unitid
        // its got a weird struct in the db for speed but its unit per site even tho its an array
        if (state.siteprofiles[siteid].siteunitsprofile) {
          if (state.siteprofiles[siteid].siteunitsprofile[0].crypto_idnum) {
            unitid = state.siteprofiles[siteid].siteunitsprofile[0].crypto_idnum
            let rec = {
              siteid: siteid,
              unitid: unitid,
            }
            sitelabelrec.push(rec)
            groupunits.push(unitid)
          }
        }
      }
    }
    // get unique units list by unit id
    // const uniqueunits = [...new Set(groupunits.map(rec => rec.unitid))]
    const uniqueunits = [...new Set(groupunits)]
    // push all the safe ids into an array
    // get each from the database
    // summarize these by note type
    // summarize these by manual drop
    // get total sum
    let PromArr = []
    for (let calday in datesarr) {
      for (let key in uniqueunits) {
        // get data for this safe unit id num from firebase
        // let today = moment(new Date()).format('DD-MM-YYYY')
        let safeidnum = uniqueunits[key]
        let prom = firebase.database().ref('e2c').child('EODRECS').child(datesarr[calday]).child(safeidnum).once('value')
          .then((data) => {
            let notedata = []


            let obj = data.val()


            if (obj) {
              // if we have something to do lets format us up a nice record so the complexity isnt in the view
              // get that site label
              let siteidnum = ''
              for (let entry in sitelabelrec) {
                if (safeidnum === sitelabelrec[entry].unitid) {
                  siteidnum = sitelabelrec[entry].siteid
                }
              }
              groupeod.push({
                siteid: siteidnum,
                unitid: safeidnum,
                day: datesarr[calday],
                ones: obj.ones,
                twos: obj.twos ?? 0,
                fives: obj.fives,
                tens: obj.tens,
                twenties: obj.twenties,
                fifties: obj.fifties,
                hundreds: obj.hundreds,
                validated: obj.sumvalidated,
                sumdrops: numeral(obj.sumdrops).format('0.00'),
                sum: obj.sum
              })
              // console.log(' data for this group is ', graphdata)
              // groupeod.push(graphdata)
              // key is the date
              // value is an array of note in events for that specific day
            } else {
              let siteidnum = ''
              for (let entry in sitelabelrec) {
                if (safeidnum === sitelabelrec[entry].unitid) {
                  siteidnum = sitelabelrec[entry].siteid
                }
              }
              console.log("NO DATA FOR ", siteidnum, ' on ', datesarr[calday])
              groupeod.push({
                siteid: siteidnum,
                unitid: safeidnum,
                day: datesarr[calday],
                ones: 0,
                twos: 0,
                fives: 0,
                tens: 0,
                twenties: 0,
                fifties: 0,
                hundreds: 0,
                validated: 0,
                sumdrops: 0,
                sum: 0
              })
            }
            return notedata
          })
          .catch((error) => {
            let nodata = []
            console.log(error)
            return nodata
          })
        // this code is actually executed before the above. I know its weird.
        PromArr.push(prom)
      }
    }
    Promise.all(PromArr).then(function (values) {
      commit('setCashinGroupValues', groupeod)
      commit('setLoading', false)
    })
  },
  loadmonthunitmanualdeposits({ commit }, payload) {
    let safes = payload
    // get data for this safe unit id num from firebase
    // let today = moment(new Date()).format('DD-MM-YYYY')
    let safeidnum = safes.crypto_idnum
    firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeidnum).child('manualdeposits').limitToLast(100).once('value')
      .then((data) => {
        const obj = data.val()
        let manualdeposits = []
        for (let key in obj) {
          manualdeposits.push({
            timestamp: obj[key].timestamp,
            userdepositid: obj[key].userdepositid,
            useridnum: obj[key].useridnum,
            amount: obj[key].amount
          })
        }
        commit('setManualDeposits', manualdeposits)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  loadunitmanualdeposits({ commit }, payload) {
    let safes = payload
    // get data for this safe unit id num from firebase
    // let today = moment(new Date()).format('DD-MM-YYYY')
    let safeidnum = safes.crypto_idnum
    if (safeidnum.includes('Postal')) {
      commit('setManualDeposits', [])

      return
    }
    firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeidnum).child('manualdeposits').limitToLast(400).once('value')
      .then((data) => {
        const obj = data.val()
        let manualdeposits = []

        if (obj) {
          for (let key in obj) {
            let idnum = 'NA'
            if (obj[key].useridnum) {
              idnum = obj[key].useridnum
            }
            manualdeposits.push({
              timestamp: obj[key].timestamp,
              userdepositid: obj[key].userdepositid,
              useridnum: 0,
              amount: obj[key].amount
            })
          }
        }

        console.log('MANUAL DEPS ', manualdeposits)
        commit('setManualDeposits', manualdeposits)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  initrealtimebalance({ commit }, payload) {
    let safes = payload
    for (let key in safes) {
      // get data for this safe unit id num from firebase
      // let today = moment(new Date()).format('DD-MM-YYYY')
      let safeidnum = safes[key].crypto_idnum
      firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeidnum).child('cashheld').on('value', function (snapshot) {
        commit('setCashBalanceValues', [])
        let obj = snapshot.val()
        if (obj) {
          let rec = {
            timestamp: obj.s,
            total: obj.t,
            bills: obj.b,
            values: obj.v
          }
          commit('setCashBalanceValues', rec)
        }

      })
    }
  },
  loadChangeSchedule({ commit }, payload) {
    // if group is admin, get all groups?
    let allchangeschedules = []
    commit('setLoadedChangeSchedules', allchangeschedules)
    firebase.database().ref('CHANGESCHEDULE').once('value')
      .then((data) => {
        let allprofiles = data.val()
        if (!allprofiles) {
          return
        }
        let groups = Object.keys(allprofiles)
        groups.forEach(element => {
          let groupProfiles = allprofiles[element]
          let profileKeys = Object.keys(allprofiles[element])
          profileKeys.forEach(key => {
            groupProfiles[key].key = key
            allchangeschedules.push(groupProfiles[key])
          })
        })
        console.log('setting change schedules ', allchangeschedules)
        commit('setLoadedChangeSchedules', allchangeschedules)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  createChangeSchedule({ commit }, payload) {
    console.log(payload)
    let group = payload.group
    firebase.database().ref('CHANGESCHEDULE').child(group).push(payload)
  },
  updateChangeSchedule({ commit }, payload) {
    let key = payload.key
    let group = payload.group
    firebase.database().ref('CHANGESCHEDULE').child(group).child(key).update(payload)
  },
  deleteChangeSchedule({ commit }, payload) {
    let key = payload.key
    let group = payload.group
    firebase.database().ref('CHANGESCHEDULE').child(group).child(key).remove()
  },
  loadChangeProfileGroup({ commit }, payload) {
    // if group is admin, get all groups?
    let group = payload.group
    firebase.database().ref('CHANGEPROFILES').child(group).once('value')
      .then((data) => {
        let key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  loadChangeProfile({ commit }, payload) {
    // if group is admin, get all groups?
    let allchangeprofiles = []
    commit('setLoadedChangeProfiles', allchangeprofiles)

    firebase.database().ref('CHANGEPROFILES').once('value')
      .then((data) => {
        let allprofiles = data.val()
        if (!allprofiles) {
          commit('setLoadedChangeProfiles', [])
          return
        }
        let groups = Object.keys(allprofiles)
        groups.forEach(element => {
          let groupProfiles = allprofiles[element]
          let profileKeys = Object.keys(allprofiles[element])
          profileKeys.forEach(key => {
            groupProfiles[key].key = key
            allchangeprofiles.push(groupProfiles[key])
          })
        })
        commit('setLoadedChangeProfiles', allchangeprofiles)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  createChangeProfile({ commit }, payload) {
    console.log(payload)
    let group = payload.group
    firebase.database().ref('CHANGEPROFILES').child(group).push(payload)
  },
  updateChangeProfile({ commit }, payload) {
    let key = payload.key
    let group = payload.group
    firebase.database().ref('CHANGEPROFILES').child(group).child(key).update(payload)
  },
  deleteChangeProfile({ commit }, payload) {
    let key = payload.key
    let group = payload.group
    firebase.database().ref('CHANGEPROFILES').child(group).child(key).remove()
  },
  async loadpostalshipmentsgroup({ commit, state }, params) {
    // gets for a single site
    // firebase.database().ref('POSTALSYSTEM').child(safeid).child('postalshipment').child(date).once('value')
    // get site list for group
    // get safe id for site
    // getall the shipments
    // filter by date range
    // this is going to be expensive but they are paying for it
    console.log('running group postal shipments')
    commit('setLoading', true)
    let grp = params.group

    let startdate = moment(params.startdate, 'YYYY-MM-DD')
    let enddate = moment(params.enddate, 'YYYY-MM-DD')
    let span = enddate.diff(startdate, 'days')
    let datesarr = []
    // add the first date
    datesarr.push(params.startdate)
    // check to see if we add more and how many
    if (span > 0) {
      for (let i = 0; i < span; i++) {
        datesarr.push(moment(startdate).add((1 + i), 'day').format('YYYY-MM-DD'))
      }
    }
    let groupunits = []
    let sitelabelrec = []
    let groupshipments = []
    // filter the loaded sites for our group
    let groupsites = state.loadedSites.filter(site => site.group === grp)
    // look up the profile for each site
    for (let index in groupsites) {
      let siteid = groupsites[index].idnum
      if (state.siteprofiles[siteid]) {
        let unitid
        // its got a weird struct in the db for speed but its unit per site even tho its an array
        if (state.siteprofiles[siteid].siteunitsprofile) {
          if (state.siteprofiles[siteid].siteunitsprofile[0].crypto_idnum) {
            unitid = state.siteprofiles[siteid].siteunitsprofile[0].crypto_idnum
            let rec = {
              siteid: siteid,
              unitid: unitid,
            }
            sitelabelrec.push(rec)
            groupunits.push(unitid)
          }
        }
      }
    }
    // get unique units list by unit id
    // const uniqueunits = [...new Set(groupunits.map(rec => rec.unitid))]
    const uniqueunits = [...new Set(groupunits)]
    // push all the safe ids into an array
    // get each from the database
    // summarize these by note type
    // summarize these by manual drop
    // get total sum
    let PromArr = []
    // mrmr we will loop by site rather than by day but this works out well in terms of the pattern july 3rd
    for (let calday in datesarr) {
      for (let key in uniqueunits) {
        // get data for this safe unit id num from firebase
        // let today = moment(new Date()).format('DD-MM-YYYY')
        let safeidnum = uniqueunits[key]
        // firebase.database().ref('POSTALSYSTEM').child(safeidnum).child('postalshipment').child(datesarr[calday]).once('value')
        let prom = firebase.database().ref('POSTALSYSTEM').child(safeidnum).child('postalshipment').child(datesarr[calday]).once('value')
          .then((data) => {
            let notedata = []
            const obj = data.val()
            if (obj) {
              // if we have something to do lets format us up a nice record so the complexity isnt in the view
              // get that site label
              let siteidnum = ''
              for (let entry in sitelabelrec) {
                if (safeidnum === sitelabelrec[entry].unitid) {
                  siteidnum = sitelabelrec[entry].siteid
                }
              }
              let values = Object.values(obj)
              console.log('#######  shipment found ', values[0])
              let entry = values[0]

              let totalcoin = 0
              let totalcheck = 0
              let totalcash = 0
              let packages = entry.contents
              let sum = 0
              console.log('this shipment has these packages ', packages)
              packages.forEach(item => {
                console.log('item ', item.securebagdeposit)
                totalcheck += item.securebagdeposit?.CheckAmount
                totalcoin += item.securebagdeposit?.CoinAmount
                totalcash += item.securebagdeposit?.CurrencyAmount
                sum += item.securebagdeposit?.DepositAmount
              })


              groupshipments.push({
                siteid: siteidnum,
                unitid: safeidnum,
                status: entry.status,
                contents: entry.contents,
                totalcheck: numeral(totalcheck).format('0.00'),
                totalcoin: numeral(totalcoin).format('0.00'),
                totalcash: numeral(totalcash).format('0.00'),
                sum: numeral(sum).format('0.00'),
                tracking_number: entry.tracking_number,
                trackdata: entry.trackdata,
                timestamp: moment(entry.timestamp).format('YYYY-MM-DD'),
              })
              // console.log(' data for this group is ', graphdata)
              // groupeod.push(graphdata)
              // key is the date
              // value is an array of note in events for that specific day
            }
            return notedata
          })
          .catch((error) => {
            let nodata = []
            console.log(error)
            return nodata
          })
        // this code is actually executed before the above. I know its weird.
        PromArr.push(prom)
      }
    }
    Promise.all(PromArr).then(function (values) {
      console.log('group postal shipments ', groupshipments)
      commit('setGroupShipments', groupshipments)
      commit('setLoading', false)
    })
  },
  async removepostaldeposit({ commit, dispatch, state }, payload) {
    console.log('postal deposit delete ', payload)
    let safeid = payload.safeid
    let siteid = payload.siteid
    let date = moment(payload.timestamp).format('YYYY-MM-DD')
    let packagekey = payload.key
    let amount = payload.securebagdeposit.DepositAmount * 100 // convert to pennies
    // SECURITYBAGSYSTEM/SAFEID/DATE/PACKAGEKEY
    // let postref = await firebase.database().ref('SECURITYBAGSYSTEM').child(payload).child('securebagdeposit').limitToLast(DAYLIMIT).once('value')
    // mrmr remove postal
    console.log('removed ', safeid, date, packagekey)
    let actionrecord = {
      user: state.user,
      actions: 'delete',
      description: 'removed postal deposit',
      timestamp: Date.now(),
      meta: amount
    }
    let removedate = moment().format('YYYY-MM-DD')
    firebase.database().ref('AUDITLOG').child(removedate).push(actionrecord)
      .catch((error) => {
        console.log(error)
        commit('setLoading', false)
      })
    console.log('remove from db ', safeid, date, packagekey)
    firebase.database().ref('SECURITYBAGSYSTEM').child(safeid).child('securebagdeposit').child(date).child(packagekey).remove()
      .then((data) => {
        console.log('removed from securitybagsystem')
      })
      .catch((error) => {
        console.log(error)
      })
    firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeid).child('manualdeposits').limitToLast(100).once('value')
      .then((data) => {
        const obj = data.val()
        let manualdeposits = []
        for (let key in obj) {
          manualdeposits.push({
            timestamp: obj[key].timestamp,
            date: moment(obj[key].timestamp).format('YYYY-MM-DD'),
            userdepositid: obj[key].userdepositid,
            useridnum: obj[key].useridnum,
            amount: obj[key].amount,
            key: key
          })
        }
        // look thru each one
        for (let entry of manualdeposits) {
          if (entry.date === date) {
            if (amount === entry.amount) {
              console.log('we found the entry to delete ', entry)
              firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeid).child('manualdeposits').child(entry.key).remove()
                .then((data) => {
                  console.log('removed from manual dep ', entry)
                  dispatch('loadpostaldeposits', safeid)
                })
            }
          }
        }
      })

    // get the last 100 manual deposits
    // match the amount
    // match the date

    // remove also from manual deposits
    // e2c/safeandsound/safeid/manualdeposits/
    // they do not share keys here so go by timestamp/date
  },
  async loadpostaldeposits({ commit }, payload) {
    console.log('loading postal deposits ', payload)
    // commit('setLoading', true)
    let DAYLIMIT = 60
    let depositbags = []
    commit('setLoadedPostalDeposits', depositbags)
    let postref = await firebase.database().ref('SECURITYBAGSYSTEM').child(payload).child('securebagdeposit').once('value')
    let postaldeposits = postref.val()
    console.log('raw postal entries from db ', postaldeposits, postaldeposits.length)
    // reset it
    // commit('setLoadedPostalDeposits', depositbags)
    if (!postaldeposits) {
      return
    }
    let dates = []
    dates = Object.keys(postaldeposits)
    for (let day of dates) {
      let entries = []
      entries = Object.keys(postaldeposits[day])
      for (let entry of entries) {
        let postalentry = postaldeposits[day][entry]
        Object.assign(postalentry, { key: entry })
        depositbags.push(postalentry)
      }
    }
    console.log('setting postal deposits', depositbags.length)
    commit('setLoadedPostalDeposits', depositbags)
  },
  loadpostalorders({ commit }, payload) {
    // commit('setLoading', true)
    let DAYLIMIT = 60

    firebase.database().ref('POSTALSYSTEM').child(payload).child('postalorder').limitToLast(DAYLIMIT).once('value')
      .then((data) => {
        let orders = []
        const postalorder = data.val()
        // for each date
        let dates = ''
        if (!postalorder) {
          return
        }
        dates = Object.keys(postalorder)
        dates.forEach(day => {
          let entries = []
          entries = Object.keys(postalorder[day])
          entries.forEach(element => {
            orders.push(postalorder[day][element])
          })
        })
        // for each order in that date
        commit('setLoadedPostalOrders', orders)
      })
      .catch(
        (error) => {
          console.log(error)
          // commit('setLoading', false)
        }
      )
  },
  createDeposituser({ commit }, payload) {
    const deposituser = {
      siteid: payload.siteid,
      username: payload.username,
      email: payload.email,
      usertype: payload.usertype,
      accesscode: payload.accesscode
    }
    let key
    firebase.database().ref('DEPOSITUSERS').child(payload.siteid).push(deposituser)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  updateDeposituser({ commit, getters }, payload) {
    const deposituser = {
      siteid: payload.siteid,
      username: payload.username,
      email: payload.email,
      usertype: payload.usertype,
      accesscode: payload.accesscode
    }
    firebase.database().ref('DEPOSITUSERS').child(payload.siteid).child(payload.key).update(deposituser)
      .then(() => {
        // console.log('we updated alert ', payload.username)
      })
      .catch((error) => {
        console.log(error)
      })
    // Reach out to firebase and store it
  },
  removeDeposituser({ commit }, payload) {
    const key = payload.key
    const siteid = payload.siteid
    commit('setLoading', true)
    firebase.database().ref('DEPOSITUSERS').child(siteid).child(key).remove()
      .catch((error) => {
        console.log(error)
        commit('setLoading', false)
      })
    commit('setLoading', false)
  },
  loadpostalbags({ commit }, payload) {
    // commit('setLoading', true)
    let DAYLIMIT = 60
    commit('setLoading', true)
    firebase.database().ref('POSTALSYSTEM').child(payload).child('postalbags').limitToLast(DAYLIMIT).once('value')
      .then((data) => {
        let bags = []
        const postalbags = data.val()
        // for each date
        if (!postalbags) {
          return
        }
        let dates = ''
        dates = Object.keys(postalbags)
        dates.forEach(day => {
          let entries = []
          entries = Object.keys(postalbags[day])
          entries.forEach(element => {
            bags.push(postalbags[day][element])
          })
        })
        // for each order in that date
        commit('setLoadedPostalBags', bags)
      })
      .catch(
        (error) => {
          console.log(error)
          // commit('setLoading', false)
        }
      )
    commit('setLoading', false)
  },
  async loadpostalshipments({ commit }, payload) {
    let DAYLIMIT = 90
    // this gets them all, for all sites
    // you need to undo this live update on exit mrmr
    firebase.database().ref('POSTALSYSTEM').child(payload).child('postalshipment').on('value', function (snapshot) {
      let postaldeposits = snapshot.val()
      let shipments = []
      console.log('load postal reset')
      commit('setPostShipments', shipments)

      // reset it
      let dates = []
      if (!postaldeposits) {
        console.log('no postal deposits in db', payload)
        return
      }
      dates = Object.keys(postaldeposits)
      console.log('dates array ', dates)
      for (let day of dates) {
        console.log('loading shipment day of ', day)
        let entries = []
        entries = Object.keys(postaldeposits[day])
        for (let entry of entries) {
          let postalentry = postaldeposits[day][entry]
          Object.assign(postalentry, { shipmentkey: entry })
          let trackingnumber = postalentry.tracking_number.toString()
          firebase.database().ref('packagetracking').child(trackingnumber).once('value')
            .then((data) => {
              let trackdata = data.val()
              if (trackdata) {
                postalentry.trackdata = trackdata
                postalentry.status = trackdata.status_description
              } else {
                // console.log('*** real time track data empty ', trackdata)
              }
              shipments.push(postalentry)
            })
        }
      }
      commit('setPostShipments', shipments)
    })
  },
  async loadsecuritybagdeposits({ commit }, payload) {
    // commit('setLoading', true)
    let DAYLIMIT = 60
    let postref = await firebase.database().ref('SECURITYBAGSYSTEM').child(payload).child('securebagdeposit').limitToLast(DAYLIMIT).once('value')
    let securebagdeposit = postref.val()
    let depositbags = []
    commit('setLoadedSecureBagDeposits', depositbags)

    // reset it
    // commit('setLoadedPostalDeposits', depositbags)
    let dates = []
    if (!securebagdeposit) {
      return
    }
    dates = Object.keys(securebagdeposit)

    for (let day of dates) {
      let entries = []
      entries = Object.keys(securebagdeposit[day])
      for (let entry of entries) {
        let bagentry = securebagdeposit[day][entry]
        // add the key in this record
        // mrmr
        Object.assign(bagentry, { key: entry })
        depositbags.push(bagentry)
      }
    }
    commit('setLoadedSecureBagDeposits', depositbags)
  },
  loadallchangeorders({ commit }, payload) {
    // commit('setLoading', true)
    firebase.database().ref('EXTERNALCHANGEORDERS').child('REQUESTED').once('value')
      .then((data) => {
        let orders = []
        const changeorders = data.val()
        // for each date
        let groups = ''
        if (!changeorders) {
          commit('setLoadedChangeOrders', orders)
          return
        }
        groups = Object.keys(changeorders)
        groups.forEach(entry => {
          let sitekeys = []
          sitekeys = Object.keys(changeorders[entry])
          sitekeys.forEach(site => {
            let requests = []
            requests = changeorders[entry][site]
            let siterequest = {
              group: entry,
              sitekey: site,
              requests: requests
            }
            orders.push(siterequest)
          })
        })
        // for each order in that date
        commit('setLoadedChangeOrders', orders)
      })
      .catch(
        (error) => {
          console.log(error)
          // commit('setLoading', false)
        }
      )
  },
  loadallfilledchangeorders({ commit }, payload) {
    // commit('setLoading', true)
    let orders = []
    commit('setLoadedFilledChangeOrders', orders)

    firebase.database().ref('EXTERNALCHANGEORDERS').child('FILLED').limitToLast(100).once('value')
      .then((data) => {
        const changeorders = data.val()
        // for each date
        let groups = ''
        groups = Object.keys(changeorders)
        groups.forEach(entry => {
          let sitekeys = []
          sitekeys = Object.keys(changeorders[entry])
          sitekeys.forEach(site => {
            let requests = []
            requests = changeorders[entry][site]

            let siterequest = {
              group: entry,
              sitekey: site,
              requests: requests,
            }
            orders.push(siterequest)
          })
        })
        // for each order in that date
        commit('setLoadedFilledChangeOrders', orders)
      })
      .catch(
        (error) => {
          console.log(error)
          // commit('setLoading', false)
        }
      )
  },
  initrealtimechangeorders({ commit }) {
    // get data for this safe unit id num from firebase
    // let today = moment(new Date()).format('DD-MM-YYYY')
    firebase.database().ref('EXTERNALCHANGEORDERS').child('REQUESTED').on('value', function (snapshot) {
      let orders = []
      // clear it
      commit('setLoadedChangeOrders', orders)

      const changeorders = snapshot.val()
      // for each date
      let groups = ''
      if (!changeorders) {
        return
      }
      groups = Object.keys(changeorders)
      groups.forEach(entry => {
        let sitekeys = []
        sitekeys = Object.keys(changeorders[entry])
        sitekeys.forEach(site => {
          let requests = []
          requests = changeorders[entry][site]
          let siterequest = {
            group: entry,
            sitekey: site,
            requests: requests
          }
          orders.push(siterequest)
        })
      })
      commit('setLoadedChangeOrders', orders)
    })
  },
  passwordResetRequest({ commit }, payload) {
    console.log('pw reset requests for ', payload)
  },
  stoprealtimeuserdeposits({ commit }, payload) {
    let safes = payload
    let PromArr = []

    for (let key in safes) {
      // get data for this safe unit id num from firebase
      // let today = moment(new Date()).format('DD-MM-YYYY')
      let safeidnum = safes[key].crypto_idnum
      let prom = firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeidnum).child('userdeposits').off()
      // this code is actually executed before the above. I know its weird.
      PromArr.push(prom)
    }
    Promise.all(PromArr).then(function (values) {
      // commit('setCashBalanceValues', cashindata)
    })
  },
  stoprealtimebalance({ commit }, payload) {
    commit('setCashBalanceValues', '')
    let safes = payload
    let cashindata = []
    let PromArr = []

    for (let key in safes) {
      // get data for this safe unit id num from firebase
      // let today = moment(new Date()).format('DD-MM-YYYY')
      let safeidnum = safes[key].crypto_idnum
      let prom = firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeidnum).child('cashheld').off()
      // this code is actually executed before the above. I know its weird.
      PromArr.push(prom)
    }
    Promise.all(PromArr).then(function (values) {
      commit('setCashBalanceValues', cashindata)
    })
  },
  stoprealtimechangeorders({ commit }) {
    firebase.database().ref('EXTERNALCHANGEORDERS').child('REQUESTED').off()
  },
  initrealtimefilledchangeorders({ commit }) {
    // get data for this safe unit id num from firebase
    // let today = moment(new Date()).format('DD-MM-YYYY')
    firebase.database().ref('EXTERNALCHANGEORDERS').child('FILLED').on('value', function (snapshot) {
      let orders = []
      // clear it
      commit('setLoadedFilledChangeOrders', orders)

      const changeorders = snapshot.val()
      // for each date
      let groups = ''
      if (!changeorders) {
        return
      }
      groups = Object.keys(changeorders)
      groups.forEach(entry => {
        let sitekeys = []
        sitekeys = Object.keys(changeorders[entry])
        sitekeys.forEach(site => {
          let requests = []
          requests = changeorders[entry][site]
          let siterequest = {
            group: entry,
            sitekey: site,
            requests: requests
          }
          orders.push(siterequest)
        })
      })
      commit('setLoadedFilledChangeOrders', orders)
    })
  },
  stoprealtimefilledchangeorders({ commit }) {
    firebase.database().ref('EXTERNALCHANGEORDERS').child('FILLED').off()
  },
  loadpackagestransit({ commit, state }, payload) {

  },

  async loadGrossPostalDeposits({ commit }, payload) {
    // for all postal safes
    // throw out our demo group safes dunbar or mitchelll
    let grossref = await firebase.database().ref('SUMMARY').child('POSTALSUMGROSS').once('value')
    let grosspostaldeposits = grossref.val()
    console.log(grosspostaldeposits.value)
    console.log('$$$$$ all postal gross', grosspostaldeposits)
    commit('setgrosspostaldeposits', grosspostaldeposits.value)
    // get the eods for each postal site
  },
  async loadGrossVerified({ commit }, payload) {
    let validatedref = await firebase.database().ref('SUMMARY').child('POSTALVALIDATED').once('value')
    let grossvalidated = validatedref.val()
    console.log(grossvalidated)
    console.log('$$$$$ all postal validated ', grossvalidated)
    commit('setgrossvalidated', grossvalidated)
  },
  async loadGrossChecks({ commit }, payload) {
    let checksref = await firebase.database().ref('SUMMARY').child('POSTALCHECKSADDED').once('value')
    let postalchecks = Object.values(checksref.val())
    console.log(postalchecks)
    console.log('$$$$$ all postal checks ', postalchecks)
    commit('setpostalchecks', postalchecks)
  },
  async loadPostalSumDay({ commit }, payload) {
    let sumbydayref = await firebase.database().ref('SUMMARY').child('POSTALSUMBYDAY').once('value')
    let sumbyday = sumbydayref.val()
    let days = Object.keys(sumbyday)
    let dayrecs = []
    for (let day of days) {
      let rec = {
        date: day,
        amount: sumbyday[day].value
      }
      dayrecs.push(rec)
    }
    console.log('$$$$$ all postal sum by day ', dayrecs)

    commit('setgrosssumbyday', dayrecs)
  },
  async loadGrossPostalShipments({ commit }, payload) {
    // this gets them all, for all sites
    firebase.database().ref('POSTALSYSTEM').child(payload).child('postalshipment').on('value', function (snapshot) {
      let postaldeposits = snapshot.val()
      let shipments = []
      commit('setGrossPostShipments', shipments)

      // reset it
      let dates = []
      if (!postaldeposits) {
        return
      }
      dates = Object.keys(postaldeposits)
      for (let day of dates) {
        let entries = []
        entries = Object.keys(postaldeposits[day])
        for (let entry of entries) {
          let postalentry = postaldeposits[day][entry]
          Object.assign(postalentry, { shipmentkey: entry })
          let trackingnumber = postalentry.tracking_number.toString()
          firebase.database().ref('packagetracking').child(trackingnumber).once('value')
            .then((data) => {
              let trackdata = data.val()
              if (trackdata) {
                postalentry.trackdata = trackdata
                postalentry.status = trackdata.status_description
              } else {
                // console.log('*** real time track data empty ', trackdata)
              }
              shipments.push(postalentry)
            })
        }
      }
      commit('setGrossPostShipments', shipments)
    })
  },
  loadpackagesstaged({ commit, state }, payload) {
    let safelist = []
    safelist = payload

    // posstalsystem
    // get packages
    // get the shipment number
    // look up shipping number in
    // packagetracking by shipment number
    let packages = []
    for (let safeid of safelist) {
      firebase.database().ref('POSTALSYSTEM').child(safeid).child('postalshipment').once('value')
        .then((data) => {
          // mrmrmail
          // get sitename for this safe
          // sitedetails = state.sites.find(entry => entry.sitekey === sitekey)
          // state.profiles
          // state.siteprofiles[site.idnum]
          let siteid = ''
          let sitekey = ''
          let group = ''
          let profiles = Object.values(state.siteprofiles)
          profiles.forEach(profile => {
            if (profile.siteunitsprofile && profile.siteunitsprofile[0]) {
              if (profile.siteunitsprofile[0].crypto_idnum) {
                if (profile.siteunitsprofile[0].crypto_idnum === safeid) {
                  sitekey = profile.sitekey
                  siteid = profile.idnum
                  group = profile.group
                }
              }
            }
          })
          let records = data.val()

          // each record get the shipment IDs and look up their status
          for (let index in records) {
            let shipment = Object.values(records[index])[0] // messy
            let totalcurrency = 0
            if (shipment.contents) {
              totalcurrency = shipment.contents.reduce((acc, val) => acc + val.securebagdeposit.DepositAmount, 0)
            }
            if (shipment.tracking_number) {
              firebase.database().ref('packagetracking').child(shipment.tracking_number).once('value')
                .then((data) => {
                  let shipdata = data.val()
                  let verifiedstatus = false
                  if (shipdata && shipdata.verifiedstatus) {
                    verifiedstatus = shipdata.verifiedstatus
                  }
                  let shipStatusRec = {
                    siteid: siteid,
                    safeid: safeid,
                    sitekey: sitekey,
                    timestamp: shipment.timestamp,
                    totalcurrency: totalcurrency,
                    contents: shipment.contents,
                    shipment_cost: data.shipment_cost,
                    group: group,
                    actual_delivery_date: '',
                    carrier_status_code: '',
                    carrier_status_description: '',
                    events: [],
                    label_url: '',
                    ship_date: '',
                    status_code: '',
                    status_description: 'nodata',
                    verifiedstatus: verifiedstatus,
                    tracking_number: ''
                  }
                  shipStatusRec.actual_delivery_date = ''

                  if (shipdata && shipdata.actual_delivery_date) {
                    shipStatusRec.actual_delivery_date = shipdata.actual_delivery_date
                  }
                  if (shipdata && shipdata.carrier_status_code) {
                    shipStatusRec.carrier_status_code = shipdata.carrier_status_code
                  }
                  if (shipdata && shipdata.carrier_status_description) {
                    shipStatusRec.carrier_status_description = shipdata.carrier_status_description
                  }
                  if (shipdata && shipdata.events) {
                    shipStatusRec.events = shipdata.events
                  }
                  if (shipdata && shipdata.label_url) {
                    shipStatusRec.label_url = shipdata.label_url
                  }
                  if (shipdata && shipdata.ship_date) {
                    shipStatusRec.ship_date = shipdata.ship_date
                  }
                  if (shipdata && shipdata.status_code) {
                    shipStatusRec.status_code = shipdata.status_code
                  }
                  if (shipdata && shipdata.status_description) {
                    shipStatusRec.status_description = shipdata.status_description
                  }
                  if (shipdata && shipdata.tracking_number) {
                    shipStatusRec.tracking_number = shipdata.tracking_number
                  }
                  packages.push(shipStatusRec)
                  // if data is null, we have not been informed of it moving
                })
            } else {
              console.error("invalid/no tracking number:", shipment);
            }
          }
        })
      // console.log('packages data ', packages)
      commit('setPostalPackages', packages)
    }
  },
  clonesiteProfile({ commit }, payload) {
    let rec = {
      originalidnum: payload.originalidnum,
      newidnum: payload.newidnum,
      group: payload.group
    }
    firebase.database().ref('SITEPROFILES').once('value')
      .then((data) => {
        const profiles = data.val()
        // if it existed before, change it
        if (profiles[rec.originalidnum]) {
          // get old value
          let origprofile = profiles[rec.originalidnum]
          profiles[rec.newidnum] = origprofile
          origprofile.idnum = rec.newidnum
          origprofile.group = rec.group
          firebase.database().ref('SITEPROFILES').child(rec.newidnum).set(origprofile)
          // only if it is a new one, otherwise we just over wrote the original
          if (rec.newidnum !== rec.originalidnum) {
            firebase.database().ref('SITEPROFILES').child(rec.originalidnum).remove()
          }
        }
        // else add it

        // commit('setLoadedProfiles', profiles)
      })

    // copy their deposit users over also
    let source = payload.originalidnum
    let destination = payload.newidnum
    console.log(source, destination)
    if (source === destination) {
      console.log('not copying users, source and dest are the same')
      return
    }
    console.log('COPYING USERS ')
    firebase.database().ref('DEPOSITUSERS').child(source).once('value')
      .then((data) => {
        let users = data.val()
        if (users) {
          firebase.database().ref('DEPOSITUSERS').child(destination).update(users)
          console.log(source, destination, users)
        }
      })
    // firebase.database().ref('SITEPROFILES').child(payload.idnum).set(machineProfile)
  },
  updateMachineConfig({ commit, getters }, payload) {
    if (!payload.allowedusers) {
      payload.allowedusers = null
    }
    const machineData = {
      idnum: payload.idnum,
      address: payload.address,
      city: payload.city,
      state: payload.state,
      sitekey: payload.sitekey,
      nightlyrestart: payload.nightlyrestart,
      wifipw: payload.wifipw,
      wifiaccess: payload.wifiaccess,
      group: payload.group,
      allowedusers: payload.allowedusers,
      changeSystemID: payload.changeSystemID,
      changeProvider: payload.changeProvider,
      changeorderprofiles: payload.changeorderprofiles,
      safeType: payload.safeType,
      noteCapacity: payload.noteCapacity,
      locationTags: payload.locationTags,
      provCredit: payload.provCredit,
      creditprovider: payload.creditprovider,
      creditproviderId: payload.creditproviderId,
      creditproviderLocationID: payload.creditproviderLocationID,
      creditproviderapikey: payload.creditproviderapikey,
      zipcode: payload.zipcode,
      sitecontactnumber: payload.sitecontactnumber,
      sitecontactname: payload.sitecontactname,
      supportemail: payload.supportemail,
      supportnumber: payload.supportnumber,
      shipmentspermonth: payload.shipmentspermonth,
      timezone: payload.timezone,
      time_open: payload.time_open,
      time_close: payload.time_close,
      time_eod: payload.time_eod,
      time_deposit_summary: payload.time_deposit_summary
    }
    firebase.database().ref('SITES').child(payload.sitekey).update(machineData)
      .then(() => {
      })
      .catch((error) => {
        console.log(error)
      })

    // Reach out to firebase and store it
  },
  loadsystemtotals({ commit }) {
    const dailytotals = []
    firebase.database().ref('SUMMARY').child('SYSTEMSUMBYDAY').once('value')
      .then((data) => {
        const obj = data.val()
        let days = 0
        days = Object.keys(obj)
        let rec = ''
        for (let day of days) {
          let val = day
          rec = {
            date: day,
            value: parseInt(Object.values(obj[val]))
          }
          dailytotals.push(rec)
        }
        commit('setTotalCash', dailytotals)
      })
      .catch(
        (error) => {
          console.log(error)
        }
      )
  },
  loadsystemsnapshot({ commit }) {
    commit('setLoading', true)

    firebase.database().ref('system').child('snapshot').once('value')
      .then((data) => {
        const snap = data.val()
        commit('setSystemSnap', snap)
        commit('setLoading', false)
      })
      .catch(
        (error) => {
          commit('setLoading', false)
          console.log(error)
        }
      )
  },
  loadestatenotecount({ commit, state }) {
    // if current user is admin, e2c, or cashconnect
    if (!state.user.status === 'admin' || !state.user.status === 'CashConnect') {
      console.log('user not auth')
      return
    }
    // get a list of all the units which are assigned
    let safelist = []
    let estatenotecount = []
    firebase.database().ref('SITEPROFILES').once('value')
      .then((data) => {
        let PromArr = []
        const profiles = Object.values(data.val())
        console.log('our profiles ', profiles)
        profiles.forEach(entry => {
          let unit
          if (entry.siteunitsprofile) {
            if (entry.siteunitsprofile[0]) {
              safelist.push(entry.siteunitsprofile[0].crypto_idnum)
            }
          }
        })
        console.log('safe list ', safelist)
        // for each safe get the note count
        for (let unit of safelist) {
          let prom = firebase.database().ref('e2c').child('SAFEANDSOUND').child(unit).child('cashheld').child('b').once('value')
            .then((data) => {
              const obj = data.val()
              if (obj) {
                estatenotecount.push({ safeid: unit, notecount: obj })
              }
            })
          PromArr.push(prom)
        }
        // promise all loop
        Promise.all(PromArr).then(function (values) {
          console.log('finished with ', estatenotecount)
          commit('setEstateNoteCount', estatenotecount)
        })
      })
      .catch(
        (error) => {
          console.log(error)
          // commit('setLoading', false)
        }
      )
  },
  createSiteWizard({ commit, getters }, payload) {
    console.log('site wiz payload ', payload)
    const machineData = {
      created_date: Date.now(),
      idnum: payload.idnum.trim(),
      nightlyrestart: '',
      address: '',
      city: '',
      zipcode: '',
      shipmentspermonth: '1',
      group: payload.group,
      wifipw: '',
      wifiaccess: '',
      allowedusers: '',
      safeType: '',
      noteCapacity: '',
      locationTags: '',
      provCredit: false,
      creditprovider: '',
      creditproviderId: '',
      creditproviderLocationID: '',
      creditproviderapikey: '',
      sitecontactnumber: '',
      sitecontactname: '',
      supportemail: '',
      supportnumber: '',
      timezone: 'EST',
      time_open: '',
      time_close: '',
      time_eod: payload.time_eod,
      time_deposit_summary: ''
    }
    // we get back order of SITES/key/data
    // we can just ignore the site key but if someone uses the same site id it'll have its own unique key
    // this is a good thing...
    let key
    firebase.database().ref('SITES').push(machineData)
      .then((data) => {
        key = data.key
        let profile = {
          assigned: false,
          crypto_idnum: payload.safeid,
          sitekey: '',
          unitkey: ''
        }
        // site profiles contain an array of units assigned to them
        let unitlist = []
        unitlist.push(profile)
        const siteprofile = {
          idnum: payload.idnum.trim(),
          group: payload.group,
          sitekey: key,
          siteunitsprofile: unitlist,
        }
        firebase.database().ref('SITEPROFILES').child(payload.idnum.trim()).set(siteprofile)
          .then((data) => {
          })
          .catch((error) => {
            console.log(error)
          })
        // assign the safe given to this site
        console.log(key)
      })
      .catch((error) => {
        console.log(error)
      })
    // Reach out to firebase and store it
  },
  removeSite({ commit, state }, payload) {
    // fb key to the item we want to remove
    const profilekey = payload.idnum
    const key = payload.sitekey
    console.log('user removing site is ', state.user)
    let rmdate = moment().format('YYYY-MM-DD')
    let actionrecordrm = {
      user: state.user,
      actions: 'delete',
      description: 'removed site attempt',
      timestamp: Date.now(),
      meta: key
    }
    firebase.database().ref('AUDITLOG').child(rmdate).push(actionrecordrm)
      .catch((error) => {
        console.log(error)
        commit('setLoading', false)
      })
    if (state.user.email !== 'mitchell@paythings.com') {
      return
    }
    commit('setLoading', true)
    firebase.database().ref('SITEPROFILES').child(profilekey).remove()
      .catch((error) => {
        console.log(error)
        commit('setLoading', false)
      })
    firebase.database().ref('SITES').child(key).remove()
      .catch((error) => {
        console.log(error)
        commit('setLoading', false)
      })
    let actionrecord = {
      user: state.user,
      actions: 'delete',
      description: 'removed site',
      timestamp: Date.now(),
      meta: key
    }
    let date = moment().format('YYYY-MM-DD')
    firebase.database().ref('AUDITLOG').child(date).push(actionrecord)
      .catch((error) => {
        console.log(error)
        commit('setLoading', false)
      })
    commit('setLoading', false)
    // Reach out to firebase and store it
  },
  loadCIT({ commit }, payload) {
    let machineid = payload.crypto_idnum
    commit('setLoading', true)
    // e2c SAFEANDSOUND SS-SIM deposits
    let citevents = []
    firebase.database().ref('e2c').child('SAFEANDSOUND').child(machineid).child('cashintransit').limitToLast(50).once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          console.log('$$$$$$$ MW safe CIT obj ', obj)
          citevents.push({
            timestamp: obj[key].s,
            guid: obj[key].guid,
            total: obj[key].t,
            bills: obj[key].b,
            values: obj[key].v
          })
        }
        console.log('****** our cits ', citevents)
        // markhere
        commit('setCITValues', citevents)
        // orders are added by time, lets put the newest at the start of the array
        // commit('setsafestatus', safes)
        commit('setLoading', false)
      })
      .catch(
        (error) => {
          console.log(error)
          commit('setLoading', false)
        }
      )
  },
  createPostalDeposit({ commit, dispatch }, payload) {
    // from record
    // get shipping label
    // add to db
    const securebagdeposit = {
      safeid: payload.safeid,
      siteid: payload.siteid,
      timestamp: payload.timestamp,
      shipped: false,
      securebagdeposit: payload.securebagdeposit,
    }
    console.log('adding bag action ', securebagdeposit)

    let logbag = firebase.functions().httpsCallable('createSecurityBagDeposit')
    let data = {
      securitybag: payload.securebagdeposit,
      safeid: payload.safeid,
      siteid: payload.siteid,
    }
    logbag(data)
      .then(function (result) {
      })
    let date = moment(payload.timestamp).format('YYYY-MM-DD')
    let key
    firebase.database().ref('SECURITYBAGSYSTEM').child(payload.safeid).child('securebagdeposit').child(date).push(securebagdeposit)
      .then((data) => {
        key = data.key
        console.log('bag key returned ', key)
        dispatch('loadpostaldeposits', payload.safeid)

        return key
      })
      .catch((error) => {
        console.log(error)
      })

  },
  createPostalDepositii({ commit }, payload) {
    // from record
    // get shipping label
    // add to db
    let sitedetails = payload.sitedetails
    let shipfrom = {
      'name': sitedetails.sitecontactname,
      'company_name': sitedetails.idnum,
      'phone': sitedetails.sitecontactnumber,
      'address_line1': sitedetails.address,
      'city_locality': sitedetails.city,
      'state_province': sitedetails.state,
      'postal_code': sitedetails.zipcode,
      'country_code': 'US',
      'address_residential_indicator': 'no'
    }
    let shipto = {
      'name': 'Safe & Sound',
      'address_line1': '1234 Someplace',
      'phone': '555-555-1234',
      'city_locality': 'New York',
      'state_province': 'NY',
      'postal_code': '10001',
      'country_code': 'US',
      'address_residential_indicator': 'no'
    }
    let data = {
      ship_from: shipfrom,
      ship_to: shipto,
      postaldeposit: payload.postaldeposit,
      sitedetails: sitedetails,
      pickupstart: payload.pickupstart,
      pickupend: payload.pickupend,
      safeid: payload.safeid,
      email: sitedetails.supportemail
    }
    var createlabel = firebase.functions().httpsCallable('createpackagelabel')
    createlabel(data)
      .then(function (result) {
        let trackdata = {
          actual_delivery_date: '',
          carrier_status_code: '',
          events: [],
          carrier_status_description: '',
          ship_date: result.data.ship_date,
          status_description: '',
          label_download: result.data.label_download,
          tracking_number: result.data.tracking_number
        }
        const postaldeposit = {
          trackdata: trackdata,
          tracking_number: result.data.tracking_number,
          label_download: result.data.label_download,
          shipment_cost: result.data.shipment_cost,
          safeid: payload.safeid,
          siteid: payload.siteid,
          timestamp: payload.timestamp,
          postaldeposit: payload.postaldeposit,
          status: result.data.tracking_status,
        }
        let date = moment(payload.timestamp).format('YYYY-MM-DD')
        // add it to our map
        let maprec = {
          siteid: payload.siteid,
          safeid: payload.safeid,
          tracking_number: result.data.tracking_number,
          packagetype: 'depositbag',
          amount: payload.postaldeposit.DepositAmount
        }
        firebase.database().ref('packagetrackmap').child(result.data.tracking_number).update(maprec)

        let key
        firebase.database().ref('SECURITYBAGSYSTEM').child(payload.safeid).child('securebagdeposit').child(date).push(postaldeposit)
          .then((data) => {
            key = data.key
            return key
          })
          .catch((error) => {
            console.log(error)
          })
        // Read result of the Cloud Function.
      }).catch(function (error) {
        // Getting the Error details.
        console.log('error ', error)
      })
  },
  loadallexternalchangeorders({ commit }, payload) {
    // console.log('load these change orders', payload)
    let externalchangeorders = firebase.functions().httpsCallable('getchangeorderlist')
    externalchangeorders()
      .then(function (result) {
        // we get the top level node so its a lot of padding here
        // we have to loop thru all the sites, then the records, then the list of the requests
        let reqList = []
        let orders = result.data.orders
        let entries = []
        console.log('from results ', result.data)
        entries = Object.keys(orders)
        entries.forEach(element => {
          let entry = orders[element].requested
          let keys = Object.keys(entry)
          for (let i = 0; i < keys.length; i++) {
            // pop this record key in the objectt
            let rec = entry[keys[i]]
            Object.assign(rec, { recordkey: keys[i] })
            reqList.push(rec)
          }
        })
        commit('setLoadedChangeOrders', reqList)

        // Read result of the Cloud Function.
      }).catch(function (error) {
        // Getting the Error details.
        console.log('error ', error)
      })
    // is the current user admin? pass the context of the user and let it be checked
    // commit('setLoading', true)
    // reach out to cloud functions to get the configured external change order system and get its list

    // user may not have the proper permissions to do this action
  },
  stoprealtimepostaldeposits({ commit }, payload) {
    let safeid = payload
    firebase.database().ref('SECURITYBAGSYSTEM').child(safeid).child('securebagdeposit').off()
  },
  stoprealtimepostalshipments({ commit }, payload) {
    let safeid = payload
    firebase.database().ref('POSTALSYSTEM').child(safeid).child('postalshipment').off()
  },
  createPostalLabel({ commit, dispatch }, payload) {
    // mrmr postalmark

    // add error that you must select bags to ship

    // from record
    // get shipping label
    // add to db
    let sitedetails = payload.sitedetails
    console.log('site details is ', sitedetails)
    let contactname = sitedetails.idnum
    if (sitedetails.sitecontactname) {
      contactname = sitedetails.sitecontactname
    }
    let shipfrom = {
      'name': contactname,
      'company_name': sitedetails.idnum,
      'phone': sitedetails.sitecontactnumber,
      'address_line1': sitedetails.address,
      'city_locality': sitedetails.city,
      'state_province': sitedetails.state,
      'postal_code': sitedetails.zipcode,
      'country_code': 'US',
      'address_residential_indicator': 'no'
    }
    let shipto = {
      'name': 'Safe & Sound',
      'address_line1': '1234 Someplace',
      'phone': '555-555-1234',
      'city_locality': 'New York',
      'state_province': 'NY',
      'postal_code': '10001',
      'country_code': 'US',
      'address_residential_indicator': 'no'
    }
    let data = {
      ship_from: shipfrom,
      ship_to: shipto,
      ship_date: payload.ship_date,
      securebagdeposit: payload.securebagdeposit,
      contents: payload.contents,
      sitedetails: sitedetails,
      pickupstart: payload.pickupstart,
      pickupend: payload.pickupend,
      safeid: payload.safeid,
      email: sitedetails.supportemail
    }

    // demo function name is democreatepackagelabel
    let cloudfunctionname = 'createpackagelabel'
    if (sitedetails.group === 'Dunbar') {
      cloudfunctionname = 'democreatepackagelabel'
    }
    console.log('we would use ', cloudfunctionname)
    var createlabel = firebase.functions().httpsCallable(cloudfunctionname)
    createlabel(data)
      .then(function (result) {
        console.log('we got a result back ', result)
        let trackdata = {
          actual_delivery_date: '',
          carrier_status_code: '',
          events: [],
          carrier_status_description: '',
          ship_date: result.data.ship_date,
          status_description: '',
          label_download: result.data.label_download,
          tracking_number: result.data.tracking_number
        }
        const postaldeposit = {
          trackdata: trackdata,
          used: false,
          tracking_number: result.data.tracking_number,
          label_download: result.data.label_download,
          shipment_cost: result.data.shipment_cost,
          safeid: payload.safeid,
          siteid: payload.siteid,
          timestamp: payload.timestamp,
          contents: payload.contents,
          status: result.data.tracking_status,
        }
        let date = moment(payload.timestamp).format('YYYY-MM-DD')
        let maprec = {
          siteid: payload.siteid,
          safeid: payload.safeid,
          tracking_number: result.data.tracking_number,
          packagetype: 'depositbag',
          contents: payload.contents
        }
        firebase.database().ref('packagetrackmap').child(result.data.tracking_number).update(maprec)

        // mark these content bags as shipped and with the tracking number
        // get the key values of the contents
        let shippedsecuritybags = payload.contents
        // for each of these postal security bags
        // get the last 30 days of security bags
        for (let item of shippedsecuritybags) {
          // days of security bags to look thru to find this one
          let itemkey = item.key
          let datekey = moment(item.timestamp).format('YYYY-MM-DD')
          let updaterec = {
            tracking_number: result.data.tracking_number,
            shipped: true
          }
          firebase.database().ref('SECURITYBAGSYSTEM').child(payload.safeid).child('securebagdeposit').child(datekey).child(itemkey).update(updaterec)
            .then((data) => {
              console.log('loading postal deposits ')
              dispatch('loadpostaldeposits', payload.safeid)
            })
            .catch((error) => {
              console.log(error)
            })
          // dispatch a call to update our security bag list from this site as the values have changed
        }
        // let actionrecord = {
        //   user: state.user,
        //   actions: 'created shipment',
        //   description: 'package shipping created',
        //   timestamp: Date.now(),
        //   meta: "postal"
        // }
        // let auditdate = moment().format('YYYY-MM-DD')

        // firebase.database().ref('AUDITLOG').child(auditdate).push(actionrecord)
        // .catch((error) => {
        //   console.log(error)
        // })
        // add the tracking number to the record
        // mark them as shipped
        //

        // log the shipment and its contents
        let key
        firebase.database().ref('POSTALSYSTEM').child(payload.safeid).child('postalshipment').child(date).push(postaldeposit)
          .then((data) => {
            key = data.key
            return key
          })
          .catch((error) => {
            console.log(error)
          })
        let sitekey = ''
        sitekey = sitedetails.sitekey
        firebase.database().ref('USPSPICKUPSYSTEM').child('requestqueue').child(sitekey).push(postaldeposit)
          .then((data) => {
            console.log('added pickup request to queue ')
          })
          .catch((error) => {
            console.log(error)
          })
        // Read result of the Cloud Function.
      }).catch(function (error) {
        // Getting the Error details.
        console.log('error ', error)
      })
  },
  loadcheckedinpackages({ commit }) {
    commit('setCheckedPackages', [])

    firebase.database().ref('packages_checkedin').limitToFirst(500).once('value')
      .then((data) => {
        let obj = data.val()
        let trackingnumbers = []
        let packages = []
        trackingnumbers = Object.keys(obj)
        for (let number of trackingnumbers) {
          let shipments = obj[number]
          for (let entrykey in shipments) {
            let shipment = shipments[entrykey]
            Object.assign(shipment, { entrykey: entrykey })
            packages.push(shipment)
          }
        }

        commit('setCheckedPackages', packages)
      })
  },
  loadcheckedinpackages_v2({ commit }) {
    console.log('LOADING v2 checked packages')
    commit('setCheckedPackages', [])
    const NUM_DAYS = 90
    let startdate = moment().subtract(NUM_DAYS, 'days')
    let enddate = moment()
    let span = enddate.diff(startdate, 'days')
    let datesarr = []
    // add the first date
    // check to see if we add more and how many
    if (span > 0) {
      for (let i = 0; i < span; i++) {
        datesarr.push(moment(startdate).add((1 + i), 'day').format('YYYY-MM-DD'))
      }
    }
    let PromArr = []
    let packages = []
    // loop through the span
    for (let day of datesarr) {
      let prom = firebase.database().ref('packages_checkedin_v2').child(day).once('value')
        .then((data) => {
          if (!data.val()) {
            // console.log('nothing here')
            return
          }
          let obj = data.val()
          let trackingnumbers = []
          trackingnumbers = Object.keys(obj)

          for (let number of trackingnumbers) {
            let shipments = obj[number]
            for (let entrykey in shipments) {
              let shipment = shipments[entrykey]
              Object.assign(shipment, { entrykey: entrykey })
              Object.assign(shipment, { dbdateref: day })
              packages.push(shipment)
            }
          }
          // commit('setCheckedPackages', packages)
        })
      PromArr.push(prom)
    }
    Promise.all(PromArr).then(function (values) {
      console.log('checked in packages v2 END', packages)
      commit('setCheckedPackages', packages)
    }).then(() => { })

    // firebase.database().ref('packages_checkedin').limitToFirst(500).once('value')
    // .then((data) => {
    //   let obj = data.val()
    //   let trackingnumbers = []
    //   let packages = []
    //   trackingnumbers = Object.keys(obj)
    //   console.log('checked in ', obj)
    //   for (let number of trackingnumbers) {
    //     let shipments = obj[number]
    //     for (let entrykey in shipments) {
    //       console.log('entry ', entrykey)
    //       console.log(shipments[entrykey])
    //       let shipment = shipments[entrykey]
    //       Object.assign(shipment, { entrykey: entrykey })
    //       packages.push(shipment)
    //     }
    //   }
    //   console.log(packages)

    //   commit('setCheckedPackages', packages)
    // })
  },
  async loadallpackages({ commit }) {
    commit('setLoading', true)
    let allpackref = await firebase.database().ref('packagetrackmap').once('value')
    let allpacks = allpackref.val()
    let tracking_numbers = []
    if (allpacks) {
      tracking_numbers = Object.keys(allpacks)
    }
    commit('setAllPackageTrackingNumbers', tracking_numbers)

    commit('setLoading', false)
  },
  clearShipmentDetail({ commit, state }) {
    commit('setShipmentDetail', '')
  },
  clearCheckedDetail({ commit, state }) {
    commit('setCheckedDetail', '')
  },
  loadShipmentDetail({ commit, state }, payload) {
    let tracking_number = payload
    commit('setLoading', true)
    commit('setShipmentDetail', '')
    firebase.database().ref('packagelist').child(tracking_number).once('value')
      .then((data) => {
        let detail = data.val()
        console.log('got bag details ', detail)
        commit('setShipmentDetail', detail)
        commit('setLoading', false)
      })
      .catch(
        (error) => {
          console.log(error)
          commit('setShipmentDetail', '')
          commit('setLoading', false)
        }
      )
  },
  loadPackageMapDetails({ commit }, payload) {
    let trackingNumbers = payload
    // load an array of package map details
  },
  async checkPackageIn_v2({ commit, state }, payload) {
    let shipment = payload
    if (shipment) {
      console.log('checking in ', shipment)
      // lets get the shipment contents and such also
      let detailref = await firebase.database().ref('packagetrackmap').child(shipment.tracking_number).once('value')
      let packdetail = detailref.val()
      if (packdetail) {
        Object.assign(shipment, { contents: packdetail.contents })
        Object.assign(shipment, { safeid: packdetail.safeid })
        Object.assign(shipment, { siteid: packdetail.siteid })
        Object.assign(shipment, { contents: packdetail.contents })
      }
      let checkintime = Date.now()
      Object.assign(shipment, { checkintime: checkintime })
      Object.assign(shipment, { checkinuid: firebase.auth().currentUser.uid })
      Object.assign(shipment, { checkinemail: firebase.auth().currentUser.email })
      Object.assign(shipment, { checkedin: true })
      Object.assign(shipment, { validated: false })
      Object.assign(shipment, { senttobank: false })
      // i also need to know which site has a package checked in
      let date = moment().format('YYYY-MM-DD')
      firebase.database().ref('packages_checkedin_v2').child(date).child(shipment.tracking_number).push(shipment)
        .then(() => {
          console.log('package is checked in')
          firebase.database().ref('packagetrackmap').child(shipment.tracking_number).update({ checkedin: true })
        })
      if (shipment.duplicated) {
        firebase.database().ref('packages_duplicated').child(shipment.tracking_number).push(shipment)
          .then(() => {
            console.log('dup package is checked in')
          })
      }
    }
  },
  async checkPackageIn({ commit, state }, payload) {
    let shipment = payload
    if (shipment) {
      console.log('checking in ', shipment)
      // lets get the shipment contents and such also
      let detailref = await firebase.database().ref('packagetrackmap').child(shipment.tracking_number).once('value')
      let packdetail = detailref.val()
      if (packdetail) {
        Object.assign(shipment, { contents: packdetail.contents })
        Object.assign(shipment, { safeid: packdetail.safeid })
        Object.assign(shipment, { siteid: packdetail.siteid })
        Object.assign(shipment, { contents: packdetail.contents })
      }
      let checkintime = Date.now()
      Object.assign(shipment, { checkintime: checkintime })
      Object.assign(shipment, { checkinuid: firebase.auth().currentUser.uid })
      Object.assign(shipment, { checkinemail: firebase.auth().currentUser.email })
      Object.assign(shipment, { checkedin: true })
      Object.assign(shipment, { validated: false })
      Object.assign(shipment, { senttobank: false })
      // i also need to know which site has a package checked in
      firebase.database().ref('packages_checkedin').child(shipment.tracking_number).push(shipment)
        .then(() => {
          console.log('package is checked in')
          firebase.database().ref('packagetrackmap').child(shipment.tracking_number).update({ checkedin: true })
        })
      if (shipment.duplicated) {
        firebase.database().ref('packages_duplicated').child(shipment.tracking_number).push(shipment)
          .then(() => {
            console.log('dup package is checked in')
          })
      }
    }
  },
  loadcheckedinpackages_v2({ commit }) {
    console.log('LOADING v2 checked packages')
    commit('setCheckedPackages', [])
    const NUM_DAYS = 90
    let startdate = moment().subtract(NUM_DAYS, 'days')
    let enddate = moment()
    let span = enddate.diff(startdate, 'days')
    let datesarr = []
    // add the first date
    // check to see if we add more and how many
    if (span > 0) {
      for (let i = 0; i < span; i++) {
        datesarr.push(moment(startdate).add((1 + i), 'day').format('YYYY-MM-DD'))
      }
    }
    let PromArr = []
    let packages = []
    // loop through the span
    for (let day of datesarr) {
      let prom = firebase.database().ref('packages_checkedin_v2').child(day).once('value')
        .then((data) => {
          if (!data.val()) {
            // console.log('nothing here')
            return
          }
          let obj = data.val()
          let trackingnumbers = []
          trackingnumbers = Object.keys(obj)

          for (let number of trackingnumbers) {
            let shipments = obj[number]
            for (let entrykey in shipments) {
              let shipment = shipments[entrykey]
              Object.assign(shipment, { entrykey: entrykey })
              Object.assign(shipment, { dbdateref: day })
              packages.push(shipment)
            }
          }
          // commit('setCheckedPackages', packages)
        })
      PromArr.push(prom)
    }
    Promise.all(PromArr).then(function (values) {
      console.log('checked in packages v2 END', packages)
      commit('setCheckedPackages', packages)
    }).then(() => { })

    // firebase.database().ref('packages_checkedin').limitToFirst(500).once('value')
    // .then((data) => {
    //   let obj = data.val()
    //   let trackingnumbers = []
    //   let packages = []
    //   trackingnumbers = Object.keys(obj)
    //   console.log('checked in ', obj)
    //   for (let number of trackingnumbers) {
    //     let shipments = obj[number]
    //     for (let entrykey in shipments) {
    //       console.log('entry ', entrykey)
    //       console.log(shipments[entrykey])
    //       let shipment = shipments[entrykey]
    //       Object.assign(shipment, { entrykey: entrykey })
    //       packages.push(shipment)
    //     }
    //   }
    //   console.log(packages)

    //   commit('setCheckedPackages', packages)
    // })
  },
  loadcheckedinpackages({ commit }) {
    commit('setCheckedPackages', [])

    firebase.database().ref('packages_checkedin').limitToFirst(500).once('value')
      .then((data) => {
        let obj = data.val()
        let trackingnumbers = []
        let packages = []
        trackingnumbers = Object.keys(obj)
        for (let number of trackingnumbers) {
          let shipments = obj[number]
          for (let entrykey in shipments) {
            let shipment = shipments[entrykey]
            Object.assign(shipment, { entrykey: entrykey })
            packages.push(shipment)
          }
        }

        commit('setCheckedPackages', packages)
      })
  },
  loadCheckedDetailArray({ commit }, payload) {
    let tracking_numbers = []
    tracking_numbers = payload
    commit('setLoading', true)
    commit('setCheckedArrayDetail', '')
    for (let packagenumber of tracking_numbers) {
      console.log('look up ', packagenumber)
    }
  },
  loadCheckedDetail({ commit, state }, payload) {
    let tracking_number = payload
    commit('setLoading', true)
    commit('setCheckedDetail', '')
    firebase.database().ref('packages_checkedin').child(tracking_number).once('value')
      .then((data) => {
        let detail = data.val()
        let packages = []
        if (detail) {
          packages = Object.values(detail)
          console.log('got bag details ', packages)
        }
        commit('setCheckedDetail', packages)
        commit('setLoading', false)
      })
      .catch(
        (error) => {
          console.log(error)
          commit('setShipmentDetail', '')
          commit('setLoading', false)
        }
      )
  },
  loadpackages_staged({ commit, state }, payload) {
    // gets for a single site
    // firebase.database().ref('POSTALSYSTEM').child(safeid).child('postalshipment').child(date).once('value')
    // get site list for group
    // get safe id for site
    // getall the shipments
    // filter by date range
    // this is going to be expensive but they are paying for it
    console.log('running group postal shipments')
    commit('setLoading', true)
    // let grp = params.group

    let startdate = moment('2022-09-01', 'YYYY-MM-DD')
    let enddate = moment('2023-01-04', 'YYYY-MM-DD')
    let span = enddate.diff(startdate, 'days')
    let datesarr = []
    // add the first date
    datesarr.push('2022-09-01')
    // check to see if we add more and how many
    if (span > 0) {
      for (let i = 0; i < span; i++) {
        datesarr.push(moment(startdate).add((1 + i), 'day').format('YYYY-MM-DD'))
      }
    }
    let groupunits = []
    let sitelabelrec = []
    let groupshipments = []
    // filter the loaded sites for our group
    let groupsites = state.loadedSites
    // look up the profile for each site
    for (let index in groupsites) {
      let siteid = groupsites[index].idnum
      if (state.siteprofiles[siteid]) {
        let unitid
        // its got a weird struct in the db for speed but its unit per site even tho its an array
        if (state.siteprofiles[siteid].siteunitsprofile) {
          if (state.siteprofiles[siteid].siteunitsprofile[0].crypto_idnum) {
            unitid = state.siteprofiles[siteid].siteunitsprofile[0].crypto_idnum
            let rec = {
              siteid: siteid,
              unitid: unitid,
            }
            sitelabelrec.push(rec)
            groupunits.push(unitid)
          }
        }
      }
    }
    // get unique units list by unit id
    // const uniqueunits = [...new Set(groupunits.map(rec => rec.unitid))]
    const uniqueunits = [...new Set(groupunits)]
    // push all the safe ids into an array
    // get each from the database
    // summarize these by note type
    // summarize these by manual drop
    // get total sum
    let PromArr = []
    // mrmr we will loop by site rather than by day but this works out well in terms of the pattern july 3rd
    for (let calday in datesarr) {
      for (let key in uniqueunits) {
        // get data for this safe unit id num from firebase
        // let today = moment(new Date()).format('DD-MM-YYYY')
        let safeidnum = uniqueunits[key]
        // firebase.database().ref('POSTALSYSTEM').child(safeidnum).child('postalshipment').child(datesarr[calday]).once('value')
        let prom = firebase.database().ref('POSTALSYSTEM').child(safeidnum).child('postalshipment').child(datesarr[calday]).once('value')
          .then((data) => {
            let notedata = []
            const obj = data.val()
            if (obj) {
              // if we have something to do lets format us up a nice record so the complexity isnt in the view
              // get that site label
              let siteidnum = ''
              for (let entry in sitelabelrec) {
                if (safeidnum === sitelabelrec[entry].unitid) {
                  siteidnum = sitelabelrec[entry].siteid
                }
              }
              let values = Object.values(obj)
              console.log('#######  shipment found ', values[0])
              let entry = values[0]
              let verified = 'unknown'
              if (entry.verifiedstatus) {
                verified = 'verified'
              }
              let sum = 0
              if (entry.contents) {
                entry.contents.forEach(item => {
                  sum += item.securebagdeposit.DepositAmount
                })
              }
              if (entry.status_description) {
                console.log('DESCR!!!!!', entry.status_description)
                return
              }
              groupshipments.push({
                siteid: siteidnum,
                safeid: safeidnum,
                timestamp: entry.timestamp,
                totalcurrency: sum,
                contents: entry.contents,
                shipment_cost: data.shipment_cost,
                group: entry.group,
                actual_delivery_date: '',
                carrier_status_code: '',
                carrier_status_description: '',
                events: [],
                label_url: '',
                ship_date: '',
                trackdata: entry.trackdata,
                verifiedstatus: verified,
                verifiedcash: entry.verifiedcash,
                verifiedtimestamp: entry.verifiedtimestamp,
                status_description: 'initial_create',
                tracking_number: entry.tracking_number
              })
              // if the postal api hasn't said anything yet, we need to handle this and still list it

              // console.log(' data for this group is ', graphdata)
              // groupeod.push(graphdata)
              // key is the date
              // value is an array of note in events for that specific day
            }
            return notedata
          })
          .catch((error) => {
            let nodata = []
            console.log(error)
            return nodata
          })
        // this code is actually executed before the above. I know its weird.
        PromArr.push(prom)
      }
    }
    Promise.all(PromArr).then(function (values) {
      console.log('group postal shipments END')
    }).then(() => {
      console.log('end of promise all for staged')
      for (let shipment of groupshipments) {
        firebase.database().ref('packagetracking').child(shipment.tracking_number).once('value')
          .then((data) => {
            let shipdata = data.val()
            if (shipdata) {

            }
            console.log('####### shipment on data ', shipdata)
            if (shipdata.verifiedstatus) {
              shipment.verifiedstatus = shipdata.verifiedstatus
            }

            shipment.actual_delivery_date = ''

            if (shipdata && shipdata.actual_delivery_date) {
              shipment.actual_delivery_date = shipdata.actual_delivery_date
            }
            if (shipdata && shipdata.carrier_status_code) {
              shipment.carrier_status_code = shipdata.carrier_status_code
            }
            if (shipdata && shipdata.carrier_status_description) {
              shipment.carrier_status_description = shipdata.carrier_status_description
            }
            if (shipdata && shipdata.events) {
              shipment.events = shipdata.events
            }
            if (shipdata && shipdata.label_url) {
              shipment.label_url = shipdata.label_url
            }
            if (shipdata && shipdata.ship_date) {
              shipment.ship_date = shipdata.ship_date
            }
            if (shipdata && shipdata.status_code) {
              shipment.status_code = shipdata.status_code
            }
            if (shipdata && shipdata.status_description) {
              shipment.status_description = shipdata.status_description
            }
            if (shipdata && shipdata.tracking_number) {
              shipment.tracking_number = shipdata.tracking_number
            }
            // if data is null, we have not been informed of it moving
          })
      }
    }).then(() => {
      commit('setPostalPackages', groupshipments)
      commit('setLoading', false)
    })
    // now do a promise all and get the shipping status data for each
  },
  loadpackagesstaged({ commit, state }, payload) {
    let safelist = []
    safelist = payload

    console.log('staged 3764 ')
    // posstalsystem
    // get packages
    // get the shipment number
    // look up shipping number in
    // packagetracking by shipment number
    let packages = []
    for (let safeid of safelist) {
      firebase.database().ref('POSTALSYSTEM').child(safeid).child('postalshipment').limitToLast(100).once('value')
        .then((data) => {
          // mrmrmail
          // get sitename for this safe
          // sitedetails = state.sites.find(entry => entry.sitekey === sitekey)
          // state.profiles
          // state.siteprofiles[site.idnum]
          let siteid = ''
          let sitekey = ''
          let group = ''
          let profiles = Object.values(state.siteprofiles)
          profiles.forEach(profile => {
            if (profile.siteunitsprofile && profile.siteunitsprofile[0]) {
              if (profile.siteunitsprofile[0].crypto_idnum) {
                if (profile.siteunitsprofile[0].crypto_idnum === safeid) {
                  sitekey = profile.sitekey
                  siteid = profile.idnum
                  group = profile.group
                }
              }
            }
          })
          let records = data.val()

          // each record get the shipment IDs and look up their status
          for (let index in records) {
            let shipment = Object.values(records[index])[0] // messy
            console.log('shipment ', shipment, index, safeid)
            if (moment(shipment.timestamp).format('YYYY') === '2023') {
              // console.log('FOUND 2023!!!!!!! ', shipment)
            }
            let totalcurrency = 0
            if (shipment.contents) {
              totalcurrency = shipment.contents.reduce((acc, val) => acc + val.securebagdeposit.DepositAmount, 0)
            }
            // if the postal api hasn't said anything yet, we need to handle this and still list it
            let verifiedstatus = false
            // if shipment is not older than 6 months
            let start = moment(shipment.timestamp) // some random moment in time (in ms)
            let end = moment() // some random moment after start (in ms)
            let duration = moment.duration(end.diff(start))

            if (duration.asMonths() < 3) {
              let shipStatusRec = {
                siteid: siteid,
                safeid: safeid,
                sitekey: sitekey,
                timestamp: shipment.timestamp,
                totalcurrency: totalcurrency,
                contents: shipment.contents,
                shipment_cost: shipment.shipment_cost,
                group: group,
                actual_delivery_date: '',
                carrier_status_code: '',
                carrier_status_description: '',
                events: [],
                label_url: '',
                ship_date: '',
                status_code: '',
                status_description: 'initial_create',
                verifiedstatus: verifiedstatus,
                tracking_number: shipment.tracking_number
              }
              if (shipment && shipment.tracking_number) {
                firebase.database().ref('packagetracking').child(shipment.tracking_number).once('value')
                  .then((data) => {
                    let shipdata = data.val()
                    if (shipdata) {

                    }
                    // console.log('####### shipment on data ', shipdata)
                    if (shipdata && shipdata.verifiedstatus) {
                      shipStatusRec.verifiedstatus = shipdata.verifiedstatus
                    }

                    shipStatusRec.actual_delivery_date = ''

                    if (shipdata && shipdata.actual_delivery_date) {
                      shipStatusRec.actual_delivery_date = shipdata.actual_delivery_date
                    }
                    if (shipdata && shipdata.carrier_status_code) {
                      shipStatusRec.carrier_status_code = shipdata.carrier_status_code
                    }
                    if (shipdata && shipdata.carrier_status_description) {
                      shipStatusRec.carrier_status_description = shipdata.carrier_status_description
                    }
                    if (shipdata && shipdata.events) {
                      shipStatusRec.events = shipdata.events
                    }
                    if (shipdata && shipdata.label_url) {
                      shipStatusRec.label_url = shipdata.label_url
                    }
                    if (shipdata && shipdata.ship_date) {
                      shipStatusRec.ship_date = shipdata.ship_date
                    }
                    if (shipdata && shipdata.status_code) {
                      shipStatusRec.status_code = shipdata.status_code
                    }
                    if (shipdata && shipdata.status_description) {
                      shipStatusRec.status_description = shipdata.status_description
                    }
                    if (shipdata && shipdata.tracking_number) {
                      shipStatusRec.tracking_number = shipdata.tracking_number
                    }
                    // if data is null, we have not been informed of it moving
                  })
                packages.push(shipStatusRec)
              }

            }
          }
        })
      console.log('packages data ', packages)
      commit('setPostalPackages', packages)
    }
  },



  async loadFIData({ commit, state }, payload) {
    commit('setLoading', true)

    // take in the FI key
    // get list of their sites

    console.log('fi data payload ', payload, state.user)
    // final values
    let FIEODs = []
    let FICITs = []
    let FIKey = payload.FIKey

    // let UserFiKey = ''
    // if (state.user?.institution?.key) {
    //   UserFiKey = state.user?.institution?.key
    // }
    // let FIKey = UserFiKey
    // if (!FIKey) {
    //   return
    // }
    const userinstitutions = []
    let sitekeys = []
    let finame = ''
    let firef = await firebase.database().ref('Institutions').child(FIKey).once('value')
    let fidata = firef.val()
    if (fidata) {
      finame = fidata.name
      sitekeys = fidata.sitekeys
    }
    // get the safe assigned to these site keys
    // mrmr fi
    let sitenames = []
    let PromArr = []
    for (let key of sitekeys) {
      let prom = firebase.database().ref('SITES').child(key).once('value')
        .then((data) => {
          return data.val()
        })
      PromArr.push(prom)
    }
    await Promise.all(PromArr).then(function (values) {
      sitenames = values.map(entry => entry.idnum)
      // we have all our site names
    })
    console.log('getting site profiles now')
    let siteprofiles = []
    // get all our site profiles
    let PromArrProfiles = []
    for (let sitename of sitenames) {
      let prom = firebase.database().ref('SITEPROFILES').child(sitename).once('value')
        .then((data) => {
          return data.val()
        })
        .catch((err) => {
          console.log(sitename, err)
        })
      PromArrProfiles.push(prom)
    }
    await Promise.all(PromArrProfiles).then(function (values) {
      // might have a profile but remove the safe present
      // check for this
      values.forEach(entry => {
        if (entry.siteunitsprofile && entry.siteunitsprofile[0].crypto_idnum) {
          if (!entry.siteunitsprofile[0].crypto_idnum.includes('VirtualSafe')) {
            if (!entry.siteunitsprofile[0].crypto_idnum.includes('Postal')) {
              siteprofiles.push({
                sitename: entry.idnum,
                group: entry.group,
                sitekey: entry.sitekey,
                safeid: entry.siteunitsprofile[0].crypto_idnum,
              })
            }
          }
        }
      })
      // we have all our site names
    })
    // get the eod data for each safeid for last 7 days
    let startdate = moment(payload.startdate, 'YYYY-MM-DD')
    let enddate = moment(payload.enddate, 'YYYY-MM-DD')
    let span = enddate.diff(startdate, 'days')
    let datesarr = []
    // add the first date
    datesarr.push(payload.startdate)
    // check to see if we add more and how many
    if (span > 0) {
      for (let i = 0; i < span; i++) {
        datesarr.push(moment(startdate).add((1 + i), 'day').format('YYYY-MM-DD'))
      }
    }
    // prmoise all
    let PromArrEOD = []
    for (let date of datesarr) {
      for (let entry of siteprofiles) {
        console.log('dates ', date, entry.safeid)
        let prom = firebase.database().ref('e2c').child('EODRECS').child(date).child(entry.safeid).once('value')
          .then((data) => {
            let datarec = data.val()
            let eodrec = {
              ones: 0,
              twos: 0,
              fives: 0,
              tens: 0,
              twenties: 0,
              fifties: 0,
              hundreds: 0,
              sumdrops: 0,
              sumvalidated: 0,
              sum: 0,
            }
            if (datarec && datarec.ones) {
              eodrec.ones = datarec.ones
            }
            if (datarec && datarec.twos) {
              eodrec.twos = datarec.twos
            }
            if (datarec && datarec.fives) {
              eodrec.fives = datarec.fives
            }
            if (datarec && datarec.tens) {
              eodrec.tens = datarec.tens
            }
            if (datarec && datarec.twenties) {
              eodrec.twenties = datarec.twenties
            }
            if (datarec && datarec.fifties) {
              eodrec.fifties = datarec.fifties
            }
            if (datarec && datarec.hundreds) {
              eodrec.hundreds = datarec.hundreds
            }
            if (datarec && datarec.sumdrops) {
              eodrec.sumdrops = datarec.sumdrops
            }
            if (datarec && datarec.sumvalidated) {
              eodrec.sumvalidated = datarec.sumvalidated
            }
            if (datarec && datarec.sum) {
              eodrec.sum = datarec.sum
            }
            let rec = {
              date: date,
              timestamp: moment(date).valueOf(),
              sitename: entry.sitename,
              safeid: entry.safeid,
              eod: eodrec
            }
            return rec
          })
        PromArrEOD.push(prom)
      }
    }
    await Promise.all(PromArrEOD).then(function (values) {
      FIEODs = values
      // sitenames = values.map(entry => entry.idnum)
      // we have all our site names
    })
    // get the last 100 cit events from each safe
    let PromArrCIT = []
    for (let entry of siteprofiles) {
      // mrmr fi
      let citevents = []
      let prom = firebase.database().ref('e2c').child('SAFEANDSOUND').child(entry.safeid).child('cashintransit').limitToLast(150).once('value')
        .then((data) => {
          let datarec = data.val()
          // see if we care about the dates contained in this list
          // could be more than 1 cit on a single date
          if (datarec) {
            for (let key in datarec) {
              let locdate = datarec[key].s
              let timeZone = 'America/New_York'
              let formatime = formatInTimeZone(datarec[key].s, 'America/New_York', 'yyyy-MM-dd HH:mm:ss')
              let formatdate = formatInTimeZone(datarec[key].s, 'America/New_York', 'yyyy-MM-dd')
              // is this event in a date we care about?
              if (datesarr.includes(formatdate)) {
                citevents.push({
                  date: formatdate,
                  timelocal: formatime,
                  safeid: entry.safeid,
                  sitename: entry.sitename,
                  total: datarec[key].t,
                  bills: datarec[key].b
                })
              }
            }
            // we have cit data to look at
            // we have to shift the timestamp from UTC to EST
          }
          return citevents
        })
      PromArrCIT.push(prom)
    }
    await Promise.all(PromArrCIT).then(function (values) {
      values.forEach(val => {
        val.forEach(entry => {
          FICITs.push(entry)
        })
      })
      // sitenames = values.map(entry => entry.idnum)
      // we have all our site names
    })
    FIEODs.forEach(entry => {
      let citsforsite = []
      // console.log('eod ', entry)
      citsforsite = FICITs.filter(cit => cit.sitename === entry.sitename)
      let citsfordate = []
      let citsum = 0
      citsfordate = citsforsite.filter(cit => cit.date === entry.date)
      if (citsfordate.length > 0) {
        citsfordate.forEach(cit => {
          citsum += cit.total
        })
      }
      Object.assign(entry, { citsum: citsum })
      Object.assign(entry, { citnum: citsfordate.length })
    })
    commit('setFIEODs', FIEODs)
    commit('setLoading', false)
  },
  async markchangeorderfilled({ commit, state }, payload) {
    let sitekey = payload.sitekey
    let orderkey = payload.orderkey
    let group = payload.group
    let item = payload
    Object.assign(item, { filledtime: Date.now(), user: firebase.auth().currentUser.email })
    let filleddate = moment().format('YYYY-MM-DD')
    // write it to filled section
    firebase.database().ref('EXTERNALCHANGEORDERS').child('FILLED').child(group).child(sitekey).child(orderkey).update(item)
    firebase.database().ref('EXTERNALCHANGEORDERS').child('FILLEDLOG').child(filleddate).push(item).then(() => {
      // only then remove it after you copied it over
      firebase.database().ref('EXTERNALCHANGEORDERS').child('REQUESTED').child(group).child(sitekey).child(orderkey).remove()
    })
    // delete it from requested section
  },
  async sendChangeOrderRec({ commit, state }, payload) {
    let data = {
      email: firebase.auth().currentUser.email,
      message: 'Your change order request for ' + payload.siteid + ' in the amount of ' + numeral(payload.changeorder.DepositAmount).format('$0,00.00') + ' has been recorded. Please note due to the national coin shortage some orders may be adjusted.'
    }
    let appNotice = firebase.functions().httpsCallable('sendChangeOrderApproval')

    appNotice(data)
      .then(function (result) {
        console.log('we sent the notice')
      }).catch(function (error) {
        // Getting the Error details.
        console.log('error ', error)
      })
    data.email = 'Coin@ssarmored.com'
    appNotice(data)
      .then(function (result) {
        console.log('we sent the notice to vault')
      }).catch(function (error) {
        // Getting the Error details.
        console.log('error ', error)
      })
  },
  async sendChangeOrderApprovedNotice({ commit, state }, payload) {
    console.log('payload approved order ', payload)
    // get site details
    // get site email
    let sitedetails = ''
    let sitekey = payload.sitekey
    // find the site contact info
    sitedetails = state.sites.find(entry => entry.sitekey === sitekey)
    console.log('we send email to ', sitedetails.supportemail)
    let email = ''
    if (sitedetails.supportemail) {
      email = sitedetails.supportemail
    }
    let data = {
      email: email,
      message: 'Your change order request for ' + payload.siteid + ' in the amount of ' + numeral(payload.changeorder.DepositAmount).format('$0,00.00') + ' has been approved by the financial institution. Please note due to the national coin shortage some orders may be adjusted.'
    }
    let appNotice = firebase.functions().httpsCallable('sendChangeOrderApproval')

    appNotice(data)
      .then(function (result) {
        console.log('we sent the notice')
      }).catch(function (error) {
        // Getting the Error details.
        console.log('error ', error)
      })
  },
  async sendChangeOrderDeclineNotice({ commit, state }, payload) {
    console.log('payload decline order ', payload)
    // get site details
    // get site email
    let sitedetails = ''
    let sitekey = payload.sitekey
    // find the site contact info
    sitedetails = state.sites.find(entry => entry.sitekey === sitekey)
    console.log('we send email to ', sitedetails.supportemail)
    let email = ''
    if (sitedetails.supportemail) {
      email = sitedetails.supportemail
    }
    let data = {
      email: email,
      message: 'Your change order request for ' + payload.siteid + ' in the amount of ' + numeral(payload.changeorder.DepositAmount).format('$0,00.00') + ' has been rejected by the financial institution or corporate management. Please contact your bank or corporate management, or try again'
    }
    let rejNotice = firebase.functions().httpsCallable('sendChangeOrderRejection')

    rejNotice(data)
      .then(function (result) {
        console.log('we sent the notice')
      }).catch(function (error) {
        // Getting the Error details.
        console.log('error ', error)
      })
  },
  async removechangeorder({ commit, state }, payload) {
    let sitekey = payload.sitekey
    let orderkey = payload.orderkey
    let group = payload.group
    let item = payload

    Object.assign(item, { filledtime: Date.now(), user: state.user })
    // write it to filled section
    firebase.database().ref('EXTERNALCHANGEORDERS').child('REQUESTED').child(group).child(sitekey).child(orderkey).remove()
    // delete it from requested section
  },
  loadallchangeorders({ commit }, payload) {
    // commit('setLoading', true)
    firebase.database().ref('EXTERNALCHANGEORDERS').child('REQUESTED').once('value')
      .then((data) => {
        let orders = []
        const changeorders = data.val()
        // for each date
        let groups = ''
        if (!changeorders) {
          commit('setLoadedChangeOrders', orders)
          return
        }
        groups = Object.keys(changeorders)
        groups.forEach(entry => {
          let sitekeys = []
          sitekeys = Object.keys(changeorders[entry])
          sitekeys.forEach(site => {
            let requests = []
            requests = changeorders[entry][site]
            let siterequest = {
              group: entry,
              sitekey: site,
              requests: requests
            }
            orders.push(siterequest)
          })
        })
        // for each order in that date
        commit('setLoadedChangeOrders', orders)
      })
      .catch(
        (error) => {
          console.log(error)
          // commit('setLoading', false)
        }
      )
  },
  async loadnotereaderjams({ commit }) {
    // today and x days back
    commit('setLoading', true)
    let jamrecs = []
    let jamlist = []
    try {
      let jameventref = await firebase.database().ref('hardware').child('notejam').limitToLast(50).once('value')
      let jams = jameventref.val()
      for (let day in jams) {
        for (let safe in jams[day]) {
          // console.log('how many jams ', Object.keys(jams[day][safe]))
          // each key here is a rejection entry but its not an iterable list
          let rec = {
            day: day,
            crypto_idnum: safe,
            jamcount: Object.keys(jams[day][safe]).length
          }
          jamrecs.push(rec)
          Object.values(jams[day][safe]).forEach(element => {
            let event = {
              crypto_idnum: safe,
              timestamp: element.TS
            }
            jamlist.push(event)
          })
        }
        // {day machine count}
        // rejectrecs.push(rec)
      }
      commit('setJamEventList', jamlist)
      commit('setJamEvents', jamrecs)
    } catch {

    }
    commit('setLoading', false)
  },
  async loadsystemevents({ commit }, payload) {
    commit('setLoading', true)
    let startrecs = []
    let safeid = payload
    try {
      let systemref = await firebase.database().ref('hardware').child('status').child(safeid).limitToLast(20).once('value')
      let restarts = systemref.val()
      for (let key in restarts) {
        startrecs.push(restarts[key])
      }
    } catch {

    }
    commit('setSystemEvents', startrecs)
    commit('setLoading', false)
  },
  initrealtimestackerevents({ commit }, payload) {
    let siteid = payload
    firebase.database().ref('events').child('notereader').child('stacker').child(siteid).limitToLast(10).on('value', function (snapshot) {
      let stackerevents = []
      commit('setstackerevents', [])

      const obj = snapshot.val()
      for (let key in obj) {
        stackerevents.push({
          key: key,
          timestamp: obj[key].TS,
          type: obj[key].type
        })
      }
      commit('setstackerevents', stackerevents)
    })
  },
  stoprealtimestackerevents({ commit }, payload) {
    let siteid = payload
    firebase.database().ref('events').child('notereader').child('stacker').child(siteid).off()
  },
  loadallpickupschedules({ commit, state }) {
    // get all site keys

    firebase.database().ref('PICKUP_DIRECTOR').once('value')
      .then((data) => {
        let schedules = []
        if (data.val()) {
          let arr = Object.values(data.val())
          arr.forEach(entry => {
            console.log(entry)
            schedules.push(entry.schedule)
          })
        }
        console.log('loaded all pickup schedule for ', schedules)

        commit('setAllPickupSchedules', schedules)
      })
  },
  loadsitePickups({ commit }, payload) {
    let safeid = payload
    firebase.database().ref('CITtesting').child('SAFEANDSOUND').child(safeid).limitToLast(100).once('value')
      .then((data) => {
        if (data.val()) {
          let pickups = []
          pickups = Object.values(data.val())
          console.log('our pick ups ', pickups)
          commit('setsitePickups', pickups)
        }
      })
  },
  async loadweather({ commit }, payload) {
    let city = payload
    // load 7 days back from startdate
    let results = []
    let weatherdata = []
    let dataref = await firebase.database().ref('weather').child(city).limitToLast(14).once('value')
    results = dataref.val()
    for (let day in results) {
      console.log(results[day])
      weatherdata.push({
        day: day,
        conditions: results[day].forecast,
      })
    }
    console.log('nice weather data ', weatherdata)
    commit('setWeather', weatherdata)
  },

  async loadmachinelearning({ commit }, payload) {
    let safeid = payload[0].crypto_idnum
    console.log('ml safeid ', payload)
    let numberofdays = 7
    let days = []
    let mlresults = []
    commit('setmlresults', mlresults)

    for (let i = 0; i < numberofdays; i++) {
      days.push(moment().subtract(i, 'days').format('YYYY-MM-DD'))
    }
    for (let day of days) {
      let mlforday = []
      console.log('ml day ', day, safeid)
      let dataref = await firebase.database().ref('e2c').child('ML').child(day).child(safeid).once('value')
      mlforday = dataref.val()
      if (mlforday) {
        Object.assign(mlforday, { date: day })
        mlresults.push(mlforday)
      }
    }
    console.log('ML results ', mlresults)
    commit('setmlresults', mlresults)
  },
  loadsiteschedule({ commit, state }, payload) {
    let sitekey = payload
    firebase.database().ref('PICKUP_DIRECTOR').child(sitekey).child('schedule').once('value')
      .then((data) => {
        console.log('loaded schedule for ', sitekey, data.val())
        commit('setPickupSchedule', data.val())
      })
  },
  updatesiteschedule({ commit }, payload) {
    let sitekey = payload.sitekey
    let rec = payload
    console.log('site schedule rec ', rec)
    firebase.database().ref('PICKUP_DIRECTOR').child(sitekey).child('schedule').update(rec)
      .then((data) => {
        console.log('updated schedule for ', sitekey, data.val())
      })
  },
  resetfinancialdata({ commit }, payload) {
    if (!payload.safeid || !payload.siteidnum) {
      commit('setError', 'Can not reset safe, insufficient data')
      return
    }
    const safeid = payload.safeid
    const siteidnum = payload.siteidnum
    commit('setLoading', true)
    firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeid).once('value')
      .then((data) => {
        const obj = data.val()
        let now = Date.now()
        firebase.database().ref('e2c').child('SAFEANDSOUND').child(now + safeid).set(obj)
          .then(() => {
            firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeid).remove()
              .then(() => {
                commit('setError', 'Safe Fiancial Data Reset ' + safeid + ' at ' + siteidnum)
              })
              .catch((error) => {
                console.log(error)
                commit('setLoading', false)
              })
          })
        commit('setLoading', false)
      })
    commit('setLoading', false)
  },
  resetallsafedata({ commit, state }, payload) {
    if (!payload.safeid || !payload.siteidnum) {
      commit('setError', 'Can not reset safe, insufficient data')
      return
    }
    const safeid = payload.safeid
    const siteidnum = payload.siteidnum
    let actionrecord = {
      user: state.user,
      actions: 'delete',
      description: 'resetall',
      timestamp: Date.now(),
      meta: payload
    }
    let date = moment().format('YYYY-MM-DD')
    firebase.database().ref('AUDITLOG').child(date).push(actionrecord)
      .catch((error) => {
        console.log(error)
        commit('setLoading', false)
      })
    commit('setLoading', true)
    firebase.database().ref('e2c').child('SAFEANDSOUND').child(safeid).remove()
      .then(
      // console.log('removed safe')
    )
      .catch((error) => {
        console.log(error)
        commit('setLoading', false)
      })
    firebase.database().ref('SITEPROFILES').child(siteidnum).remove()
      .then(
      // console.log('removed profile')
    )
      .catch((error) => {
        console.log(error)
      })
    commit('setError', 'Safe Removed ' + safeid + ' at ' + siteidnum)
    commit('setLoading', false)
  },
  cloneeod({ commit }, payload) {
    let sourceSafeidnum = 'S&S-0123FFD3E02A9627EE'
    let destinationSafeidnum = 'S&S-01232304BB8298FCEE'
    let day = '2020-05-25'
    firebase.database().ref('e2c').child('EODRECS').child(day).child(sourceSafeidnum).once('value')
      .then((data) => {
        const obj = data.val()
        // console.log(obj)
        firebase.database().ref('e2c').child('EODRECS').child(day).child(destinationSafeidnum).set(obj)
        // i need to next migrate the EOD records here we can find them and then clone them with the new destination value. limit to the last 7 cal days
      })
      .catch((error) => {
        console.log(error)
      })
  },
  async migrateallsafedata({ commit }, payload) {
    // copys all data from safe A into safe B
    // really i should just get the top level node and write it to the destination with a set
    const safesource = payload.source
    const safedestination = payload.destination
    commit('setLoading', true)
    let eodref = await firebase.database().ref('e2c').child('SAFEANDSOUND').child(safesource).child('eod').once('value')
    let eoddata = eodref.val()

    // console.log('eod data is ', eoddata)
    if (eoddata) {
      for (let key in eoddata) {
        // console.log(key)
        // push is safe
        let ref = await firebase.database().ref('e2c').child('SAFEANDSOUND').child(safedestination).child('eod').child(key).set(eoddata[key])
        console.log(ref)
      }
    }

    let depref = await firebase.database().ref('e2c').child('SAFEANDSOUND').child(safesource).child('userdeposits').once('value')
    let depdata = depref.val()

    // console.log('depdata is ', depdata)
    if (depdata) {
      for (let key in depdata) {
        // console.log(key)
        // push is safe
        let ref = await firebase.database().ref('e2c').child('SAFEANDSOUND').child(safedestination).child('userdeposits').child(key).set(depdata[key])
        console.log(ref)
      }
    }

    // get cit
    let citref = await firebase.database().ref('e2c').child('SAFEANDSOUND').child(safesource).child('cashintransit').once('value')
    let citdata = citref.val()
    // set cit
    if (citdata) {
      for (let key in citdata) {
        // push is safe
        let ref = await firebase.database().ref('e2c').child('SAFEANDSOUND').child(safedestination).child('cashintransit').child(key).set(citdata[key])
        console.log(ref)
      }
    }
    // get cit
    let cashheldref = await firebase.database().ref('e2c').child('SAFEANDSOUND').child(safesource).child('cashheld').once('value')
    let cashhelddata = cashheldref.val()
    // set cit
    if (cashhelddata) {
      let ref = await firebase.database().ref('e2c').child('SAFEANDSOUND').child(safedestination).child('cashheld').set(cashhelddata)
      console.log(ref)
    }
    commit('setLoading', false)
  },

  loadallfilledchangeorders({ commit }, payload) {
    // commit('setLoading', true)
    let orders = []
    commit('setLoadedFilledChangeOrders', orders)

    firebase.database().ref('EXTERNALCHANGEORDERS').child('FILLED').limitToLast(100).once('value')
      .then((data) => {
        const changeorders = data.val()
        // for each date
        let groups = ''
        groups = Object.keys(changeorders)
        groups.forEach(entry => {
          let sitekeys = []
          sitekeys = Object.keys(changeorders[entry])
          sitekeys.forEach(site => {
            let requests = []
            requests = changeorders[entry][site]

            let siterequest = {
              group: entry,
              sitekey: site,
              requests: requests,
            }
            orders.push(siterequest)
          })
        })
        // for each order in that date
        commit('setLoadedFilledChangeOrders', orders)
      })
      .catch(
        (error) => {
          console.log(error)
          // commit('setLoading', false)
        }
      )
  },
  createPostalBags({ commit }, payload) {
    let trackdata = {
      actual_delivery_date: '',
      carrier_status_code: '',
      events: [],
      carrier_status_description: '',
      ship_date: '',
      status_description: '',
      tracking_number: ''
    }
    const postalbags = {
      safeid: payload.safeid,
      address: payload.sitedetails.address,
      city: payload.sitedetails.city,
      zipcode: payload.sitedetails.zipcode,
      state: payload.sitedetails.state,
      siteid: payload.siteid,
      timestamp: payload.timestamp,
      postalbags: payload.postalbags,
      status: 'Request Sent',
    }
    let key
    let date = moment(payload.timestamp).format('YYYY-MM-DD')
    console.log('safeid ', payload.safeid, date, postalbags, payload.sitedetails)
    if (payload.sitedetails.group === 'Dunbar') {
      console.log('DUNBAR DO NOT SEND DEMO REQUESTS')
      return
    }
    console.log('logging request in db')
    firebase.database().ref('POSTALSYSTEM').child(payload.safeid).child('postalbags').child(date).push(postalbags)
      .then((data) => {
        key = data.key
        // mrmr
        let mailmessage = 'Client site ' + payload.siteid + ' has requested postal supplies' + '\n\n'
        mailmessage += 'Bags: ' + postalbags.postalbags.bags + ' ' + '\n'
        mailmessage += 'Boxes: ' + postalbags.postalbags.boxes + ' ' + '\n\n'
        mailmessage += 'Deposit Slips: ' + '200' + ' ' + '\n\n'
        mailmessage += 'Address: \n' + postalbags.address + '\n' + postalbags.city + ', ' + postalbags.state + '\n' + postalbags.zipcode + '\n'
        let send_dunbar_supply_email_request = firebase.functions().httpsCallable('send_dunbar_supply_email_request')
        send_dunbar_supply_email_request({ message: mailmessage, address: 'mitchell@paythings.com' })
          .then(function (result) {
            console.log('we sent duunbar the request ', result)
          })
        send_dunbar_supply_email_request({ message: mailmessage, address: 'daniel@paythings.com' })
          .then(function (result) {
            console.log('we sent duunbar the request ', result)
          })
        send_dunbar_supply_email_request({ message: mailmessage, address: 'orders@dunbarsecurityproducts.com' })
          .then(function (result) {
            console.log('we sent duunbar the request ', result)
          })
        console.log('returning from email send')
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  createPostalCoinOrder({ commit, state }, payload) {
    let user = {
      bio: 'nothing',
      email: 'mitchell@paythings.com',
      group: 'Mitchelll',
      id: 'xSPKxuIirtY5hv4j3aYGOHiALsg2',
      level: 2000,
      status: 'admin',
      meta: 'default case'
    }
    user = state.user
    let group = payload.group

    let order = {
      changeorder: payload.changeorder,
      group: payload.group,
      sitekey: payload.sitekey,
      timestamp: Date.now(),
      filledtime: Date.now(),
      safeid: payload.safeid,
      siteid: payload.siteid,
      user: firebase.auth().currentUser.uid
    }
    // mrmr
    console.log('adding change order ', order)
    let today = moment().format('YYYY-MM-DD')
    firebase.database().ref('EXTERNALCHANGEORDERS').child('FILLEDLOG').child(today).push(order)
    firebase.database().ref('EXTERNALCHANGEORDERS').child('FILLED').child(group).child(payload.sitekey).push(order)
    // send change order alert
  },
  loadbillingclients({ commit }) {
    console.log('loading billing clients')
    const clients = []
    firebase.database().ref('BILLINGCLIENTS').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          clients.push({
            name: obj[key].name,
            address: obj[key].address,
            state: obj[key].state,
            zip: obj[key].zip,
            city: obj[key].city,
            contact: obj[key].contact,
            phone: obj[key].phone,
            email: obj[key].email,
            key: key,
          })
        }
      })
    commit('setLoadedBillingClients', clients)
  },
  updatebillingclient({ commit }, payload) {
    // mrmr
    let key = payload.key
    const client = {
      name: payload.name,
      address: payload.address,
      state: payload.state,
      city: payload.city,
      zip: payload.zip,
      contact: payload.contact,
      phone: payload.phone,
      email: payload.email,
    }
    firebase.database().ref('BILLINGCLIENTS').child(key).update(client)
  },
  createbillingclient({ commit }, payload) {
    console.log('creating biling client ', payload)
    const client = {
      name: payload.name,
      address: payload.address,
      state: payload.state,
      zip: payload.zip,
      city: payload.city,
      contact: payload.contact,
      phone: payload.phone,
      email: payload.email,
    }
    let key
    firebase.database().ref('BILLINGCLIENTS').push(client)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  removebillingclient({ commit }, payload) {

  },
  loadbillingprofiles({ commit }) {
    console.log('loading billing profiles')
    const profiles = []
    firebase.database().ref('BILLINGPROFILES').once('value')
      .then((data) => {
        const obj = data.val()
        console.log('profiles obj action ', obj)
        for (let key in obj) {
          profiles.push({
            name: obj[key].name,
            locationtype: obj[key].locationtype,
            baserate: obj[key].baserate,
            sentshipmentfee: obj[key].sentshipmentfee,
            changeorderfee: obj[key].changeorderfee,
            platformfee: obj[key].platformfee,
            rentalfee: obj[key].rentalfee,
            bagtrackrate: obj[key].bagtrackrate,
            volumerate: obj[key].volumerate,
            packagerate: obj[key].packagerate,
            insurancerate: obj[key].insurancerate,
            timestamp: obj[key].timestamp,
            user: obj[key].user,
            key: key,
          })
        }
        console.log('setting with ', profiles)
        commit('setLoadedBillingProfiles', profiles)
      })
  },
  createbillingprofile({ commit }, payload) {
    console.log('creating biling profile ', payload)
    const profile = {
      name: payload.name,
      locationtype: payload.locationtype,
      baserate: payload.baserate,
      sentshipmentfee: payload.sentshipmentfee,
      changeorderfee: payload.changeorderfee,
      platformfee: payload.platformfee,
      rentalfee: payload.rentalfee,
      volumerate: payload.volumerate,
      bagtrackrate: payload.bagtrackrate,
      packagerate: payload.packagerate,
      insurancerate: payload.insurancerate,
      timestamp: Date.now(),
      user: firebase.auth().currentUser.uid,
    }
    let key
    firebase.database().ref('BILLINGPROFILES').push(profile)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  updatebillingprofile({ commit }, payload) {
    let key = payload.key
    const client = {
      name: payload.name,
      locationtype: payload.locationtype,
      baserate: payload.baserate,
      sentshipmentfee: payload.sentshipmentfee,
      changeorderfee: payload.changeorderfee,
      platformfee: payload.platformfee,
      rentalfee: payload.rentalfee,
      volumerate: payload.volumerate,
      packagerate: payload.packagerate,
      bagtrackrate: payload.bagtrackrate,
      insurancerate: payload.insurancerate,
      timestamp: Date.now(),
      user: firebase.auth().currentUser.uid,
    }
    firebase.database().ref('BILLINGPROFILES').child(key).update(client)
  },
  createsmartsafeunit({ commit }, payload) {
    const ssunit = {
      crypto_idnum: payload.crypto_idnum,
      assigned: false,
      sitekey: '',
    }
    let key
    firebase.database().ref('UNITS').push(ssunit)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  removesmartsafeunit({ commit, state }, payload) {
    const key = payload
    commit('setLoading', true)
    firebase.database().ref('UNITS').child(key).remove()
      .then(() => {
        let actionrecord = {
          user: state.user,
          actions: 'delete',
          description: 'removed smartsafe',
          timestamp: Date.now(),
          meta: key
        }
        let date = moment().format('YYYY-MM-DD')
        firebase.database().ref('AUDITLOG').child(date).push(actionrecord)
          .catch((error) => {
            console.log(error)
            commit('setLoading', false)
          })
      })
      .catch((error) => {
        console.log(error)
        commit('setLoading', false)
      })
    commit('setLoading', false)
  },
  createUserGroup({ commit, getters }, payload) {
    const groupData = {
      name: payload
    }
    let key
    firebase.database().ref('GROUPS').push(groupData)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
    // Reach out to firebase and store it
  },
  removeUserGroup({ commit, state }, payload) {
    const key = payload.groupkey
    commit('setLoading', true)
    firebase.database().ref('GROUPS').child(key).remove()
      .then(() => {
        let actionrecord = {
          user: state.user,
          actions: 'delete',
          description: 'removed group',
          timestamp: Date.now(),
          meta: key
        }
        let date = moment().format('YYYY-MM-DD')
        firebase.database().ref('AUDITLOG').child(date).push(actionrecord)
          .catch((error) => {
            console.log(error)
            commit('setLoading', false)
          })
      })
      .catch((error) => {
        console.log(error)
        commit('setLoading', false)
      })
    commit('setLoading', false)
    // Reach out to firebase and store it
  },
  async validateShipmentContents({ commit }, payload) {
    // phase II shipment bag validation
    commit('setLoading', true)
    console.log('validate record ', payload)
    let dbdateref = payload.item.dbdateref
    let date = moment(payload.item.timestamp).format('YYYY-MM-DD')
    let safeid = payload.item.safeid
    let tracking_number = payload.item.tracking_number
    let selected = payload.selected
    let entrykey = payload.item.entrykey
    if (!selected || !safeid || !tracking_number || !entrykey) {
      console.log(' not enough info supplied to update vault record ', payload)
      commit('setLoading', false)

      return
    }
    let validatedRec = {
      validatedstatus: 'valultvalidated',
      validatedbags: selected.length,
      validatedtimestamp: Date.now(),
      validateddate: moment().format('YYYY-MM-DD HH:mm:ss'),
      validateduid: firebase.auth().currentUser.uid,
      validatedeamil: firebase.auth().currentUser.email,
      validatedselections: selected,
      validated: true
    }
    console.log('update with ', validatedRec)
    // mrmr valid contents
    firebase.database().ref('packages_checkedin_v2').child(dbdateref).child(tracking_number).child(entrykey).update(validatedRec)
    // if not a dupe
    if (!payload.item.duplicated) {
      firebase.database().ref('packagetrackmap').child(tracking_number).update(validatedRec)
    }
    // send packages to packages for the vault shipment

    // update checked in that its validated
    // update package map that its checked in, its validated so any can be looked up by tracking number
    // mrmr sat
    let actionrecord = {
      user: firebase.auth().currentUser.uid,
      actions: 'validate',
      description: 'validated package',
      timestamp: Date.now(),
      meta: tracking_number
    }
    firebase.database().ref('AUDITLOG').child(date).push(actionrecord)

    // mrmr ship
    // firebase.database().ref('POSTALSYSTEM').child(safeid).child('postalshipment').child(date).child(shipmentkey).update({ verifiedstatus: verifiedstatus })
    // firebase.database().ref('POSTALSYSTEM').child(safeid).child('postalshipment').child(date).child(shipmentkey).update({ verifiedcash: verifiedcash })
    // firebase.database().ref('POSTALSYSTEM').child(safeid).child('postalshipment').child(date).child(shipmentkey).update({ verifiedtimestamp: verifiedtimestamp })
    // firebase.database().ref('packagetracking').child(tracking_number).update({ verifiedstatus: verifiedstatus })
    // .catch((error) => {
    //   console.log(error)
    // })
    // firebase.database().ref('packagetracking').child(tracking_number).update({ verifiedcash: verifiedcash })
    // firebase.database().ref('packagetracking').child(tracking_number).update({ verifiedtimestamp: verifiedtimestamp })
    commit('setLoading', false)
  },
  addcommand({ commit }, payload) {
    //return
    let amt = payload
    let rec = {
      cmd: 'add',
      amt: amt
    }
    firebase.database().ref('CMD').push(rec)
  },
  async addalertsbatchcmd({ commit, dispatch }, payload) {
    let alertlist = payload

    // now add them to the deposit users in the db
    for (let entry of alertlist) {
      const alert = {
        crypto_idnum: entry.crypto_idnum,
        label: entry.label,
        event_type: entry.event_type,
        method: entry.method,
        destination: entry.destination
      }
      dispatch('createalert', alert)
    }
  },
  createalert({ commit }, payload) {
    console.log('add alert using ', payload)
    const alert = {
      crypto_idnum: payload.crypto_idnum,
      label: payload.label,
      event_type: payload.event_type,
      method: payload.method,
      destination: payload.destination
    }
    let key
    firebase.database().ref('ALERTS').child(payload.crypto_idnum).push(alert)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  updateAlert({ commit, getters }, payload) {
    const alert = {
      crypto_idnum: payload.crypto_idnum,
      label: payload.label,
      event_type: payload.event_type,
      method: payload.method,
      destination: payload.destination
    }
    firebase.database().ref('ALERTS').child(payload.crypto_idnum).child(payload.key).update(alert)
      .then(() => {
        // console.log('we updated alert ', payload.crypto_idnum)
      })
      .catch((error) => {
        console.log(error)
      })
    // Reach out to firebase and store it
  },
  removealert({ commit }, payload) {
    const key = payload.key
    const cryptoidnum = payload.crypto_idnum
    commit('setLoading', true)
    firebase.database().ref('ALERTS').child(cryptoidnum).child(key).remove()
      .catch((error) => {
        console.log(error)
        commit('setLoading', false)
      })
    commit('setLoading', false)
  },
  async listCloudCCFilesAsync({ commit }, payload) {
    commit('setDepositImages', []) // reset
    let imageUrls = []
    // convert to promise all!!!
    const storageRef = await firebase.storage().ref().child('slipimages').child(payload.sitekey).child(payload.trackingnumber)
    let listTask = await storageRef.listAll().then((results) => {
      console.log('storage list item ', results.items[0].name)
      let sorted = results.items.sort(function (a, b) { return a - b })
      let promises = results.items.map((imageItem) => {
        return imageItem.getDownloadURL()
      })
      Promise.all(promises).then(urls => {
        imageUrls = urls
        console.log('we have our list of urls ', imageUrls)
        commit('setDepositImages', imageUrls)
      })
    })
  },
  async getCCDailyURL({ commit }, payload) {
    commit('setDepositFiles', [])

    console.log('get 30 days of ', payload)
    let ccfiles = []
    let safeid = payload
    let MAX_DAYS = 90
    for (let i = 1; i < MAX_DAYS; i++) {
      try {
        let fileRec = {
          created: '',
          filename: '',
          fileURL: '',
          size: '',
          description: ''
        }
        let transdaydetails
        let fileUrls = []
        let day = moment(new Date()).subtract(i, 'day').format('YYYY-MM-DD')
        const storageRef = firebase.storage().ref().child('cashconnectfiles').child(safeid).child(day)
        let listTask = await storageRef.listAll().then((results) => {
          console.log('storage list item ', results.items[0].name)

          let filename = ''
          if (results.items[0].name) {
            filename = results.items[0].name
          }
          let fileref = firebase.storage().ref().child('cashconnectfiles').child(safeid).child(day).child(filename)
          fileref.getMetadata()
            .then((metadata) => {
              console.log('meta data ', metadata)
              fileRec.size = metadata.size
              fileRec.filename = filename
              fileRec.created = metadata.timeCreated
              if (metadata.size > 19) {
                fileRec.description = 'Full Data set'
              } else {
                fileRec.description = 'Empty Data set'
              }
              // Metadata now contains the metadata for 'images/forest.jpg'
            })
          let sorted = results.items.sort(function (a, b) { return a - b })
          let promises = results.items.map((fileItem) => {
            return fileItem.getDownloadURL()
          })
          Promise.all(promises).then(urls => {
            fileUrls = urls
            console.log('we have our list of urls ', fileUrls)
            fileRec.fileURL = fileUrls[0]
            ccfiles.push(fileRec)
          }).then(() => {
            // set all the files
            console.log('all file urls ', ccfiles)
            commit('setDepositFiles', ccfiles)
          })
        })
      } catch (err) {
        console.log(err)
      }
    }
  },
  async listCloudDepositImagesAsync({ commit }, payload) {
    commit('setDepositImages', []) // reset
    let imageUrls = []
    // convert to promise all!!!
    const storageRef = await firebase.storage().ref().child('slipimages').child(payload.sitekey).child(payload.trackingnumber)
    let listTask = await storageRef.listAll().then((results) => {
      console.log('storage list item ', results.items[0].name)
      let sorted = results.items.sort(function (a, b) { return a - b })
      let promises = results.items.map((imageItem) => {
        return imageItem.getDownloadURL()
      })
      Promise.all(promises).then(urls => {
        imageUrls = urls
        console.log('we have our list of urls ', imageUrls)
        commit('setDepositImages', imageUrls)
      })
    })
  },
  listCloudDepositImages({ commit }, payload) {
    commit('setDepositImages', []) // reset
    let imageUrls = []
    // convert to promise all!!!
    const storageRef = firebase.storage().ref().child('slipimages').child(payload.sitekey).child(payload.trackingnumber)
    let listTask = storageRef.listAll().then((results) => {
      console.log('storage list item ', results.items[0].name)
      let sorted = results.items.sort(function (a, b) { return a - b })
      console.log('sorted ', sorted)
      sorted.forEach((itemRef) => {
        // itemRef.forEach(entry => {
        //   console.log('name: ', entry.name)
        // })
        // convert to promise all!!!
        itemRef.getDownloadURL().then((url) => {
          console.log('url is ', url)
          imageUrls.push(url)
          // Insert url into an <img> tag to "download"
        }).then(() => {
          console.log('got all our urls inner', imageUrls)
          commit('setDepositImages', imageUrls) // reset
        })
        // All the items under listRef.
      })
      console.log('total num ', results.items.length)
    })
  },
  async uploadMetadata({ commit, dispatch }, payload) {
    console.log('passing image to upload')
    const storageRef = firebase.storage().ref().child('slipimages').child(payload.sitekey).child(payload.trackingnumber)
    // [START storage_upload_metadata]
    // Create file metadata including the content type
    let metadata = {
      contentType: payload.type,
    }
    // store it
    // Upload the file and metadata
    // we must upload it in this manner because of the nature of base64 images. Essentially cuts off the first 23 chars.
    let uploadTask = await storageRef.child(Date.now() + '.jpg').putString(payload.img, 'data_url').then(function (snapshot) {
      console.log('Uploaded a data_url string!')
      dispatch('listCloudDepositImagesAsync', payload)
    })
    // get the list of that node (promise all)
    let listTask = storageRef.listAll().then((results) => {
      results.items.forEach((itemRef) => {
        console.log('storage list item ', itemRef)
        itemRef.getDownloadURL().then((url) => {
          console.log('url is ', url)
          // Insert url into an <img> tag to "download"
        })
        // All the items under listRef.
      })
      console.log('total num ', results.items.length)
    })
    // get the links for them all

    // add them to the list

    // [END storage_upload_metadata]
  },
  async syncsafeuserbatch({ commit, dispatch }, payload) {
    let userlist = payload
    for (let entry of userlist) {
      let rec = {
        cmd: 'adddepuser',
        safeid: entry.safeid,
        username: entry.username,
        usertype: entry.usertype,
        userpin: entry.userpin
      }
      console.log('pushing user ', rec)
      await firebase.database().ref('CMD').push(rec)
    }
  },
  async addsafeuserbatchcmd({ commit, dispatch }, payload) {
    let userlist = payload
    for (let entry of userlist) {
      let rec = {
        cmd: 'adddepuser',
        safeid: entry.safeid,
        username: entry.username,
        usertype: entry.usertype,
        userpin: entry.userpin
      }
      await firebase.database().ref('CMD').push(rec)
    }
    // now add them to the deposit users in the db
    for (let entry of userlist) {
      const deposituser = {
        siteid: entry.siteid,
        username: entry.username,
        email: '-',
        usertype: entry.usertype,
        accesscode: entry.userpin
      }
      dispatch('createDeposituser', deposituser)
    }
  },
  sendopensafe({ commit }, payload) {
    let rec = {
      cmd: 'open',
      safeid: payload.safeid,
      uid: firebase.auth().currentUser.uid,
      email: firebase.auth().currentUser.email
    }
    console.log('open safe rec ', rec)
    let date = moment().format('YYYY-MM-DD')
    firebase.database().ref('AUDITLOG').child(date).push(rec)

    let sendOpenCommand = firebase.functions().httpsCallable('sendOpenCommand')
    sendOpenCommand(rec)
      .then(function (result) {
        console.log('we sent command, got back ', result)
      })
  },
  loadSafeFobs({ commit }, payload) {
    // load
    commit('setSafeFobs', [])
    let safeid = payload
    let keyfobs = []
    firebase.database().ref('Keyfobs').child(safeid).once('value')
      .then((data) => {
        let obj = data.val()
        for (let key in obj) {
          keyfobs.push({
            safeid: obj[key].safeid,
            keyfob: obj[key].keyfob,
            sitekey: obj[key].sitekey,
            uid: obj[key].uid,
            email: obj[key].email,
            timestamp: obj[key].timestamp,
            time: moment(obj[key].timestamp).format('YYYY-MM-DD HH:mm:ss')
          })
        }
        console.log('fobs', keyfobs)
        commit('setSafeFobs', keyfobs)
      })
  },

  async lookupUnifiedWalletDetails({ commit }, payload) {
    const endpoint = `${process.env.VUE_APP_API_URL}/canex-cscp-security/lookupwallet`

    const lookupData = {
      blockchain: payload.blockchain,
      isLivenet: Vue.prototype.$appProd,
      wallet: payload.wallet,
    }

    try {
      return axios.post(endpoint, lookupData, {
        headers: {
          'x-api-key': API_KEY,
        },
      })
    } catch (e) {
      console.log(e)

      return undefined
    }
  },
  sendresetrequest({ commit }, payload) {
    let rec = {
      cmd: 'resetrequest',
      email: payload.email,
      timestamp: Date.now()
    }
    console.log('add reset request ', rec)
    const endpoint = `https://canex.services/paythings-auth-adapter/resetpw`

    const reqData = {
      email: payload.email,
    }
    let API_KEY = '123456789'
    try {
      return axios.post(endpoint, reqData, {
        headers: {
          'x-api-key': API_KEY,
        },
      })
    } catch (e) {
      console.log(e)

      return undefined
    }
    // firebase.database().ref('AUDITLOG').child(date).push(rec)
    //firebase.database().ref('SecResetReq').child('reset').push(rec)

  },
  sendaddkeyfob({ commit }, payload) {
    let rec = {
      cmd: 'addkey',
      safeid: payload.safeid,
      keyfob: payload.keyfob,
      sitekey: payload.sitekey,
      username: payload.username,
      uid: firebase.auth().currentUser.uid,
      email: firebase.auth().currentUser.email,
      timestamp: Date.now()
    }
    console.log('add keyfob rec ', rec)
    let date = moment().format('YYYY-MM-DD')
    firebase.database().ref('AUDITLOG').child(date).push(rec)
    firebase.database().ref('Keyfobs').child(payload.safeid).push(rec)

    let sendAddKeyfob = firebase.functions().httpsCallable('sendAddKeyfob')
    sendAddKeyfob(rec)
      .then(function (result) {
        console.log('we sent command, got back ', result)
      })
  },
  addsafeusercmd({ commit }, payload) {
    let rec = {
      cmd: 'adddepuser',
      safeid: payload.safeid,
      username: payload.username,
      usertype: payload.usertype,
      userpin: payload.userpin
    }
    // console.log(rec)
    firebase.database().ref('CMD').push(rec)
  },
  sendtimezonecmd({ commit }, payload) {
    let rec = {
      cmd: 'setsafetimezone',
      safeid: payload.safeid,
      zone: payload.timezone
    }
    // console.log(rec)
    firebase.database().ref('CMD').push(rec)
  },
  sendsettimecmd({ commit }, payload) {
    let rec = {
      cmd: 'setsafetime',
      safeid: payload.safeid,
      time: payload.safetime,
    }
    // console.log(rec)
    firebase.database().ref('CMD').push(rec)
  },
  sendsafeprintercmd({ commit }, payload) {
    // false is use connected printer
    // true is use remote printer
    let rec = {
      cmd: 'setsafeprinter',
      safeid: payload.safeid,
      useremoteprinter: payload.printer,
    }
    // console.log(rec)
    firebase.database().ref('CMD').push(rec)
  },
  sendsafestatecmd({ commit }, payload) {
    let rec = {
      cmd: 'setsafestate',
      safeid: payload.safeid,
      state: payload.state,
    }
    // console.log(rec)
    firebase.database().ref('CMD').push(rec)
  },
  sendsafemodecmd({ commit }, payload) {
    let rec = {
      cmd: 'setsafemode',
      safeid: payload.safeid,
      Mode: payload.Mode,
    }
    // console.log(rec)
    firebase.database().ref('CMD').push(rec)
  },
  sendseteodcmd({ commit }, payload) {
    let rec = {
      cmd: 'seteod',
      safeid: payload.safeid,
      eodtime: payload.eodtime,
    }
    // console.log(rec)
    firebase.database().ref('CMD').push(rec)
  },
  sendrequpdatecmd({ commit }, payload) {
    let rec = {
      cmd: 'setsafeupdate',
      safeid: payload.safeid,
      url: payload.updateurl,
      username: payload.username,
      userpass: payload.userpass
    }
    // console.log(rec)
    firebase.database().ref('CMD').push(rec)
  },
  sendreqlogfilescmd({ commit }, payload) {
    let rec = {
      cmd: 'sendreqlogfilescmd',
      safeid: payload.safeid,
      productlogs: payload.productlogs,
      logfilepath: payload.logfilepath,
      destinationurl: payload.destinationurl,
      ftpuser: payload.ftpuser,
      ftppass: payload.ftppass
    }
    // console.log(rec)
    firebase.database().ref('CMD').push(rec)
  },
  sendsafepingcmd({ commit }, payload) {
    let rec = {
      cmd: 'ping',
      safeid: payload.safeid
    }
    console.log('ping rec ', rec)
    // firebase.database().ref('CMD').push(rec)
  },
  sendonboardcmd({ commit }, payload) {
    let data = {
      cmd: 'onboardsafe',
      customerId: payload.customerId,
      unitId: payload.unitId,
      printCopies: payload.printCopies,
      printEod: payload.printEod,
      eodTime: payload.eodTime, // hh:mm
      timezone: payload.timezone,
      depositTimeout: payload.depositTimeout,
      disabled: payload.disabled,
      safeid: payload.safeid
    }
    let rec = {
      cmd: 'onboardsafe',
      safeid: payload.safeid,
      onboard_data: data,
    }
    firebase.database().ref('CMD').push(rec)
  },
  sendsafeuserlistcmd({ commit }, payload) {
    if (!payload.userlist) {
      return
    }
    let rec = {
      cmd: 'setdepuserlist',
      safeid: payload.safeid,
      userlist: payload.userlist,
      function: 'set',
    }
    // console.log(rec)
    firebase.database().ref('CMD').push(rec)
  },
  simcit() {
    let rec = {
      cmd: 'cit'
    }
    firebase.database().ref('CMD').push(rec)
  },
  simsplit() {
    let rec = {
      cmd: 'split'
    }
    firebase.database().ref('CMD').push(rec)
  },
  simjam() {
    let rec = {
      cmd: 'jam'
    }
    firebase.database().ref('CMD').push(rec)
  },
  simreject() {
    let rec = {
      cmd: 'reject'
    }
    firebase.database().ref('CMD').push(rec)
  },
  simuserdep() {
    let rec = {
      cmd: 'userdep'
    }
    firebase.database().ref('CMD').push(rec)
  },
  simcashheld({ commit }, payload) {
    let rec = {
      cmd: 'cashheld'
    }
    firebase.database().ref('CMD').push(rec)
  },
  simmanualdep({ commit }, payload) {
    let rec = {
      cmd: 'manualdep',
      amt: payload
    }
    firebase.database().ref('CMD').push(rec)
  },
  async TestprocessDimeBankChangeOrder({ commit, dispatch }, payload) {
    console.log('process dimbank change order ', payload)
    let user = {
      bio: 'nothing',
      email: 'mitchell@paythings.com',
      group: 'Mitchelll',
      id: 'xSPKxuIirtY5hv4j3aYGOHiALsg2',
      level: 2000,
      status: 'admin'
    }
    let order = {
      changeorder: payload.changeorder,
      group: payload.group,
      sitekey: payload.sitekey,
      timestamp: Date.now(),
      filledtime: Date.now(),
      safeid: payload.safeid,
      siteid: payload.siteid,
      user: 'mitchell@Paythings.com'
    }

    // are they services by dime bank?
    // get that sites details
    // if its simulator its not real and tell them
    let dimebanksitesref = await firebase.database().ref('Institutions').child('-N6Z3nY4y8aUmcMh_AyC').once('value')
    let dimebanksites = dimebanksitesref.val()
    if (dimebanksites) {
      console.log('checking for we have a dimebank site', payload.sitekey)
      if (true) {
        console.log('we have a dimebank site')
        console.log('we would have posted it')



      

        let mailmessage = 'Dime Bank client site ' + order.siteid + ' has requested a change order'
        let detailmessage = ''
        let changeorder = payload.changeorder

        detailmessage +=  await dispatch('formatChangeMessage', changeorder);
        // formatChangeMessage(order)
        mailmessage += detailmessage
        // mrmr dimebank
        //firebase.database().ref('EXTERNALCHANGEORDERS').child('REQUESTED').child(payload.group).child(payload.sitekey).push(order)

        let send_dimebank_email_notification = firebase.functions().httpsCallable('send_dimebank_email_notification')
        // send confirmation email to user
        let amt = 0
        if (payload.changeorder && payload.changeorder.DepositAmount) {
          amt = numeral(payload.changeorder.DepositAmount).format('$0.00')
        }
        let useremail = firebase.auth().currentUser.email
        send_dimebank_email_notification({ message: 'Your change order is pending approval' + ' \n' + detailmessage + '\n\n', address: useremail })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })
        send_dimebank_email_notification({ message: mailmessage, address: 'mitchell@Paythings.com' })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })

        // send a confirmation email to the user
        // send_email_notification(mailmessage, 'RetailOperations@bridgenb.com')
        // send_dimebank_email_notification(mailmessage, 'mitchell@Paythings.com')
        // send_dimebank_email_notification(mailmessage, 'branchops@dime.com')
        // send_dimebank_email_notification(mailmessage, 'mortiz@ssarmored.com')
        // send_dimebank_email_notification(mailmessage, 'jameskelly@ssarmored.com')
        console.log('#### returning normally')
      } else {
        console.log('no dimebank site for order ')
      }
    }
  },

  async processDimeBankChangeOrder({ commit, dispatch }, payload) {
    console.log('process dimbank change order ', payload)
    let user = {
      bio: 'nothing',
      email: 'mitchell@paythings.com',
      group: 'Mitchelll',
      id: 'xSPKxuIirtY5hv4j3aYGOHiALsg2',
      level: 2000,
      status: 'admin'
    }
    let order = {
      changeorder: payload.changeorder,
      group: payload.group,
      sitekey: payload.sitekey,
      timestamp: Date.now(),
      filledtime: Date.now(),
      safeid: payload.safeid,
      siteid: payload.siteid,
      user: user
    }

    // are they services by dime bank?
    // get that sites details
    // if its simulator its not real and tell them
    let dimebanksitesref = await firebase.database().ref('Institutions').child('-N6Z3nY4y8aUmcMh_AyC').once('value')
    let dimebanksites = dimebanksitesref.val()
    if (dimebanksites) {
      console.log('checking for we have a dimebank site', payload.sitekey)
      if (dimebanksites.sitekeys.includes(payload.sitekey)) {
        console.log('we have a dimebank site')
        console.log('we would have posted it')

        let mailmessage = 'Dime Bank client site ' + order.siteid + ' has requested a change order'

        let detailmessage = ''
        let changeorder = payload.changeorder

        detailmessage +=  await dispatch('formatChangeMessage', changeorder);
        mailmessage += detailmessage

        // mrmr dimebank
        firebase.database().ref('EXTERNALCHANGEORDERS').child('REQUESTED').child(payload.group).child(payload.sitekey).push(order)

        let send_dimebank_email_notification = firebase.functions().httpsCallable('send_dimebank_email_notification')
        // send confirmation email to user
        let amt = 0
        if (payload.changeorder && payload.changeorder.DepositAmount) {
          amt = numeral(payload.changeorder.DepositAmount).format('$0.00')
        }
        let useremail = firebase.auth().currentUser.email
        send_dimebank_email_notification({ message: 'Your change order is pending approval' + ' \n ' + detailmessage, address: useremail })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })
        send_dimebank_email_notification({ message: mailmessage, address: 'mitchell@Paythings.com' })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })
        send_dimebank_email_notification({ message: mailmessage, address: 'RetailOperations@bridgenb.com' })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })
        send_dimebank_email_notification({ message: mailmessage, address: 'vaultservices@dime.com' })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })
        send_dimebank_email_notification({ message: mailmessage, address: 'mortiz@ssarmored.com' })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })
        send_dimebank_email_notification({ message: mailmessage, address: 'jameskelly@ssarmored.com' })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })
        // send a confirmation email to the user
        // send_email_notification(mailmessage, 'RetailOperations@bridgenb.com')
        // send_dimebank_email_notification(mailmessage, 'mitchell@Paythings.com')
        // send_dimebank_email_notification(mailmessage, 'branchops@dime.com')
        // send_dimebank_email_notification(mailmessage, 'mortiz@ssarmored.com')
        // send_dimebank_email_notification(mailmessage, 'jameskelly@ssarmored.com')
        console.log('#### returning normally')
      } else {
        console.log('no dimebank site for order ')
      }
    }
  },
  formatChangeMessage({commit},payload) {
    console.log('PAYLOAD PASSED TO ORDER FORMAT ', payload)
    let changeorder = payload
    let Ones = 0
    let Fives = 0
    let Tens = 0
    let Twenties = 0
    let Fifties = 0
    let Hundreds = 0
    let Pennies = 0
    let Nickels = 0
    let Dimes = 0
    let Quarters = 0
    let Total = 0
  
    if (changeorder.Notes1) {
      Ones = changeorder.Notes1
    }
    if (changeorder.Notes5) {
      Fives = changeorder.Notes5
    }
    if (changeorder.Notes10) {
      Tens = changeorder.Notes10
    }
    if (changeorder.Notes20) {
      Twenties = changeorder.Notes20 
    }
    if (changeorder.Notes50) {
      Fifties = changeorder.Notes50
    }
    if (changeorder.Notes100) {
      Hundreds = changeorder.Notes100
    }
    if (changeorder.Coin001 ) {
      Pennies = changeorder.Coin001      
    }
    if (changeorder.Coin005) {
      Nickels = changeorder.Coin005
    }
    if (changeorder.Coin010) {
      Dimes = changeorder.Coin010
    }
    if (changeorder.Coin025) {
      Quarters = changeorder.Coin025
    }
    if (changeorder.DepositAmount) {
      Total = changeorder.DepositAmount
    }

    let mailmessage = ''
    mailmessage += "\n\n" + "Ordered: "
    mailmessage += "\n" + "Ones: " + numeral(Ones).format('$0.00')
    mailmessage += "\n" + "Fives: " + numeral(Fives).format('$0.00')
    mailmessage += "\n" + "Tens: " + numeral(Tens).format('$0.00')
    mailmessage += "\n" + "Twenties: " + numeral(Twenties).format('$0.00')
    mailmessage += "\n" + "Fifties: " + numeral(Fifties).format('$0.00')
    mailmessage += "\n" + "Hundreds: " + numeral(Hundreds).format('$0.00')
    mailmessage += "\n\n" + "Pennies: " + numeral(Pennies).format('$0.00')
    mailmessage += "\n" + "Nickels: " + numeral(Nickels).format('$0.00')
    mailmessage += "\n" + "Dimes: " + numeral(Dimes).format('$0.00')
    mailmessage += "\n" + "Quarters: " + numeral(Quarters).format('$0.00')
    mailmessage += "\n\n\n" + "Total: " + numeral(Total).format('$0.00')
    return mailmessage
  },
  async processChaseAEGChangeOrder({ commit, dispatch }, payload) {
    console.log('process chase aeg change order ', payload)
    let user = {
      bio: 'nothing',
      email: 'mitchell@paythings.com',
      group: 'Mitchelll',
      id: 'xSPKxuIirtY5hv4j3aYGOHiALsg2',
      level: 2000,
      status: 'admin'
    }
    let order = {
      changeorder: payload.changeorder,
      group: payload.group,
      sitekey: payload.sitekey,
      timestamp: Date.now(),
      filledtime: Date.now(),
      safeid: payload.safeid,
      siteid: payload.siteid,
      user: user
    }

    // are they services by dime bank?
    // get that sites details
    // if its simulator its not real and tell them
    let chaseaegsitesref = await firebase.database().ref('Institutions').child('-O59dL-6JfUY9WdDfdHz').once('value')
    let chaseaegsites = chaseaegsitesref.val()
    if (chaseaegsites) {
      console.log('checking for we have a chase aeg site', payload.sitekey)
      if (chaseaegsites.sitekeys.includes(payload.sitekey)) {
        console.log('we have a chase aeg site')
        console.log('we would have posted it')
        let mailmessage = 'AEG client site ' + order.siteid + ' has requested a change order'
        // mrmr chaseaeg
        firebase.database().ref('EXTERNALCHANGEORDERS').child('REQUESTED').child(payload.group).child(payload.sitekey).push(order)

        let send_chaseaeg_email_notification = firebase.functions().httpsCallable('sendChangeOrderApproval')
        // send confirmation email to user
        let amt = 0
        if (payload.changeorder && payload.changeorder.DepositAmount) {
          amt = numeral(payload.changeorder.DepositAmount).format('$0.00')
        }
        let useremail = firebase.auth().currentUser.email
        // we're basically using the dimebank email function with a new message
        send_chaseaeg_email_notification({ message: 'Your change order is pending approval' + ' \nOrder: ' + amt, email: useremail })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })
        send_chaseaeg_email_notification({ message: mailmessage, email: 'mitchell@Paythings.com' })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })
        send_chaseaeg_email_notification({ message: mailmessage, email: 'treasury@aegvision.com' })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })
        send_chaseaeg_email_notification({ message: mailmessage, email: 'mbui@aegvision.com' })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })
        const AEGEMAILAPPROVAL = 'mitchell@paythings.com'
        send_chaseaeg_email_notification({ message: mailmessage, email: AEGEMAILAPPROVAL })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })
        send_chaseaeg_email_notification({ message: mailmessage, address: 'mortiz@ssarmored.com' })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })
        send_chaseaeg_email_notification({ message: mailmessage, address: 'jameskelly@ssarmored.com' })
          .then(function (result) {
            console.log('we sent db note result ', result)
          })
        // send a confirmation email to the user
        // send_email_notification(mailmessage, 'RetailOperations@bridgenb.com')
        // send_dimebank_email_notification(mailmessage, 'mitchell@Paythings.com')
        // send_dimebank_email_notification(mailmessage, 'branchops@dime.com')
        // send_dimebank_email_notification(mailmessage, 'mortiz@ssarmored.com')
        // send_dimebank_email_notification(mailmessage, 'jameskelly@ssarmored.com')
        console.log('#### returning normally')
      } else {
        console.log('no chase aeg site for order ')
      }
    }
  },
  async isDimebankSite({ commit, dispatch }, payload) {
    let sitekey = payload.sitekey
    console.log('data is ', sitekey)
    let isDimebankSite = false
    commit('setDimebankSite', isDimebankSite)
    let dimebanksitesref = await firebase.database().ref('Institutions').child('-N6Z3nY4y8aUmcMh_AyC').once('value')
    let dimebanksites = dimebanksitesref.val()
    if (dimebanksites) {
      if (dimebanksites.sitekeys.includes(sitekey)) {
        console.log('we have a dimebank site')
        let cutoffTime = moment('10:00:00', 'HHmmss')
        isDimebankSite = true
      }
    }
    console.log(' dimebank site?  ', isDimebankSite)
    commit('setDimebankSite', isDimebankSite)
  },
  async isChaseAEGSite({ commit, dispatch }, payload) {
    let sitekey = payload.sitekey
    console.log('data is ', sitekey)
    let isChaseAEGSite = false
    commit('setChaseSite', isChaseAEGSite)
    const CHASEAEGFIKEY = '-O59dL-6JfUY9WdDfdHz'
    let chaseaegsitesref = await firebase.database().ref('Institutions').child(CHASEAEGFIKEY).once('value')
    let chaseaegsites = chaseaegsitesref.val()
    console.log('chase aeg sites ', chaseaegsites, ' our site key  ', sitekey)
    if (chaseaegsites) {
      if (chaseaegsites.sitekeys.includes(sitekey)) {
        console.log('we have a chase bank site')
        isChaseAEGSite = true
      }
    }
    console.log('chase bank aeg site', isChaseAEGSite)
    commit('setChaseAEGSite', isChaseAEGSite)
  },
  loadreleases({ commit }) {
    const rels = []
    firebase.database().ref('RELEASES').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          rels.push({
            name: obj[key].name,
            path: obj[key].path,
            key: key
          })
        }
        commit('setLoadedReleases', rels)
      })
      .catch(
        (error) => {
          console.log(error)
        }
      )
  },
  createrelease({ commit }, payload) {
    const ssunit = {
      name: payload.name,
      path: payload.path,
      sitekey: '',
    }
    let key
    firebase.database().ref('RELEASES').push(ssunit)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  updaterelease({ commit, getters }, payload) {
    const rel = {
      name: payload.name,
      path: payload.path,
      key: payload.key
    }

    firebase.database().ref('RELEASES').child(payload.key).update(rel)
      .then(() => {
        // console.log('we updated site ', payload.key)
      })
      .catch((error) => {
        console.log(error)
      })
    // Reach out to firebase and store it
  },
  removerelease({ commit }, payload) {
    const key = payload.key
    commit('setLoading', true)
    firebase.database().ref('RELEASES').child(key).remove()
      .catch((error) => {
        console.log(error)
        commit('setLoading', false)
      })
    commit('setLoading', false)
  },
  createkcSite({ commit }, payload) {
    // CASHCONNECT_DIRECTOR
    console.log('creating kapchargeclient ', payload)
    const sitedetails = {
      idnum: payload.idnum,
      sitekey: payload.sitekey,
      safeid: payload.safeid,
      ccid: payload.ccid,
      override: payload.override,
      timestamp: Date.now(),
    }
    let key
    firebase.database().ref('KAPCHARGE_DIRECTOR').child('KC_EnabledSites').push(sitedetails)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  updatekcSite({ commit }, payload) {
    console.log('creating kapcharge client ', payload)
    const sitedetails = {
      idnum: payload.idnum,
      sitekey: payload.sitekey,
      ccid: payload.ccid,
      key: payload.key,
      safeid: payload.safeid,
      override: payload.override,
      timestamp: Date.now(),
    }
    let key
    firebase.database().ref('KAPCHARGE_DIRECTOR').child('KC_EnabledSites').child(payload.key).update(sitedetails)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  removekcSite({ commit }, payload) {
    // KAPCHARGE_DIRECTOR
    firebase.database().ref('KAPCHARGE_DIRECTOR').child('KC_EnabledSites').child(payload.key).remove()
  },
  async loadkcSitesProm({ commit }, payload) {
    const clients = []
    return firebase.database().ref('KAPCHARGE_DIRECTOR').child('KC_EnabledSites').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          clients.push({
            idnum: obj[key].idnum,
            sitekey: obj[key].sitekey,
            ccid: obj[key].ccid,
            safeid: obj[key].safeid,
            override: obj[key].override,
            timestamp: obj[key].timestamp,
            key: key,
          })
        }
        console.log('kc sites setting ', clients)
        commit('setKapchargeSites', clients)
      })
  },
  loadkcSites({ commit }, payload) {
    // KAPCHARGE_DIRECTOR
    console.log('loading cash connect clients')
    const clients = []
    firebase.database().ref('KAPCHARGE_DIRECTOR').child('KC_EnabledSites').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          clients.push({
            idnum: obj[key].idnum,
            sitekey: obj[key].sitekey,
            ccid: obj[key].ccid,
            safeid: obj[key].safeid,
            override: obj[key].override,
            timestamp: obj[key].timestamp,
            key: key,
          })
        }
        console.log('kc sites setting ', clients)
        commit('setKapchargeSites', clients)
      })
  },
  loadkccit({ commit }, payload) {
    let safes = payload.safelist
    let num_events = payload.num_events
    console.log('get kc cit from safes ', safes, num_events)
    let citevents = []
    let PromArr = []
    if (!safes) {
      return
    }
    for (let i = 0; i < safes.length; i++) {
      let safeid = safes[i]
      let prom = firebase.database().ref('CITtesting').child('SAFEANDSOUND').child(safeid).limitToLast(num_events).once('value')
        .then((data) => {
          let notedata = []
          const obj = data.val()
          if (obj) {
            console.log('groupcitobj ', Object.values(obj))
            let dataset = Object.values(obj)
            // if we have something to do lets format us up a nice record so the complexity isnt in the view
            // get that site label
            // loop thru data set
            dataset.forEach(entry => {
              let billcount = 0
              let total_amount = 0

              if (entry.values) {
                entry.values.forEach(item => {
                  billcount += item.count
                  total_amount += item.denom * item.count
                })
              }
              // empty ones are not meaningful
              if (total_amount > 0) {
                citevents.push({
                  safeid: safeid,
                  day: moment(entry.TS).format('ddd YY-MM-DD HH:mm'),
                  notecount: billcount,
                  timestamp: entry.TS,
                  total: total_amount,
                  notes: entry.v
                })
              }
            })

            // console.log(' data for this group is ', graphdata)
            // groupeod.push(graphdata)
            // key is the date
            // value is an array of note in events for that specific day
          }
          return notedata
        })
        .catch((error) => {
          let nodata = []
          console.log(error)
          return nodata
        })
      // this code is actually executed before the above. I know its weird.
      PromArr.push(prom)
    }
    Promise.all(PromArr).then(function (values) {
      console.log('kc cit values ', citevents)
      commit('setCITGroupValues', citevents)
      commit('setLoading', false)
    })
  },
  loadkceod({ commit }, payload) {
    let startdate = moment(payload.startdate, 'YYYY-MM-DD')
    let enddate = moment(payload.enddate, 'YYYY-MM-DD')
    let safelist = payload.safelist
    let span = enddate.diff(startdate, 'days')
    let datesarr = []

    // add the first date
    datesarr.push(payload.startdate)
    // check to see if we add more and how many
    if (span > 0) {
      for (let i = 0; i < span; i++) {
        datesarr.push(moment(startdate).add((1 + i), 'day').format('YYYY-MM-DD'))
      }
    }
    console.log('get eods from ', safelist, startdate, enddate)
    let PromArr = []
    let groupeod = []
    for (let calday of datesarr) {
      for (let safeid of safelist) {
        // get data for this safe unit id num from firebase
        // let today = moment(new Date()).format('DD-MM-YYYY')
        let safeidnum = safeid
        console.log('check safe eod ', safeidnum, calday)
        let prom = firebase.database().ref('e2c').child('EODRECS').child(calday).child(safeidnum).once('value')
          .then((data) => {
            let notedata = []
            const obj = data.val()
            if (obj) {
              // if we have something to do lets format us up a nice record so the complexity isnt in the view
              // get that site label
              let siteidnum = ''
              groupeod.push({
                siteid: siteidnum,
                safeid: safeidnum,
                day: calday,
                ones: obj.ones ?? 0,
                fives: obj.fives ?? 0,
                tens: obj.tens ?? 0,
                twenties: obj.twenties ?? 0,
                fifties: obj.fifties ?? 0,
                hundreds: obj.hundreds ?? 0,
                validated: numeral(obj.sumvalidated).format('0.00'),
                sumdrops: numeral(obj.sumdrops).format('0.00'),
                sum: obj.sum ?? 0
              })
              // console.log(' data for this group is ', graphdata)
              // groupeod.push(graphdata)
              // key is the date
              // value is an array of note in events for that specific day
            }
            return notedata
          })
          .catch((error) => {
            let nodata = []
            console.log(error)
            return nodata
          })
        // this code is actually executed before the above. I know its weird.
        PromArr.push(prom)
      }
    }
    Promise.all(PromArr).then(function (values) {
      console.log('setting eods ', groupeod)
      commit('setCashinGroupValues', groupeod)
      commit('setLoading', false)
    })
  },
  loadssSites({ commit }, payload) {
    // KAPCHARGE_DIRECTOR
    console.log('loading ss clients')
    const clients = []
    firebase.database().ref('SAFEANDSOUND_DIRECTOR').child('SS_EnabledSites').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          clients.push({
            idnum: obj[key].idnum,
            sitekey: obj[key].sitekey,
            ccid: obj[key].ccid,
            safeid: obj[key].safeid,
            override: obj[key].override,
            timestamp: obj[key].timestamp,
            key: key,
          })
        }
        console.log('ss sites setting ', clients)
        commit('setSafeandSoundSites', clients)
      })
  },
  loadNamsysTransaction ({commit}, payload) {
    let transactionID = payload
    commit('setLoading', true)

    commit('setNamsysTransactionDetail', '')

    firebase.database().ref('NAMSYS_DIRECTOR').child('NAMSYS_TRANSACTIONS').child(transactionID).once('value')
    .then((data) => {
      const obj = data.val()
      commit('setNamsysTransactionDetail', obj)
    })
    commit('setLoading', false)
  },
  loadNamsysUnitStatus ({commit}, payload) {
    // takes in an array of safeids
    // get their ping and info 
  },
  loadNamsysDailyFeed({ commit }, payload) {
    let rundate = payload

    //.child(runid).child(data.feedid).push(data)
    firebase.database().ref('NAMSYS_DIRECTOR').child('DATA_FEED_RUN').child(rundate).once('value')
      .then((data) => {
        const obj = data.val()
        console.log('data feed ', obj)
        let feedrecs = []
        let feedData = {
          numruns: 0,
          runtimes: [],
          feedrecs: [],
        }
        if (obj) {
          let runtimes = []
          runtimes = Object.keys(obj)
          feedData.numruns = runtimes.length
          for (let run of runtimes) {
            let entryids = Object.keys(obj[run])
            feedData.runtimes.push(run)
            console.log('we have ', entryids, ' for run ', run)
            for (let feedid of entryids) {
              let entryrecs = []
              entryrecs = Object.values(obj[run][feedid])
              console.log(' entry recs ', feedid, ' ', entryrecs)
              for (let entry of entryrecs) {
                feedData.feedrecs.push(entry)
              }
            }
          }
        }
        commit('setFeedData', feedData)

      })
  },
  async loadv5publishedSequence({commit}, payload) {

    const cclients = []
    await firebase.database().ref('CASHCONNECT_DIRECTOR').child('CC_EnabledSites').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          cclients.push({
            idnum: obj[key].idnum,
            sitekey: obj[key].sitekey,
            ccid: obj[key].ccid,
            safeid: obj[key].safeid,
            override: obj[key].override,
            timestamp: obj[key].timestamp,
            key: key,
          })
        }
        console.log('cc sites setting ', cclients)
      })
    let ccclient_seqdata = []  
    let promArr = []
    for (let client of cclients) {
      console.log('get this seq data ', client)
      let prom = firebase.database().ref('CASHCONNECT_V5_DIRECTOR').child('FEED_SEQUENCE_PUBLISH_V5').child('SEQSTATUS').child(client.safeid).limitToLast(1).once('value')
      .then((data) => {
        if (data) {
          if (data.val()) {
            let timestamp = 0
            let seqNum = 0
            let isPublished = false
            let sequence = -1
            let sd = data.val()
            if (sd) {
              sequence = Object.keys(sd)[0]
              isPublished = Object.values(sd)[0].isPublished
              timestamp = Object.values(sd)[0].timestamp
            }
            ccclient_seqdata.push({
              siteid: client.idnum,
              override: client.override,
              ccid: client.ccid,
              sitekey: client.sitekey,
              safeid: client.safeid,
              isPublished: isPublished,
              sequence: sequence,
              timestamp : timestamp,
              hrtimestamp : moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
            })
          }
        }
      })
      promArr.push(prom)
    }
    Promise.all(promArr).then(function (values) {
      console.log('#####  all seq recs published ', ccclient_seqdata)
      commit('setSeqDataPublished', ccclient_seqdata)
    })
  },
  async updatev5publishedSequence ({commit}, payload) {
    let safeid = payload.safeid
    let seqidValue = parseInt(payload.sequence)
    let seqDate = payload.key

    if (Number.isNaN(seqidValue)) {
      console.log('we can only write seq values as numbers! ')
      return
    }
    console.log('seq update passed ', payload, seqDate, seqidValue,safeid)

    if (!safeid || !seqidValue) {
      return
    }


    firebase.database().ref('CASHCONNECT_V5_DIRECTOR').child('FEED_SEQUENCE_V5')
      .child(safeid).child(seqDate).update({sequence: seqidValue})
      .then((data) => {
        console.log('updated ', safeid, seqDate, seqidValue)
      })
  },
  loadV5DailyFeed({ commit }, payload) {
    let rundate = payload

    //.child(runid).child(data.feedid).push(data)
    firebase.database().ref('CASHCONNECT_V5_DIRECTOR').child('DATA_FEED_RUN').child(rundate).once('value')
      .then((data) => {
        const obj = data.val()
        console.log('data feed ', obj)
        let feedrecs = []
        let feedData = {
          numruns: 0,
          runtimes: [],
          feedrecs: [],
        }
        if (obj) {
          let runtimes = []
          runtimes = Object.keys(obj)
          feedData.numruns = runtimes.length
          for (let run of runtimes) {
            let entryids = Object.keys(obj[run])
            feedData.runtimes.push(run)
            console.log('we have ', entryids, ' for run ', run)
            for (let feedid of entryids) {
              let entryrecs = []
              entryrecs = Object.values(obj[run][feedid])
              console.log(' entry recs ', feedid, ' ', entryrecs)
              for (let entry of entryrecs) {
                feedData.feedrecs.push(entry)
              }
            }
          }
        }
        commit('setFeedData', feedData)

      })
  },
  async loadV5SequenceData({ commit, dispatch }) {

    // get the last 1 
    // get the list
    const cclients = []
    await firebase.database().ref('CASHCONNECT_DIRECTOR').child('CC_EnabledSites').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          cclients.push({
            idnum: obj[key].idnum,
            sitekey: obj[key].sitekey,
            ccid: obj[key].ccid,
            safeid: obj[key].safeid,
            override: obj[key].override,
            timestamp: obj[key].timestamp,
            key: key,
          })
        }
        console.log('cc sites setting ', cclients)
      })

    let estateSeqRecs = []
    let promArr = []
    cclients.forEach(site => {
      let prom
      prom = firebase.database().ref('CASHCONNECT_V5_DIRECTOR').child('FEED_SEQUENCE_V5')
      .child(site.safeid).limitToLast(1).once('value')
        .then((data) => {
          const obj = data.val()
          const keyval = data.key
          let seqrecs = []
          if (obj) {
            let sd = Object.values(obj)?.[0]
            estateSeqRecs.push({
              key: sd?.date, // we use a date as the object index here
              safeid: sd?.safeid,
              sequence: sd?.sequence,
              idnum: site.idnum,
              ccid: site.ccid,
              override: site.override,
              sitekey: site.sitekey
            })
          } else {
            console.log(' no sequence data found ')
          }
        })
        promArr.push(prom)
    })
    Promise.all(promArr).then(function (values) {
      console.log('#####  all seq recs ', estateSeqRecs)
      commit('setSeqFeedData', estateSeqRecs)
    })

  },
  loadKCDailyFeed({ commit }, payload) {
    let rundate = payload

    //.child(runid).child(data.feedid).push(data)
    firebase.database().ref('KAPCHARGE_DIRECTOR').child('DATA_FEED_RUN').child(rundate).once('value')
      .then((data) => {
        const obj = data.val()
        console.log('data feed ', obj)
        let feedrecs = []
        let feedData = {
          numruns: 0,
          runtimes: [],
          feedrecs: [],
        }
        if (obj) {
          let runtimes = []
          runtimes = Object.keys(obj)
          feedData.numruns = runtimes.length
          for (let run of runtimes) {
            let entryids = Object.keys(obj[run])
            feedData.runtimes.push(run)
            console.log('we have ', entryids, ' for run ', run)
            for (let feedid of entryids) {
              let entryrecs = []
              entryrecs = Object.values(obj[run][feedid])
              console.log(' entry recs ', feedid, ' ', entryrecs)
              for (let entry of entryrecs) {
                feedData.feedrecs.push(entry)
              }
            }
          }
        }
        commit('setFeedData', feedData)

      })
  },
  loadSSDailyFeed({ commit }, payload) {
    let rundate = payload

    //.child(runid).child(data.feedid).push(data)
    firebase.database().ref('SAFEANDSOUND_DIRECTOR').child('DATA_FEED_RUN').child(rundate).once('value')
      .then((data) => {
        const obj = data.val()
        console.log('data feed ', obj)
        let feedrecs = []
        let feedData = {
          numruns: 0,
          runtimes: [],
          feedrecs: [],
        }
        if (obj) {
          let runtimes = []
          runtimes = Object.keys(obj)
          feedData.numruns = runtimes.length
          for (let run of runtimes) {
            let entryids = Object.keys(obj[run])
            feedData.runtimes.push(run)
            console.log('we have ', entryids, ' for run ', run)
            for (let feedid of entryids) {
              let entryrecs = []
              entryrecs = Object.values(obj[run][feedid])
              console.log(' entry recs ', feedid, ' ', entryrecs)
              for (let entry of entryrecs) {
                feedData.feedrecs.push(entry)
              }
            }
          }
        }
        commit('setSSFeedData', feedData)

      })
  },
  createssSite({ commit }, payload) {
    // CASHCONNECT_DIRECTOR
    console.log('creating ss client ', payload)
    const sitedetails = {
      idnum: payload.idnum,
      sitekey: payload.sitekey,
      safeid: payload.safeid,
      ccid: payload.ccid,
      override: payload.override,
      timestamp: Date.now(),
    }
    let key
    firebase.database().ref('SAFEANDSOUND_DIRECTOR').child('SS_EnabledSites').push(sitedetails)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  updatessSite({ commit }, payload) {
    console.log('creating SS client ', payload)
    const sitedetails = {
      idnum: payload.idnum,
      sitekey: payload.sitekey,
      ccid: payload.ccid,
      key: payload.key,
      safeid: payload.safeid,
      override: payload.override,
      timestamp: Date.now(),
    }
    let key
    firebase.database().ref('SAFEANDSOUND_DIRECTOR').child('SS_EnabledSites').child(payload.key).update(sitedetails)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  removessSite({ commit }, payload) {
    // KAPCHARGE_DIRECTOR
    firebase.database().ref('SAFEANDSOUND_DIRECTOR').child('SS_EnabledSites').child(payload.key).remove()
  },

  // get gemini predictions

  async loadFISiteList({ commit, dispatch }, payload) {
    //loadmachinelearning
    let FIEODs = []
    let FICITs = []
    let FIKey = payload

    // let UserFiKey = ''
    // if (state.user?.institution?.key) {
    //   UserFiKey = state.user?.institution?.key
    // }
    // let FIKey = UserFiKey
    // if (!FIKey) {
    //   return
    // }
    const userinstitutions = []
    let sitekeys = []
    let finame = ''
    let firef = await firebase.database().ref('Institutions').child(FIKey).once('value')
    let fidata = firef.val()
    if (fidata) {
      finame = fidata.name
      sitekeys = fidata.sitekeys
    }
    // get the safe assigned to these site keys
    // mrmr fi
    let sitenames = []
    let PromArr = []
    for (let key of sitekeys) {
      let prom = firebase.database().ref('SITES').child(key).once('value')
        .then((data) => {
          return data.val()
        })
      PromArr.push(prom)
    }
    await Promise.all(PromArr).then(function (values) {
      sitenames = values.map(entry => entry.idnum)
      // we have all our site names
    })
    console.log('getting site profiles now')
    let siteprofiles = []
    // get all our site profiles
    let PromArrProfiles = []
    for (let sitename of sitenames) {
      let prom = firebase.database().ref('SITEPROFILES').child(sitename).once('value')
        .then((data) => {
          return data.val()
        })
        .catch((err) => {
          console.log(sitename, err)
        })
      PromArrProfiles.push(prom)
    }
    await Promise.all(PromArrProfiles).then(function (values) {
      // might have a profile but remove the safe present
      // check for this
      values.forEach(entry => {
        if (entry.siteunitsprofile && entry.siteunitsprofile[0].crypto_idnum) {
          siteprofiles.push({
            sitename: entry.idnum,
            group: entry.group,
            sitekey: entry.sitekey,
            safeid: entry.siteunitsprofile[0].crypto_idnum,
          })
        }
      })
      console.log('we have our site propfiles here ', siteprofiles)
      // we have all our site names
    })

    console.log('using our site propfiles here ', siteprofiles)

    console.log('ML results ', siteprofiles)

    commit('setFISiteList', siteprofiles)

  },
  async loadNamsysSitesProm({ commit }, payload) {
    const clients = []
    return firebase.database().ref('NAMSYS_DIRECTOR').child('NS_EnabledSites').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          clients.push({
            idnum: obj[key].idnum,
            sitekey: obj[key].sitekey,
            nssecret: obj[key].nssecret,
            ccid: obj[key].ccid,  // our namesys id
            accessKeyId: obj[key].accessKeyId,
            safeid: obj[key].safeid,
            override: obj[key].override,
            timestamp: obj[key].timestamp,
            key: key,
          })
        }
        console.log('ns prom sites setting ', clients)
        commit('setNamsysSites', clients)
      })
  },
  loadNamsysSites({ commit }, payload) {
    // KAPCHARGE_DIRECTOR
    console.log('loading namsys clients')
    const clients = []
    firebase.database().ref('NAMSYS_DIRECTOR').child('NS_EnabledSites').once('value')
      .then((data) => {
        const obj = data.val()
        console.log('ns sites from db ', obj)
        for (let key in obj) {
          clients.push({
            idnum: obj[key].idnum,
            sitekey: obj[key].sitekey,
            nssecret: obj[key].nssecret,
            accessKeyId: obj[key].accessKeyId,
            ccid: obj[key].ccid,  // our namesys id
            safeid: obj[key].safeid,
            override: obj[key].override,
            timestamp: obj[key].timestamp,
            key: key,
          })
        }
        console.log('namsys sites setting ', clients)
        commit('setNamsysSites', clients)
      })
  },
  createNamsysSite({ commit }, payload) {
    // NAMSYS_DIRECTOR
    console.log('creating ns site ', payload)
    if (!payload.idnum || !payload.sitekey || !payload.safeid || !payload.ccid || !payload.nssecret|| !payload.accessKeyId) {
      console.log('incomplete data sent', payload)
      return
    }
    const sitedetails = {
      idnum: payload.idnum,
      sitekey: payload.sitekey,
      safeid: payload.safeid,
      nssecret: payload.nssecret,
      ccid: payload.ccid,
      override: payload.override,
      accessKeyId: payload.accessKeyId,
      timestamp: Date.now(),
    }
    let key
    console.log('we would set ', sitedetails)
    firebase.database().ref('NAMSYS_DIRECTOR').child('NS_EnabledSites').push(sitedetails)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  updateNamsysSite({ commit }, payload) {
    console.log('creating NS client ', payload)
    const sitedetails = {
      idnum: payload.idnum,
      sitekey: payload.sitekey,
      ccid: payload.ccid,
      nssecret: payload.nssecret,
      key: payload.key,
      safeid: payload.safeid,
      override: payload.override,
      timestamp: Date.now(),
    }
    let key
    firebase.database().ref('NAMSYS_DIRECTOR').child('NS_EnabledSites').child(payload.key).update(sitedetails)
      .then((data) => {
        key = data.key
        return key
      })
      .catch((error) => {
        console.log(error)
      })
  },
  removeNamsysSite({ commit }, payload) {
    // KAPCHARGE_DIRECTOR
    firebase.database().ref('NAMSYS_DIRECTOR').child('NS_EnabledSites').child(payload.key).remove()
  },

  async loadAIAnalysis({ commit }, payload) {
    let aidata = {
    }
    let safeid = ''
    safeid = payload
    console.log('getting data for ', payload, safeid)
    firebase.database().ref('AI_SUMMARY').child(safeid).once('value')
      .then((data) => {
        console.log('data is ', data.val())
        const obj = data.val()
        if (obj) {
          aidata = obj
        }
        console.log('adding AI data ', payload, aidata)
        commit('setFISiteAnalysis', aidata)
      })
      .catch(
        (error) => {
          console.log(error)
        }
      )
    commit('setFISiteAnalysis', aidata)

  },
  loadVaultML({ commit }) {
    commit('setVaultAIData', [])

    console.log('getting data for Miami')
    firebase.database().ref('ChangeVault').child('machinelearning').child('MiamiCIB').once('value')
      .then((data) => {
        console.log('data is ', data.val())
        const obj = data.val()
        let aidata = []
        if (obj) {
          console.log('ai data is ', obj)
          let aiarr = []
          aiarr = Object.values(obj)
          for (let item of aiarr) {
            if (item.prediction && item.date && item.total) {
              aidata.push(item)
            }
          }
          console.log('setting ai vault data ', aidata)
          commit('setVaultAIData', aidata)
        }
      })
      .catch(
        (error) => {
          console.log(error)
        }
      )

  },
  loadVaultAI({ commit }) {
    console.log('getting data for Miami')
    firebase.database().ref("AI_VAULT_SUMMARY").child('Miami').once('value')
      .then((data) => {
        console.log('data AI CONTENXT is ', data.val())
        const obj = data.val()
        if (obj) {
          console.log('ai data is ', obj)
          let aiarr = []
          console.log('setting ai vault data ', obj)
          commit('setVaultAIContext', obj)
        }
      })
      .catch(
        (error) => {
          console.log(error)
        }
      )

  }
}
